(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2395],{

/***/ 38047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13193);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_meta_tags__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81372);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14141);
/* harmony import */ var config_constants_meta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31574);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4449);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  /* @media screen and (max-width: 1280px) {\n    display: none;\n  } */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 212px;\n  @media screen and (max-width: 1000px){\n    width: 120px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 190px;\n  @media screen and (max-width: 1000px){\n    width: 120px;\n  }\n  @media screen and (max-width: 600px){\n    width: 100px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: green;\n    width:100%;\n    height: auto;\n    display:flex;\n    justify-content:center;\n    align-items:center;\n    flex-direction: column;\n    overflow: hidden;\n    position: relative;\n    /* margin-top: ",
        "px; */\n    background-color: ",
        ";\n    &::before{\n      content: '';\n      position: absolute;\n      width: 28px;\n      height: 470px;\n      left: -14px;\n      top: 1226px;\n      background: #F9A138;\n      border-radius: 56px;\n      @media screen and (max-width: 1000px){\n        display: none;\n      }\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: -35px;\n  top: 21px;\n  @media screen and (max-width: 1000px){\n    left: -72px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: -28px;\n  top: 58px;\n  @media screen and (max-width: 1000px){\n    right: -72px;\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





// import { useLocation } from 'react-router'




var PageMeta = function() {
    var ref = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(), t = ref.t, locale = ref.currentLanguage.locale;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var pageMeta = (0,config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .getCustomMeta */ .S)(pathname, t, locale) || {};
    var ref1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, config_constants_meta__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_META */ .k, pageMeta), title = ref1.title, description = ref1.description, image = ref1.image;
    var pageTitle = title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_meta_tags__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                property: "og:image",
                content: image
            })
        ]
    });
};
var PageFullWidth = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageMeta, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ColImageLeft, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapImg, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgIconLeft, {
                                src: "/images/ccqFundgo/bg_left.png",
                                alt: "background"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ColImageRight, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapImg, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgIconRight, {
                                src: "/images/ccqFundgo/bg_right.png",
                                alt: "background"
                            })
                        })
                    })
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageFullWidth);
var Row = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8774da8a-0"
})(_templateObject());
var WrapImg = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8774da8a-1"
})(_templateObject1());
var ImgIconLeft = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-8774da8a-2"
})(_templateObject2());
var ImgIconRight = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-8774da8a-3"
})(_templateObject3());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8774da8a-4"
})(_templateObject4(), _pancakeswap_uikit_src_widgets_Menu_config__WEBPACK_IMPORTED_MODULE_10__/* .MENU_HEIGHT */ .d0, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var ColImageLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8774da8a-5"
})(_templateObject5());
var ColImageRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8774da8a-6"
})(_templateObject6());


/***/ }),

/***/ 88175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UseActiveCCQ": function() { return /* binding */ UseActiveCCQ; },
/* harmony export */   "ccqSupport": function() { return /* binding */ ccqSupport; },
/* harmony export */   "getPoolProposalConfig": function() { return /* binding */ getPoolProposalConfig; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var logged = false;
var getPoolProposalConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(chainId) {
        var error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        __webpack_require__(79419)("./".concat(chainId, ".ts"))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().default.filter(function(f) {
                            return f.id !== null;
                        })
                    ];
                case 2:
                    error = _state.sent();
                    if (!logged) {
                        console.error("Cannot get ccq config", error, chainId);
                        logged = true;
                    }
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPoolProposalConfig(chainId) {
        return _ref.apply(this, arguments);
    };
}();
var UseActiveCCQ = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(chain) {
        var ccq;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getPoolProposalConfig(chain)
                    ];
                case 1:
                    ccq = _state.sent();
                    return [
                        2,
                        ccq
                    ];
            }
        });
    });
    return function UseActiveCCQ(chain) {
        return _ref.apply(this, arguments);
    };
}();
var ccqSupport = function(chainId) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), ccqConfig = ref[0], setccqConfig = ref[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getccqConfig = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                var activePools;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                UseActiveCCQ(chainId)
                            ];
                        case 1:
                            activePools = _state.sent();
                            setccqConfig(activePools);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getccqConfig() {
                return _ref.apply(this, arguments);
            };
        }();
        getccqConfig();
    }, [
        chainId
    ]);
    return ccqConfig;
};


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useCallWithMarketGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64487);







function useCallWithMarketGasPrice() {
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithMarketGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with market gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callWithMarketGasPrice: callWithMarketGasPrice
    };
}


/***/ }),

/***/ 2391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ views_MarketPlace; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(13193);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/HelpCcq.tsx
var HelpCcq = __webpack_require__(76611);
// EXTERNAL MODULE: ./packages/uikit/src/util/getWindowSize.ts
var getWindowSize = __webpack_require__(33904);
// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/MarketPlace/actions.ts
var actions = __webpack_require__(65364);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/Layout/SubHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display:flex;\n    color: #13486B;\n    font-size: 24px;\n    font-weight: 600;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin-top: 24px;\n    cursor: pointer;\n    &:hover{\n        text-decoration: underline;\n    }\n    @media screen and (max-width: 1024px){\n        font-size: 14px;\n        gap: 8px;\n        margin-top: 14px;\n    }\n    img{\n        width: 24px;\n        height: 24px;\n        @media screen and (max-width: 1024px){\n            width: 14px;\n            height: 14px;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    outline: none;\n    &:focus-visible {\n        outline: none;\n    }\n    ::placeholder {\n        color:",
        ";\n        opacity: 1;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    justify-content: center;\n    margin-top: 34px;\n    @media screen and (max-width: 768px){\n        margin-top: 17px;\n    }\n    @media screen and (max-width: 600px){\n        margin-top: 10px;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 28px;\n    height: 75px;\n    border-radius: 12px;\n    @media screen and (max-width: 768px){\n        border-radius: 4px;\n        font-size: 14px;\n        height: 50px;\n        padding: 0 16px;\n    }\n    @media screen and (max-width: 600px){\n        padding: 0 16px;\n        font-size: 12px;\n        line-height: 14px;\n        height: 40px;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    width: 100%;\n    max-width: 620px;\n    @media screen and (max-width: 768px){\n        padding: 0 36px;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 34px;\n    letter-spacing: 0.04em;\n    font-weight: 700;\n    font-size: 40px;\n    line-height: 40px;\n    color: ",
        ";\n    @media screen and (max-width: 600px){\n        font-size: 24px;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    padding: 12px 36px;\n    margin: 34px auto 0;\n    border-radius: 4px;\n    @media screen and (max-width: 768px){\n        margin: 16px 0;\n    }\n    @media screen and (max-width: 600px){\n        padding: 18px 16px;\n    }\n    input{\n        padding-right: 16px;\n        width: 75%;\n        border: none;\n        color: ",
        ";\n        font-weight: 700;\n        font-size: 32px;\n        line-height: 49px;\n        letter-spacing: 0.04em;\n        &::placeholder{\n            color: ",
        ";\n        }\n        @media screen and (max-width: 768px){\n            font-size: 20px;\n            line-height: 49px;\n        }\n        @media screen and (max-width: 600px){\n            font-size: 14px;\n            line-height: 16px;\n        }\n    }\n    ",
        "{\n        white-space: nowrap;\n        font-weight: 400;\n        font-size: 24px;\n        line-height: 28px;\n        @media screen and (max-width: 600px){\n            font-size: 10px;\n            line-height: 12px;\n        }\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    margin: 0 auto;\n    width: 100%;\n    margin-top: 34px;\n    @media screen and (max-width: 768px){\n        margin-top: 17px;\n        max-width: 100%;\n    }\n    @media screen and (max-width: 600px){\n        margin-top: 6px;\n    }\n    ",
        "{\n        font-weight: 400;\n        font-size: 24px;\n        line-height: 33px;\n        color: ",
        ";\n        @media screen and (max-width: 768px){\n            font-size: 18px;\n            line-height: 1.5;\n        }\n        @media screen and (max-width: 600px){\n            font-size: 12px;\n            line-height: 1.5;\n        }\n    }\n    span{\n        color: ",
        ";\n        margin-left: 4px;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var SubHeader = function(param) {
    var listItem = param.listItem, dataUser = param.dataUser, account = param.account;
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(), fillPrice = ref1[0], setFillPice = ref1[1];
    var sortListItem = (ref = (0,_to_consumable_array/* default */.Z)(listItem)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
        return (b === null || b === void 0 ? void 0 : b.unitPrice) - (a === null || a === void 0 ? void 0 : a.unitPrice);
    });
    var addThousandPrice = sortListItem.map(function(item) {
        var buysThousandPrice = item.buys.map(function(b) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, b), {
                amount: b.amount * item.unitPrice
            });
        });
        return {
            buys: buysThousandPrice,
            id: item.id,
            addresses: item.nftAddress,
            unitPrice: item.unitPrice
        };
    });
    var handleSearch = function() {
        var resultFilter = [];
        var amountBuy = Number(fillPrice);
        addThousandPrice.forEach(function(obj) {
            var buys = obj.buys.map(function(b) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, b), {
                    amount: b.amount / obj.unitPrice
                });
            });
            obj.buys.forEach(function(item) {
                if (item.amount > 0 && amountBuy > 0) {
                    var quantityToBuy = Math.min(amountBuy, item.amount);
                    resultFilter.push({
                        addresses: obj.addresses,
                        buys: buys,
                        id: item.id,
                        buyAmount: quantityToBuy / obj.unitPrice
                    });
                    var updatedAmount = item.amount - quantityToBuy;
                    var updatedBuyAmount = amountBuy - quantityToBuy;
                    // eslint-disable-next-line no-param-reassign
                    obj.buys = obj.buys.map(function(buy) {
                        return buy.id === item.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buy), {
                            amount: updatedAmount
                        }) : buy;
                    });
                    // eslint-disable-next-line no-param-reassign
                    amountBuy = updatedBuyAmount;
                }
            });
        });
        var result = resultFilter.reduce(function(acc, pre) {
            var index = acc.findIndex(function(item) {
                var ref, ref1;
                return (item === null || item === void 0 ? void 0 : (ref = item.addresses) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref1 = pre.addresses) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
            });
            if (index === -1) {
                acc.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pre), {
                    buyAmount: Math.floor(pre.buyAmount)
                }));
            } else {
                var buyAmount = acc[index].buyAmount;
                // eslint-disable-next-line no-param-reassign
                acc[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[index]), {
                    buyAmount: Math.floor(buyAmount + pre.buyAmount)
                });
            }
            return acc;
        }, []);
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: result
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchHeading, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFirstHeading, {
                children: t("T\xf4i muốn mua")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsSecondHeading, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsNumericFormat, {
                        value: fillPrice,
                        decimalScale: 2,
                        thousandSeparator: !false,
                        placeholder: "1,000,000",
                        // eslint-disable-next-line no-return-assign, no-param-reassign
                        onFocus: function(e) {
                            return e.target.placeholder = "";
                        },
                        onValueChange: function(values) {
                            var value = values.value;
                            if (Number(value) >= 0) {
                                setFillPice(value);
                            }
                        },
                        isAllowed: function(values) {
                            var value = values.value;
                            return account ? Number(value) <= Number(dataUser === null || dataUser === void 0 ? void 0 : dataUser.balance) : Number(value) >= 0;
                        },
                        maxLength: 35,
                        allowNegative: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Chứng chỉ Quỹ (VND)")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsThirstHeading, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Số dư t\xe0i khoản")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        style: {
                            color: "#F9A138",
                            fontWeight: 500
                        },
                        children: [
                            account ? "".concat(Number(dataUser === null || dataUser === void 0 ? void 0 : dataUser.balance).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })) : "0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontWeight: 600,
                                    marginLeft: "6px"
                                },
                                children: "VND"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsThirstHeading, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Mệnh gi\xe1 Chứng chỉ Quỹ")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        style: {
                            color: "#F9A138",
                            fontWeight: 500
                        },
                        children: [
                            "".concat(100000..toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontWeight: 600,
                                    marginLeft: "0px"
                                },
                                children: "VND"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsThirstHeading, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Số tiền giao dịch tối thiểu")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        style: {
                            color: "#F9A138",
                            fontWeight: 500
                        },
                        children: [
                            1000000..toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontWeight: 600,
                                    marginLeft: "0px"
                                },
                                children: " VND"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonSearch, {
                    onClick: handleSearch,
                    disabled: Number(fillPrice) < constants/* MINIMUM */.Gf || !fillPrice,
                    children: "T\xecm mua"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLinkVerichains, {
                href: constants/* LINK_VERICHAINS */.G4,
                target: "_blank",
                rel: "noreferrer",
                children: [
                    "Audit by Verichains",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/ccqFundgo/export.png?version=1.1",
                        alt: "export"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Layout_SubHeader = (SubHeader);
var CsLinkVerichains = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e81b91f-0"
})(_templateObject());
var CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-e81b91f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var WrapButton = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e81b91f-2"
})(_templateObject2());
var CsButtonSearch = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-e81b91f-3"
})(_templateObject3());
// start search Heading
var SearchHeading = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e81b91f-4"
})(_templateObject4());
var CsFirstHeading = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-e81b91f-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsSecondHeading = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e81b91f-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, Text/* default */.Z);
var CsThirstHeading = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e81b91f-7"
})(_templateObject7(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});

// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(33533);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/config/abi/erc20.ts + 1 modules
var erc20 = __webpack_require__(56309);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(9796);
// EXTERNAL MODULE: ./src/config/abi/ccqWrappedAbi.json
var ccqWrappedAbi = __webpack_require__(77513);
;// CONCATENATED MODULE: ./src/config/abi/marketplaceAbi.json
var marketplaceAbi_namespaceObject = JSON.parse('[{"inputs":[{"internalType":"address","name":"_paymentToken","type":"address"},{"internalType":"bool","name":"_isOpen","type":"bool"},{"internalType":"uint256","name":"_decimals","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"nftId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalValue","type":"uint256"},{"indexed":false,"internalType":"address","name":"seller","type":"address"},{"indexed":false,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"address","name":"contractAddress","type":"address"}],"name":"_eventBuyItemInMarket","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"nftId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"address","name":"seller","type":"address"}],"name":"_eventDelistItem","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"nftId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"address","name":"seller","type":"address"}],"name":"_eventListNewItemToMarket","type":"event"},{"inputs":[{"internalType":"address","name":"_publisher","type":"address"}],"name":"addPublisher","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct FundCertMarketplace.Cart[]","name":"cart","type":"tuple[]"}],"name":"buyItem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cleanMarket","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256[]","name":"_ids","type":"uint256[]"},{"internalType":"uint256[]","name":"_amounts","type":"uint256[]"}],"name":"delistItem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getTotalItems","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"isOpen","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"items","outputs":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"nftId","type":"uint256"},{"internalType":"address","name":"nftAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"address","name":"seller","type":"address"},{"internalType":"contract FundCertWrap","name":"nftContract","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256[]","name":"","type":"uint256[]"},{"internalType":"uint256[]","name":"","type":"uint256[]"},{"internalType":"bytes","name":"","type":"bytes"}],"name":"onERC1155BatchReceived","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"bytes","name":"","type":"bytes"}],"name":"onERC1155Received","outputs":[{"internalType":"bytes4","name":"","type":"bytes4"}],"stateMutability":"pure","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paymentToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"publishers","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_publisher","type":"address"}],"name":"removePublisher","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_nftAddress","type":"address"},{"components":[{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct FundCertMarketplace.SellItem[]","name":"sellItems","type":"tuple[]"}],"name":"sellItem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_status","type":"bool"}],"name":"setMartketStatus","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_paymentToken","type":"address"},{"internalType":"uint256","name":"_decimals","type":"uint256"}],"name":"setPaymentToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(97478);
;// CONCATENATED MODULE: ./src/state/MarketPlace/fetchData.ts












var fetchGetTotalItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contractAddress, chainId) {
        var calls, ref, request, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [
                        {
                            address: contractAddress,
                            name: "getTotalItems",
                            params: []
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* default */.Z)(marketplaceAbi_namespaceObject, calls, chainId)
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), request = ref[0];
                    return [
                        2,
                        Number(new bignumber/* default */.Z(request).toJSON())
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        0
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchGetTotalItems(contractAddress, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contractAddress, chainId, getTotalItems) {
        var calls, index, request, parseData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [];
                    for(index = 0; index < getTotalItems; index++){
                        calls.push({
                            address: contractAddress,
                            name: "items",
                            params: [
                                index
                            ]
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(marketplaceAbi_namespaceObject, calls, chainId)
                    ];
                case 1:
                    request = _state.sent();
                    parseData = request.map(function(item) {
                        return {
                            amount: Number(new bignumber/* default */.Z(item.amount.toString())),
                            id: Number(new bignumber/* default */.Z(item.id.toString())),
                            nftAddress: item.nftAddress,
                            nftContract: item.nftContract,
                            nftId: Number(new bignumber/* default */.Z(item.nftId.toString())),
                            seller: item.seller
                        };
                    });
                    return [
                        2,
                        parseData
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        []
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchItems(contractAddress, chainId, getTotalItems) {
        return _ref.apply(this, arguments);
    };
}();
var fetchNftAddressItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(items, contractMarketplaceAddress, chainId) {
        var formatTime, nowDay, callsEtfInfo, callsPriceAtTime, callVestingMap, callPaused, currentTime, index, ref, getEtfInfo, getEtfVestingMap, getPriceAtTime, getCallPaused, ref1, requestEtfInfor, resultVestingmap, resultPriceAtTime, resultCallPaused, parseData, filterExpireDate, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!items.length) return [
                        3,
                        2
                    ];
                    formatTime = "YYYY-MM-DD HH:mm:ss";
                    nowDay = moment_default()(new Date()).format(formatTime);
                    callsEtfInfo = [];
                    callsPriceAtTime = [];
                    callVestingMap = [];
                    callPaused = [];
                    currentTime = Math.floor(Date.now() / 1000);
                    for(index = 0; index < items.length; index++){
                        ;
                        callsEtfInfo.push({
                            address: items[index].nftAddress,
                            name: "etfInfor",
                            params: []
                        });
                        callVestingMap.push({
                            address: items[index].nftAddress,
                            name: "getMyVestList",
                            params: [
                                contractMarketplaceAddress,
                                (ref = items[index]) === null || ref === void 0 ? void 0 : ref.nftId
                            ]
                        });
                        callsPriceAtTime.push({
                            address: items[index].nftAddress,
                            name: "getPriceAtTime",
                            params: [
                                currentTime
                            ]
                        });
                        callPaused.push({
                            address: items[index].nftAddress,
                            name: "paused",
                            params: []
                        });
                    }
                    getEtfInfo = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var resultEtfInfo;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callsEtfInfo, chainId)
                                        ];
                                    case 1:
                                        resultEtfInfo = _state.sent();
                                        return [
                                            2,
                                            resultEtfInfo
                                        ];
                                }
                            });
                        });
                        return function getEtfInfo() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getEtfVestingMap = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var resultVestingMap;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callVestingMap, chainId)
                                        ];
                                    case 1:
                                        resultVestingMap = _state.sent();
                                        return [
                                            2,
                                            resultVestingMap
                                        ];
                                }
                            });
                        });
                        return function getEtfVestingMap() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getPriceAtTime = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var resultPriceAtTime;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callsPriceAtTime, chainId)
                                        ];
                                    case 1:
                                        resultPriceAtTime = _state.sent();
                                        return [
                                            2,
                                            resultPriceAtTime
                                        ];
                                }
                            });
                        });
                        return function getPriceAtTime() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getCallPaused = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var resultCallPaused;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callPaused, chainId)
                                        ];
                                    case 1:
                                        resultCallPaused = _state.sent();
                                        return [
                                            2,
                                            resultCallPaused
                                        ];
                                }
                            });
                        });
                        return function getCallPaused() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        Promise.all([
                            getEtfInfo(),
                            getEtfVestingMap(),
                            getPriceAtTime(),
                            getCallPaused()
                        ])
                    ];
                case 1:
                    ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), requestEtfInfor = ref1[0], resultVestingmap = ref1[1], resultPriceAtTime = ref1[2], resultCallPaused = ref1[3];
                    parseData = requestEtfInfor.map(function(item, index) {
                        var ref;
                        var issueDate = Number(new bignumber/* default */.Z(item.issueDate.toString()).toString());
                        var price = Number(new bignumber/* default */.Z(item.price.toString()).dividedBy(1E18).toString());
                        var interVestTerm = Number(new bignumber/* default */.Z(item.intervestTerm.toString()).toString()) === 92 ? 3 : 6;
                        var expireDate = Number(new bignumber/* default */.Z(item.expireDate.toString()).toString());
                        var resultDayNextProfit = resultVestingmap[index][0].find(function(data) {
                            return Number(data === null || data === void 0 ? void 0 : data.vestDate) * 1000 > Date.now();
                        });
                        var parseDate = new bignumber/* default */.Z(resultDayNextProfit === null || resultDayNextProfit === void 0 ? void 0 : (ref = resultDayNextProfit.vestDate) === null || ref === void 0 ? void 0 : ref.toString()).multipliedBy(1000).toString();
                        var paydayNextProfit = moment_default()(new Date(Number(parseDate))).format("DD/MM/YYYY");
                        var convertdayDiff = moment_default()(Number(parseDate)).diff(moment_default()(Number(Date.now())), config/* UNITDIFF */.Wt);
                        var interestRate = Number(new bignumber/* default */.Z(item.intervestTerm.toString()).toString()) === 92 ? 8 : 9.2;
                        var holdDate = Number(new bignumber/* default */.Z(item.intervestTerm.toString()).toString()) === 92 ? 92 - convertdayDiff : 164 - convertdayDiff;
                        // unitPrice = price + (price * interestRate% * holdDate / 365)
                        var unitPrice = Number(new bignumber/* default */.Z(resultPriceAtTime[index][0].toString()).dividedBy(1E18).toString());
                        var paused = resultCallPaused[index][0];
                        var resultVestingMap = resultVestingmap[index][0].map(function(vestItem) {
                            var ref, ref1;
                            return {
                                amount: new bignumber/* default */.Z(vestItem === null || vestItem === void 0 ? void 0 : (ref = vestItem.amount) === null || ref === void 0 ? void 0 : ref.toString()).toString(),
                                isVested: vestItem === null || vestItem === void 0 ? void 0 : vestItem.isVested,
                                vestDate: Number(new bignumber/* default */.Z(vestItem === null || vestItem === void 0 ? void 0 : (ref1 = vestItem.vestDate) === null || ref1 === void 0 ? void 0 : ref1.toString()).toString()),
                                intervestPayed: new bignumber/* default */.Z(vestItem === null || vestItem === void 0 ? void 0 : vestItem.intervestPayed.toString()).toString()
                            };
                        });
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            interVestTermRate: interestRate,
                            dayDiff: convertdayDiff + 1 > 92 ? 92 : convertdayDiff + 1
                        }, items[index]), {
                            expireDate: expireDate,
                            interVestTerm: interVestTerm,
                            paydayNextProfit: paydayNextProfit,
                            unitPrice: unitPrice,
                            issueDate: issueDate,
                            name: item.name,
                            price: price,
                            publisher: item.publisher,
                            totalSupply: Number(new bignumber/* default */.Z(item.totalSupply.toString())),
                            vestingMap: resultVestingMap,
                            paused: paused
                        });
                    });
                    filterExpireDate = parseData.filter(function(item) {
                        var endDay = moment_default()(item.expireDate * 1000).format(formatTime);
                        return moment_default()(nowDay).valueOf() < moment_default()(endDay).valueOf() && !item.paused;
                    });
                    return [
                        2,
                        filterExpireDate
                    ];
                case 2:
                    return [
                        2,
                        []
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchNftAddressItem(items, contractMarketplaceAddress, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataAllowance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(contractMarketplaceAddress, tokenAddress, account, chainId) {
        var calls, ref, resultAllowance, resultBalanceOf, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!account) return [
                        3,
                        2
                    ];
                    calls = [
                        {
                            address: tokenAddress,
                            name: "allowance",
                            params: [
                                account,
                                contractMarketplaceAddress
                            ]
                        },
                        {
                            address: tokenAddress,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), resultAllowance = ref[0], resultBalanceOf = ref[1];
                    return [
                        2,
                        {
                            allowance: new bignumber/* default */.Z(resultAllowance[0].toString()).toString(),
                            balance: new bignumber/* default */.Z(resultBalanceOf[0].toString()).toString()
                        }
                    ];
                case 2:
                    return [
                        2,
                        {
                            allowance: "0",
                            balance: "0"
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            allowance: "0",
                            balance: "0"
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataAllowance(contractMarketplaceAddress, tokenAddress, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/MarketPlace/index.ts






var GetValueSearch = function() {
    var data = useSelector(function(state) {
        return state.marketplace;
    });
    var valueSearch = data;
    return valueSearch;
};
var UseCoreMarketplace = function(contractMarketplaceAddress, tokenAddress, chainId, account) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var listCart = GetDataMarketplace().listCart; // run dispatch buy item request
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var getDataItem = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var dataAllowance, getTotalItems, items, nftAddressItem, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            dispatch((0,actions/* fetchStatusLoading */.Xy)({
                                isLoading: true
                            }));
                            return [
                                4,
                                fetchDataAllowance(contractMarketplaceAddress, tokenAddress, account, chainId)
                            ];
                        case 1:
                            dataAllowance = _state.sent();
                            return [
                                4,
                                fetchGetTotalItems(contractMarketplaceAddress, chainId)
                            ];
                        case 2:
                            getTotalItems = _state.sent();
                            return [
                                4,
                                fetchItems(contractMarketplaceAddress, chainId, getTotalItems)
                            ];
                        case 3:
                            items = _state.sent();
                            return [
                                4,
                                fetchNftAddressItem(items, contractMarketplaceAddress, chainId)
                            ];
                        case 4:
                            nftAddressItem = _state.sent();
                            dispatch((0,actions/* fetchDataOnMarketplace */.b1)({
                                listItem: nftAddressItem
                            }));
                            dispatch((0,actions/* fetchDataUserAction */.VG)({
                                dataUser: dataAllowance
                            }));
                            return [
                                3,
                                6
                            ];
                        case 5:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataItem() {
                return _ref.apply(this, arguments);
            };
        }();
        getDataItem();
    }, [
        account,
        chainId,
        contractMarketplaceAddress,
        dispatch,
        tokenAddress,
        listCart.length
    ]);
};
var GetDataMarketplace = function() {
    var dataMarketplace = (0,es/* useSelector */.v9)(function(state) {
        return state.marketplace;
    });
    return dataMarketplace;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/tooltipClasses.js
var tooltipClasses = __webpack_require__(7335);
;// CONCATENATED MODULE: ./src/components/ToolTip/index.tsx







var LightTooltip = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        placement: "top"
    }, props), {
        arrow: true,
        classes: {
            popper: className
        }
    }));
}).withConfig({
    componentId: "sc-a832e5c2-0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "white",
        "&::before": {
            backgroundColor: "white"
        }
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "white",
        color: "#8c8d8e",
        boxShadow: "#8c8d8e",
        fontSize: 14,
        padding: 10,
        fontWeight: 500
    }), _obj;
});

// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./src/config/constants/contracts.ts
var contracts = __webpack_require__(87338);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(69352);
;// CONCATENATED MODULE: ./src/utils/renderAddress.ts




function renderMarketplaceAddress(chainId) {
    return (0,addressHelpers/* getAddress */.Kn)(contracts/* default.ccqMarketplace */.Z.ccqMarketplace, chainId);
}
function renderToken(chainId) {
    switch(chainId){
        case swap_sdk_src/* ChainId.BSC */.a_.BSC:
            return tokens_src/* bscTokens.VNDC */.ds.VNDC;
        case swap_sdk_src/* ChainId.ONUS */.a_.ONUS:
            return tokens_src/* onusMainnetTokens.vndc */.Au.vndc;
        default:
            return tokens_src/* bscTestnetTokens.vndc */.dI.vndc;
    }
}

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(62255);
;// CONCATENATED MODULE: ./src/utils/sumTotalItems.ts

var totalPrice = function(listCart, listItemsOnMarketplace) {
    return listCart === null || listCart === void 0 ? void 0 : listCart.reduce(function(sum, i) {
        if ((i === null || i === void 0 ? void 0 : i.id) === null || (i === null || i === void 0 ? void 0 : i.id) === undefined) {
            return 0;
        }
        var items = listItemsOnMarketplace === null || listItemsOnMarketplace === void 0 ? void 0 : listItemsOnMarketplace.find(function(data) {
            return Number(data === null || data === void 0 ? void 0 : data.id) === Number(i === null || i === void 0 ? void 0 : i.id);
        });
        return new bignumber/* BigNumber */.O(sum).plus(new bignumber/* BigNumber */.O(i.buyAmount).multipliedBy(items === null || items === void 0 ? void 0 : items.unitPrice).toString()).toString();
    }, 0);
};
var totalItems = function(listCart) {
    return listCart === null || listCart === void 0 ? void 0 : listCart.reduce(function(sum, i) {
        if ((i === null || i === void 0 ? void 0 : i.id) === null || (i === null || i === void 0 ? void 0 : i.id) === undefined) {
            return 0;
        }
        return new bignumber/* BigNumber */.O(sum).plus(new bignumber/* BigNumber */.O(i.buyAmount).toString()).toString();
    }, 0);
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(91375);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Plus.tsx
var Plus = __webpack_require__(89325);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(18221);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/ItemBuyMobile/index.tsx

function ItemBuyMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    font-weight: bold;\n    text-align: center;\n    color: ",
        ";\n    &:first-child {\n        text-align: left;\n    }\n"
    ]);
    ItemBuyMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 2px;\n    width: 22px;\n    cursor: pointer;\n    border-radius: 4px;\n    background: rgba(238, 68, 55, 0.12);\n"
    ]);
    ItemBuyMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 10%;\n    justify-content: flex-end;\n    position: absolute;\n    top:22px;\n    right: 22px;\n"
    ]);
    ItemBuyMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    align-items: center;\n"
    ]);
    ItemBuyMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: rgba(239, 239, 239, 0.8);\n    border-radius: 4px;\n    padding: 6px 15px;\n    align-items: center;\n"
    ]);
    ItemBuyMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    color: ",
        ";\n    text-align: center;\n    box-shadow: none;\n    border: none;\n    height: 100%;\n    width: 100%;\n    padding: 0;\n    font-size: 16px;\n    border-radius: 0;\n    &::placeholder {\n        color: ",
        ";\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 14px;\n    }\n"
    ]);
    ItemBuyMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid transparent;\n    background: ",
        ";\n    border-radius: 4px;\n    box-shadow: none;\n    padding: 8px;\n    height: 16px;\n    width: 16px;\n    cursor: pointer;\n    &:hover {\n        background: ",
        ";\n    }\n"
    ]);
    ItemBuyMobile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ItemBuyMobile_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 25%;\n    height: 42px;\n    align-items: center;\n    font-size: 12px;\n"
    ]);
    ItemBuyMobile_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 22.5%;\n    height: 42px;\n    align-items: center;\n    font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 2px;\n    overflow: hidden;\n    padding: 12px 20px;\n    background: ",
        ";\n    position: relative;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 6px;\n    align-items: center;\n    background: ",
        ";\n    border-radius: 4px;\n    width: 86px;\n    height: 28px;\n    padding: 4px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var ItemBuyMobile = function(param) {
    var buyAmount = param.buyAmount, listItem = param.listItem, handleChangeAmountBuy = param.handleChangeAmountBuy, handleCancel = param.handleCancel;
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (/^\d+$/.test(value) || value === "") {
            var convertNumber = value;
            if (Number(convertNumber) < 1) {
                convertNumber = "";
            } else if (convertNumber > Number(listItem === null || listItem === void 0 ? void 0 : listItem.amount)) {
                convertNumber = listItem === null || listItem === void 0 ? void 0 : listItem.amount;
            }
            handleChangeAmountBuy(Number(convertNumber), listItem.id, listItem.nftAddress, listItem.buys);
        }
    };
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = listItem === null || listItem === void 0 ? void 0 : (ref = listItem.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        listItem === null || listItem === void 0 ? void 0 : listItem.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return listItem === null || listItem === void 0 ? void 0 : (ref = listItem.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        listItem === null || listItem === void 0 ? void 0 : listItem.vestingMap
    ]);
    var total = new bignumber/* default */.Z(listItem === null || listItem === void 0 ? void 0 : listItem.unitPrice).multipliedBy(buyAmount).decimalPlaces(2, 1).toString();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBuyItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapIcon, {
                width: "10%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsCloseIcon, {
                    onClick: function() {
                        return handleCancel(listItem.id);
                    },
                    color: "red"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlex2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardMobile, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    children: "SL:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                                    children: [
                                        "\xa0",
                                        Number(listItem.amount).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardSmall, {
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                            children: [
                                listItem.interVestTerm,
                                " th\xe1ng"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardSmall, {
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                            children: [
                                listItem === null || listItem === void 0 ? void 0 : listItem.interVestTermRate,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardMobile, {
                        alignItems: "center",
                        justifyContent: "flex-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: Number(listItem.price).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlex2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardMobile, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    children: "ĐG:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                                    children: [
                                        "\xa0",
                                        Number(listItem.unitPrice).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardSmall, {
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                            children: [
                                listItem === null || listItem === void 0 ? void 0 : listItem.dayDiff,
                                " ",
                                config/* UNIT_DATE */.L$
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardSmall, {
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsText, {
                            children: [
                                totalVested,
                                "/",
                                totalVestingMap
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemCardMobile, {
                        alignItems: "center",
                        justifyContent: "flex-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: listItem === null || listItem === void 0 ? void 0 : listItem.paydayNextProfit
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlex3, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "60%",
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                width: "60%",
                                fontSize: "12px",
                                children: "Chọn SL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapCount, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonQuanlity, {
                                        disabled: Number(buyAmount) <= 1,
                                        onClick: function() {
                                            return handleChangeAmountBuy(Number(buyAmount) - 1, listItem.id, listItem.nftAddress, listItem.buys);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                                        type: "text",
                                        scale: "lg",
                                        inputMode: "numeric",
                                        value: buyAmount,
                                        placeholder: "0",
                                        onChange: handleChangeInput
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonQuanlity, {
                                        onClick: function() {
                                            return handleChangeAmountBuy(Number(buyAmount) + 1, listItem.id, listItem.nftAddress, listItem.buys);
                                        },
                                        disabled: Number(buyAmount) >= Number(listItem === null || listItem === void 0 ? void 0 : listItem.amount),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                        width: "50%",
                        children: Number(total).toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        })
                    })
                ]
            })
        ]
    });
};
var CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-0"
})(ItemBuyMobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsCloseIcon = (0,styled_components_browser_esm/* default */.ZP)(Close/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-1"
})(ItemBuyMobile_templateObject1());
var CsWrapIcon = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-2"
})(ItemBuyMobile_templateObject2());
var CsFlex2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-3"
})(ItemBuyMobile_templateObject3());
var CsFlex3 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-4"
})(ItemBuyMobile_templateObject4());
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-5"
})(ItemBuyMobile_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ButtonQuanlity = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-6"
})(ItemBuyMobile_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsItemCardMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-7"
})(ItemBuyMobile_templateObject7());
var CsItemCardSmall = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-8"
})(_templateObject8());
var WrapperBuyItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ea98dfb8-9"
})(_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var WrapCount = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ea98dfb8-10"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.success3;
});
/* harmony default export */ var Cart_ItemBuyMobile = (ItemBuyMobile);

;// CONCATENATED MODULE: ./src/views/MarketPlace/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 12%;\n    height: 100%;\n    align-items: center;\n    color: ",
        " !important;;\n    justify-content: center;\n    white-space: nowrap;\n    text-align: center;\n    ",
        "{\n        line-height:21px;\n        font-size: 14px;\n        white-space: nowrap;\n    }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 4%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 9.5%;\n    height: 100%;\n    align-items: center;\n    color: ",
        " !important;\n    justify-content: center;\n    text-align: center;\n    line-height:21px;\n    white-space: nowrap;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var CsItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2fffbb8c-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, Text/* default */.Z);
var CsItemWarning = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2fffbb8c-1"
})(style_templateObject1());
var CsItemSmall = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2fffbb8c-2"
})(style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/ItemBuyPC/index.tsx

function ItemBuyPC_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    color: ",
        ";\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    border: none;\n    box-shadow: none;\n    font-size: 16px;\n    border-radius: 0;\n    &::placeholder {\n        color: ",
        ";\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 14px;\n    }\n"
    ]);
    ItemBuyPC_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemBuyPC_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid transparent;\n    background: ",
        ";\n    border-radius: 4px;\n    box-shadow: none;\n    padding: 4px;\n    height: 24px;\n    width: 24px;\n"
    ]);
    ItemBuyPC_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemBuyPC_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 6px;\n    align-items: center;\n    background: ",
        ";\n    border-radius: 4px;\n    width: 104px;\n    height: 34px;\n    padding: 4px;\n"
    ]);
    ItemBuyPC_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemBuyPC_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    background: transparent;\n    border-radius: 4px;\n    min-width: 112px;\n    height: 40px;\n"
    ]);
    ItemBuyPC_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemBuyPC_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center top;\n"
    ]);
    ItemBuyPC_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ItemBuyPC_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.62);\n    &::after {\n        content: "";\n        position: absolute;\n        left: 19%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ';\n    }\n    &::before {\n        content: "";\n        position: absolute;\n        right: 33.5%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ";\n    }\n    ",
        "{\n        height: 70px;\n        align-items: center;\n    }\n"
    ]);
    ItemBuyPC_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var ItemBuy = function(param) {
    var buyAmount = param.buyAmount, listItem = param.listItem, handleChangeAmountBuy = param.handleChangeAmountBuy, handleCancel = param.handleCancel;
    var t = (0,src/* useTranslation */.$G)().t;
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (/^\d+$/.test(value) || value === "") {
            var convertNumber = value;
            if (Number(convertNumber) < 1) {
                convertNumber = "";
            } else if (convertNumber > Number(listItem === null || listItem === void 0 ? void 0 : listItem.amount)) {
                convertNumber = listItem === null || listItem === void 0 ? void 0 : listItem.amount;
            }
            handleChangeAmountBuy(Number(convertNumber), listItem.id, listItem.nftAddress, listItem.buys);
        }
    };
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = listItem === null || listItem === void 0 ? void 0 : (ref = listItem.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        listItem === null || listItem === void 0 ? void 0 : listItem.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return listItem === null || listItem === void 0 ? void 0 : (ref = listItem.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        listItem === null || listItem === void 0 ? void 0 : listItem.vestingMap
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(listItem === null || listItem === void 0 ? void 0 : listItem.amount).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(listItem === null || listItem === void 0 ? void 0 : listItem.price).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                    children: [
                        totalVested,
                        "/",
                        totalVestingMap
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: "".concat(listItem === null || listItem === void 0 ? void 0 : listItem.interVestTerm, " th\xe1ng")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: listItem === null || listItem === void 0 ? void 0 : listItem.paydayNextProfit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: "".concat(listItem.dayDiff, " ").concat(config/* UNIT_DATE */.L$)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                    children: [
                        listItem === null || listItem === void 0 ? void 0 : listItem.interVestTermRate,
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(listItem === null || listItem === void 0 ? void 0 : listItem.unitPrice).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemBuyPC_WrapCount, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC_ButtonQuanlity, {
                                    disabled: Number(buyAmount) <= 1,
                                    onClick: function() {
                                        return handleChangeAmountBuy(Number(buyAmount) - 1, listItem.id, listItem.nftAddress, listItem.buys);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC_CustomInput, {
                                    type: "text",
                                    scale: "lg",
                                    inputMode: "numeric",
                                    value: buyAmount,
                                    placeholder: "0",
                                    onChange: handleChangeInput
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC_ButtonQuanlity, {
                                    onClick: function() {
                                        return handleChangeAmountBuy(Number(buyAmount) + 1, listItem.id, listItem.nftAddress, listItem.buys);
                                    },
                                    disabled: Number(buyAmount) >= Number(listItem === null || listItem === void 0 ? void 0 : listItem.amount),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonCancel, {
                        onClick: function() {
                            return handleCancel(listItem.id);
                        },
                        children: t("Huỷ")
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ItemBuyPC = (ItemBuy);
var ItemBuyPC_CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-e7eaabbe-0"
})(ItemBuyPC_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ItemBuyPC_ButtonQuanlity = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-e7eaabbe-1"
})(ItemBuyPC_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ItemBuyPC_WrapCount = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7eaabbe-2"
})(ItemBuyPC_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.success3;
});
var CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-e7eaabbe-3"
})(ItemBuyPC_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e7eaabbe-4"
})(ItemBuyPC_templateObject4());
var WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7eaabbe-5"
})(ItemBuyPC_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, CsItemSmall);

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/OpenNewIcon.tsx
var OpenNewIcon = __webpack_require__(60381);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
;// CONCATENATED MODULE: ./src/utils/converDate.tsx




function convertDate(date) {
    if (date) {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var hours = String(today.getHours()).padStart(2, "0");
        var minutes = String(today.getMinutes()).padStart(2, "0");
        var yyyy = today.getFullYear();
        return "".concat(dd, "/").concat(mm, "/").concat(yyyy);
    }
    return "--/--/--";
}
var renderCountdown = function(param) {
    var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
    if (completed) return /*#__PURE__*/ _jsx(_Fragment, {
        children: "00 ng\xe0y"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            zeroPad(days),
            " ng\xe0y"
        ]
    });
};
var getDateBetweenTwoDates = function(endDate) {
    var formatStartDate = moment_default()(moment_default()(endDate).format("DD-MM-YYYY HH:mm:ss"), "DD-MM-YYYY HH:mm:ss");
    var formatStartDateb = moment_default()(moment_default()(Date.now()).format("DD-MM-YYYY HH:mm:ss"), "DD-MM-YYYY HH:mm:ss");
    var addMinutes = formatStartDate.add(1, config/* UNITDIFF */.Wt);
    var finalDayDiff = addMinutes.diff(formatStartDateb, config/* UNITDIFF */.Wt) < 0 ? 0 : addMinutes.diff(formatStartDateb, config/* UNITDIFF */.Wt);
    if (finalDayDiff < 0) return 0;
    if (finalDayDiff > 92) return 92;
    return finalDayDiff;
};

;// CONCATENATED MODULE: ./src/components/ToolTip2/index.tsx







var LightTooltip2 = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        placement: "top"
    }, props), {
        arrow: true,
        classes: {
            popper: className
        }
    }));
}).withConfig({
    componentId: "sc-e4e03813-0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "white",
        "&::before": {
            backgroundColor: "#f5f5f5"
        }
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#f5f5f5",
        color: "#8c8d8e",
        boxShadow: "red",
        fontSize: 14,
        padding: 10,
        fontWeight: 500
    }), _obj;
});

// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./src/hooks/useCallWithMarketGasPrice.ts
var useCallWithMarketGasPrice = __webpack_require__(31063);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 16 modules
var useContract = __webpack_require__(90977);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 2 modules
var Toast = __webpack_require__(14605);
;// CONCATENATED MODULE: ./src/hooks/useUserRejected.ts


var useUserRejected = function() {
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var handleRejected = function(error) {
        var stringifyError = JSON.stringify(error);
        var parseError = JSON.parse(stringifyError);
        console.log("parseError", parseError);
        if ((parseError === null || parseError === void 0 ? void 0 : parseError.code) === "ACTION_REJECTED") toastError(config/* CONTENT_ERROR */.Pq);
        else if ((parseError === null || parseError === void 0 ? void 0 : parseError.code) === "CALL_EXCEPTION") toastError("Số lượng CCQ c\xf2n lại kh\xf4ng đủ thực hiện giao dịch !");
        else toastError("Đ\xe3 c\xf3 lỗi xảy ra", "X\xe1c nhận giao dịch v\xe0 đảm bảo rằng bạn đủ tiền trong v\xed để xử l\xfd giao dịch !");
    };
    return {
        handleRejected: handleRejected
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/hooks/useApprove.tsx














var useApprove = function(contractAddress, tokenAddress, account, chainId) {
    var ref = (0,react.useState)(false), requestedApproval = ref[0], setRequestedApproval = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var address = (0,useContract/* useERC20 */.X_)(tokenAddress);
    var ref2 = (0,react.useState)(false), pendingTx = ref2[0], setPendingTx = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e, dataAllowance, e1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingTx(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        9
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(address, "approve", [
                            contractAddress,
                            bignumbers/* MaxUint256 */.Bz
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Hợp đồng đ\xe3 k\xedch hoạt"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestedApproval(true);
                        setPendingTx(false);
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setRequestedApproval(false);
                        setPendingTx(false);
                    }
                    return [
                        3,
                        9
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    handleRejected(e);
                    setPendingTx(false);
                    return [
                        3,
                        9
                    ];
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        fetchDataAllowance(contractAddress, tokenAddress, account, chainId)
                    ];
                case 6:
                    dataAllowance = _state.sent();
                    dispatch((0,actions/* fetchDataUserAction */.VG)({
                        dataUser: dataAllowance
                    }));
                    return [
                        3,
                        8
                    ];
                case 7:
                    e1 = _state.sent();
                    console.log(e1);
                    return [
                        3,
                        8
                    ];
                case 8:
                    return [
                        7
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    }), [
        callWithMarketGasPrice,
        address,
        contractAddress,
        toastSuccess,
        t,
        toastError,
        tokenAddress,
        account,
        chainId,
        dispatch
    ]);
    return {
        handleApprove: handleApprove,
        requestedApproval: requestedApproval,
        pendingTx: pendingTx
    };
};

// EXTERNAL MODULE: ./src/state/asset/actions.ts
var asset_actions = __webpack_require__(99460);
;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/hooks/useBuyItem.tsx
















var useBuyItem = function(marketplaceAddress, account, chainId, listCart, onDismiss) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedApproval = ref[0], setRequestedApproval = ref[1];
    var ref1 = (0,react.useState)(false), pendingTx = ref1[0], setPendingTx = ref1[1];
    var address = (0,useContract/* useCoreMarketplace */.Y0)(marketplaceAddress);
    var handleRejected = useUserRejected().handleRejected;
    var ref2 = (0,useToast/* useToast */.p)(), toastSuccess = ref2.toastSuccess, toastError = ref2.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var newListCart = listCart.map(function(obj) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, obj), {
            buys: (0,_to_consumable_array/* default */.Z)(obj.buys).sort(function(a, b) {
                return a.amount - b.amount;
            })
        });
    });
    var resultFilter = [];
    newListCart.forEach(function(obj) {
        obj.buys.forEach(function(item) {
            if (item.amount > 0 && obj.buyAmount > 0) {
                var quantityToBuy = Math.min(obj.buyAmount, item.amount);
                resultFilter.push({
                    id: item.id,
                    amount: quantityToBuy
                });
                var updatedAmount = item.amount - quantityToBuy;
                var updatedBuyAmount = obj.buyAmount - quantityToBuy;
                // eslint-disable-next-line no-param-reassign
                obj.buys = obj.buys.map(function(buy) {
                    return buy.id === item.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buy), {
                        amount: updatedAmount
                    }) : buy;
                });
                // eslint-disable-next-line no-param-reassign
                obj.buyAmount = updatedBuyAmount;
            }
        });
    });
    var payload = resultFilter.map(function(item) {
        return [
            item.id,
            item.amount
        ];
    });
    var handleBuyItems = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingTx(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(address, "buyItem", [
                            payload
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Mua th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestedApproval(true);
                        setPendingTx(false);
                        onDismiss();
                        dispatch((0,actions/* fetchCartItems */.Vw)({
                            listCart: []
                        }));
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setRequestedApproval(false);
                        setPendingTx(false);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    handleRejected(e);
                    setPendingTx(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        address,
        callWithMarketGasPrice,
        dispatch,
        handleRejected,
        onDismiss,
        payload,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleBuyItems: handleBuyItems,
        requestedApproval: requestedApproval,
        pendingTx: pendingTx
    };
};

// EXTERNAL MODULE: ./node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(50196);
;// CONCATENATED MODULE: ./src/config/htttp.ts

// const _window: WindowWithEnv = window;
var backendURL = "https://api-fundgo-eft.tss.org.vn";
var axiosClient = axios/* default.create */.ZP.create({
    baseURL: "".concat(backendURL),
    timeout: 200000
});
var configHeader = {
    responseType: "arraybuffer",
    headers: {
        "Content-Type": "application/pdf"
    }
};

// EXTERNAL MODULE: ./node_modules/js-file-download/file-download.js
var file_download = __webpack_require__(35823);
var file_download_default = /*#__PURE__*/__webpack_require__.n(file_download);
;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/hooks/useDownloadPDF.ts






var useDownloadPDF = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastError = ref1.toastError, toastSuccess = ref1.toastSuccess;
    var handleDownload = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(raw) {
            var response, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        setLoading(true);
                        return [
                            4,
                            axiosClient.post("/pdf-generator/etf-transfer", raw, {
                                responseType: "arraybuffer",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Accept": "*"
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        file_download_default()(response.data, "hop_dong_chuyen_nhuong.pdf");
                        toastSuccess("Tải xuống th\xe0nh c\xf4ng.");
                        setLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        toastError("Tải xuống thất bại. Vui l\xf2ng thử lại.");
                        setLoading(false);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(raw) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastError,
        toastSuccess
    ]);
    return {
        loading: loading,
        handleDownload: handleDownload
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/hooks/index.ts




;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/ItemBuyPC/Row.tsx

function Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n    }\n"
    ]);
    Row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var RowForDesktop = function(param) {
    var buyAmount = param.buyAmount, itemSell = param.itemSell;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_WrapperCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: buyAmount
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: "".concat(itemSell.interVestTerm, " th\xe1ng")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: Number(itemSell.price).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    width: "14%",
                    children: [
                        itemSell.interVestTermRate,
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: itemSell.paydayNextProfit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: "".concat(itemSell.dayDiff, " ").concat(config/* UNIT_DATE */.L$)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "14%",
                    children: Number(itemSell === null || itemSell === void 0 ? void 0 : itemSell.unitPrice).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Row = (RowForDesktop);
var Row_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6763c133-0"
})(Row_templateObject());
var Row_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6763c133-1"
})(Row_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/HelpCcq2.tsx
var HelpCcq2 = __webpack_require__(89091);
;// CONCATENATED MODULE: ./src/components/ToolTip3/index.tsx







var LightTooltip3 = (0,styled_components_browser_esm/* default */.ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        placement: "top",
        arrow: true,
        classes: {
            popper: className
        },
        enterTouchDelay: 100
    }));
}).withConfig({
    componentId: "sc-36e1380a-0"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.arrow */.Z.arrow), {
        color: "white",
        "&::before": {
            backgroundColor: "#f5f5f5"
        }
    }), (0,_define_property/* default */.Z)(_obj, "& .".concat(tooltipClasses/* default.tooltip */.Z.tooltip), {
        backgroundColor: "#f5f5f5",
        color: "#8c8d8e",
        boxShadow: "red",
        fontSize: 12,
        padding: 10,
        fontWeight: 500
    }), _obj;
});

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/ItemBuyPC/RowMobile.tsx

function RowMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    ",
        " {\n        font-size: 12px;\n        font-weight: 600;\n    }\n"
    ]);
    RowMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RowMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    RowMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var RowMobile = function(param) {
    var buyAmount = param.buyAmount, itemSell = param.itemSell;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapItemMobile, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Mệnh gi\xe1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        children: Number(itemSell.price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Ng\xe0y trả lợi suất kế tiếp",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "2px",
                                        children: itemSell.paydayNextProfit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Đơn gi\xe1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "2px",
                                        children: Number(itemSell === null || itemSell === void 0 ? void 0 : itemSell.unitPrice).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mt: "1rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Ng\xe0y c\xf2n lại",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "2px",
                                        children: "".concat(itemSell.dayDiff, " ").concat(config/* UNIT_DATE */.L$)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Kỳ trả lợi suất",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "2px",
                                        children: [
                                            itemSell === null || itemSell === void 0 ? void 0 : itemSell.interVestTerm,
                                            " th\xe1ng"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Lợi suất",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "2px",
                                        children: [
                                            itemSell === null || itemSell === void 0 ? void 0 : itemSell.interVestTermRate,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ItemBuyPC_RowMobile = (RowMobile);
var WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45088f84-0"
})(RowMobile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-45088f84-1"
})(RowMobile_templateObject1());

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/ItemBuyPC/BuyModal.tsx






function BuyModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n    width:14%;\n"
    ]);
    BuyModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BuyModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 1.5rem;\n    display: flex;\n    flex-direction: row-reverse;\n    button {\n        min-width: 200px;\n    }\n    @media screen and (max-width: 1000px) {\n        flex-direction: column;\n        width: 100%;\n        gap: 1rem;\n        button {\n            min-width: 100%;\n        }\n    }\n"
    ]);
    BuyModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BuyModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    display: block;\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n"
    ]);
    BuyModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BuyModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 22px;\n    height: 22px;\n    display: none;\n    @media screen and (max-width: 768px) {\n        display: block;\n    }\n"
    ]);
    BuyModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BuyModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 28px;\n    @media screen and (max-width: 586px) {\n        font-size: 24px;\n    }\n"
    ]);
    BuyModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BuyModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 1.5rem;\n    align-items: center;\n    flex-direction: column;\n    @media screen and (max-width: 1024px) {\n        display: none;\n    }\n    @media screen and (max-width: 600px) {\n        margin-top: 0.5rem;\n        margin-bottom: 0.5rem;\n    }\n    ",
        " {\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 1.5;\n        color: ",
        ";\n        &:last-child {\n            text-decoration: underline;\n        }\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 14px;\n        }\n    }\n"
    ]);
    BuyModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BuyModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    transition: 0.5s;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        height: 40px;\n        font-size: 14px;\n        min-width: 230px;\n        border-radius: 4px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    BuyModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BuyModal_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: underline;\n    font-size: 16px;\n    padding: 0px;\n    height: fit-content;\n    font-weight: 700;\n    line-height: 1.5;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 14px;\n    }\n    cursor: pointer;\n"
    ]);
    BuyModal_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BuyModal_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: ",
        ";\n"
    ]);
    BuyModal_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BuyModal_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    min-width: 220px;\n    margin-left: 40px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1024px) {\n        min-width: 120px;\n    }\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 40px;\n        color: ",
        ";\n    }\n"
    ]);
    BuyModal_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function BuyModal_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2rem;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    display: grid;\n    gap: 2rem;\n    @media screen and (max-width: 1024px) {\n        gap: 1rem;\n        flex-direction: column;\n        display: flex;\n    }\n"
    ]);
    BuyModal_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    ",
        " {\n        font-size: 14px;\n        @media screen and (max-width: 1000px) {\n            font-size: 12px;\n        }\n    }\n    @media screen and (max-width: 1024px) {\n        width: 100%;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 12px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px 0;\n    min-width: 990px;\n    @media screen and (max-width: 768px) {\n        min-width: 90%;\n        padding: 0;\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: 1px solid ",
        ";\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 230px;\n    border-radius: 12px;\n    color: ",
        ";\n    transition: 0.5s;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        height: 40px;\n        font-size: 14px;\n        min-width: 230px;\n        border-radius: 4px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}

















var BuyModal = function(_param) {
    var handleOpenLink = function handleOpenLink(address) {
        window.open((0,utils/* getBlockExploreLink */.C)(address, "address", chainId));
    };
    var title = _param.title, onDismiss = _param.onDismiss, windowSize = _param.windowSize, listItem = _param.listItem, listCart = _param.listCart, account = _param.account, totalPrice = _param.totalPrice, chainId = _param.chainId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "onDismiss",
        "windowSize",
        "listItem",
        "listCart",
        "account",
        "totalPrice",
        "chainId"
    ]);
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref2 = useDownloadPDF(), loading = ref2.loading, handleDownload = ref2.handleDownload;
    var dispatch = (0,es/* useDispatch */.I0)();
    var marketplaceAddress = renderMarketplaceAddress(chainId);
    var token = renderToken(chainId);
    var dataMarketplace = GetDataMarketplace();
    var isNotEnoughBalance = new bignumber/* default */.Z(dataMarketplace === null || dataMarketplace === void 0 ? void 0 : (ref = dataMarketplace.dataUser) === null || ref === void 0 ? void 0 : ref.balance).isLessThan(totalPrice);
    var isAllowance = new bignumber/* default */.Z(dataMarketplace === null || dataMarketplace === void 0 ? void 0 : (ref1 = dataMarketplace.dataUser) === null || ref1 === void 0 ? void 0 : ref1.allowance).isLessThan(totalPrice);
    var ref3 = useBuyItem(marketplaceAddress, account, chainId, listCart, onDismiss), handleBuyItems = ref3.handleBuyItems, loadingBuyItems = ref3.pendingTx;
    var ref4 = useApprove(marketplaceAddress, token.address, account, chainId), handleApprove = ref4.handleApprove, pendingTx = ref4.pendingTx;
    var handleCancel = function() {
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: []
        }));
        onDismiss();
    };
    var sAccount = (account === null || account === void 0 ? void 0 : account.length) ? "".concat(account.substring(0, 6), "...").concat(account.substring(account.length - 6)) : "";
    // for download
    var handleDownloadPDF = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var filterData, pendingEtf, transferedEtf, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                filterData = listCart.map(function(item) {
                    var checkItem = listItem.find(function(data) {
                        return Number(data.id) === Number(item.id);
                    });
                    return (0,_object_spread/* default */.Z)({}, checkItem, item);
                });
                pendingEtf = filterData.map(function(item, index) {
                    var buyAmount = Number(item.buyAmount) * item.unitPrice;
                    var STT = index + 1;
                    return {
                        numericalOrder: STT < 10 ? "0".concat(STT) : STT,
                        etfId: item.nftId,
                        parValue: "".concat(item.unitPrice.toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }), " VND"),
                        interest: "".concat(item.interVestTermRate, " %"),
                        incomingInterestDate: item.paydayNextProfit,
                        releaseDate: convertDate(item.issueDate * 1000),
                        maturityDate: convertDate(item.expireDate * 1000),
                        transferValue: "".concat(buyAmount.toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }), " VND")
                    };
                });
                transferedEtf = filterData.map(function(item, index) {
                    var STT = index + 1;
                    return {
                        numericalOrder: STT < 10 ? "0".concat(STT) : STT,
                        etfId: "".concat(item === null || item === void 0 ? void 0 : item.nftId),
                        transferDate: convertDate(Date.now())
                    };
                });
                payload = {
                    buyerWalletAddress: account,
                    sellerWalletAddress: marketplaceAddress,
                    pendingEtf: pendingEtf,
                    transferedEtf: transferedEtf,
                    transferDate: convertDate(Date.now()),
                    totalTransferValue: "".concat(Number(totalPrice.toString()).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    }), " VND")
                };
                handleDownload(payload);
                return [
                    2
                ];
            });
        });
        return function handleDownloadPDF() {
            return _ref.apply(this, arguments);
        };
    }();
    var totalTransactions = listCart.reduce(function(total, item) {
        return total + Number(item.buyAmount);
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: title,
            onDismiss: onDismiss
        }, props), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitleModal, {
                        color: "text",
                        fontWeight: "700",
                        children: t("X\xe1c nhận giao dịch")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: windowSize > 768 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperItemHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14%",
                                        children: "Số lượng mua"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyModal_CsFlexHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Kỳ trả LS"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Kỳ trả lợi suất",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyModal_CsFlexHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Mệnh gi\xe1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Mệnh gi\xe1 (VND)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14%",
                                        children: "Lợi suất"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyModal_CsFlexHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Ng\xe0y trả LS"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Ng\xe0y trả lợi suất kế tiếp",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14%",
                                        children: "Ng\xe0y c\xf2n lại"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyModal_CsFlexHeader, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Đơn gi\xe1"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Đơn gi\xe1 (VND)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            listCart.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    itemSell: listItem.find(function(data) {
                                        return Number(data.id) === Number(item.id);
                                    })
                                }), "".concat(item.id));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexWrapInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CSInfoSide, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextAddr, {
                                                fontSize: "14px",
                                                children: [
                                                    "Địa chỉ v\xed để cắt tiền thanh to\xe1n ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "Chứng chỉ Quỹ"
                                                ]
                                            }),
                                            (account === null || account === void 0 ? void 0 : account.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapAddress, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "primary",
                                                    children: sAccount
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CSInfoSide, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "textSubtle",
                                                fontWeight: "700",
                                                children: t("Tổng tiền đầu tư")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexDirection: "column",
                                                alignItems: "flex-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                fontSize: "14px",
                                                                color: "primaryBright",
                                                                fontWeight: "700",
                                                                children: Number(totalPrice.toString()).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                fontSize: "14px",
                                                                color: "text",
                                                                fontWeight: "700",
                                                                ml: "5px",
                                                                children: "VND"
                                                            })
                                                        ]
                                                    }),
                                                    Number(totalPrice) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "#8C8D8E",
                                                                fontSize: "12px"
                                                            },
                                                            children: " (Tương đương ".concat(Number(totalPrice.toString()).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }), " điểm VNDC)")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            listCart.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC_RowMobile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    itemSell: listItem.find(function(data) {
                                        return Number(data.id) === Number(item.id);
                                    })
                                }), "".concat(item.id));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexWrapInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        style: {
                                            color: "#02111b",
                                            fontWeight: 700,
                                            fontSize: "0.875rem",
                                            width: "100%",
                                            textAlign: "left"
                                        },
                                        children: "Th\xf4ng tin chứng chỉ quỹ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CSInfoSide, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAddr, {
                                                fontSize: "14px",
                                                children: "Địa chỉ v\xed người mua"
                                            }),
                                            (account === null || account === void 0 ? void 0 : account.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                onClick: function() {
                                                    return handleOpenLink(account);
                                                },
                                                style: {
                                                    fontWeight: "600",
                                                    color: "#02111B",
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    sAccount,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CSInfoSide, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAddr, {
                                                fontSize: "14px",
                                                children: "Số lượng giao dịch (CCQ)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                style: {
                                                    fontWeight: "600",
                                                    color: "#02111B"
                                                },
                                                children: totalTransactions
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CSInfoSide, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontWeight: "700",
                                                children: t("Tổng tiền đầu tư")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "flex-end",
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                fontSize: "14px",
                                                                fontWeight: "700",
                                                                color: "primaryBright",
                                                                children: Number(totalPrice.toString()).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                color: "text",
                                                                fontWeight: "700",
                                                                ml: "5px",
                                                                children: "VND"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                color: "#8C8D8E",
                                                                fontSize: "10px"
                                                            },
                                                            children: " (Tương đương ".concat(Number(totalPrice.toString()).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            }), " điểm VNDC)")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: [
                        "1.5rem",
                        ,
                        "2rem"
                    ],
                    flexDirection: "column",
                    style: {
                        gap: "10px"
                    },
                    children: [
                        (account === null || account === void 0 ? void 0 : account.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isAllowance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonConfirm, {
                                    disabled: pendingTx || isNotEnoughBalance,
                                    onClick: handleApprove,
                                    endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                        spin: true,
                                        color: "textSubtle"
                                    }) : null,
                                    children: "Chấp thuận"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperButton, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonConfirm, {
                                    disabled: loadingBuyItems,
                                    endIcon: loadingBuyItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                        spin: true,
                                        color: "textSubtle"
                                    }) : null,
                                    onClick: handleBuyItems,
                                    children: t("X\xe1c nhận mua")
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            flexDirection: "column",
                            alignItems: "center",
                            children: [
                                isNotEnoughBalance && account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "red",
                                    children: t("Số dư %symbol% ​​của bạn kh\xf4ng đủ", {
                                        symbol: "VND"
                                    })
                                }),
                                !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "red",
                                    children: t("Kết nối v\xed của bạn để tiếp tục")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexAgree, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: t("Bằng c\xe1ch “x\xe1c nhận mua” t\xf4i đồng \xfd với")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLink, {
                            onClick: handleDownloadPDF,
                            disabled: loading || isNotEnoughBalance,
                            children: t("hợp đồng chuyển nhượng Chứng chỉ Quỹ ")
                        })
                    ]
                })
            ]
        }))
    });
};
var BuyModal_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-0"
})(BuyModal_templateObject());
var WrapperButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dc3c866-1"
})(BuyModal_templateObject1());
var CsTextVndc = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-2"
})(BuyModal_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsImgCoin = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3dc3c866-3"
})(BuyModal_templateObject3());
var CsTitleModal = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-4"
})(BuyModal_templateObject4());
var CsFlexAgree = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-5"
})(BuyModal_templateObject5(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-6"
})(BuyModal_templateObject6());
var CsLink = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text"
}).withConfig({
    componentId: "sc-3dc3c866-7"
})(BuyModal_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var TextAddr = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-8"
})(BuyModal_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var WrapAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dc3c866-9"
})(BuyModal_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsFlexWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-10"
})(BuyModal_templateObject10());
var CSInfoSide = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-11"
})(_templateObject11(), Text/* default */.Z);
var WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-12"
})(_templateObject12(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-3dc3c866-13"
})(_templateObject13());
var BuyModal_CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3dc3c866-14"
})(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
/* harmony default export */ var ItemBuyPC_BuyModal = (BuyModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/Cart/index.tsx





function Cart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: column;\n"
    ]);
    Cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Cart_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    Cart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Cart_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    Cart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Cart_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    Cart_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Cart_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 1rem;\n    width: 100%;\n    justify-content: space-between;\n    @media screen and (max-width: 768px) {\n        margin-top: 20px;\n        width: 100%;\n    }\n    ",
        " {\n        &:first-child {\n            line-height: 21px;\n            @media screen and (min-width: 601px) and (max-width: 1000px) {\n                font-size: 14px;\n            }\n            @media screen and (max-width: 768px) {\n                font-size: 12px;\n            }\n        }\n        &:last-child {\n            margin-left: 0.25rem;\n            font-weight: bold;\n            font-size: 16px;\n            line-height: 21px;\n            @media screen and (min-width: 601px) and (max-width: 1000px) {\n                font-size: 14px;\n            }\n            @media screen and (max-width: 768px) {\n                font-size: 12px;\n            }\n        }\n    }\n"
    ]);
    Cart_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Cart_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: 0.5s;\n    @media screen and (max-width: 1024px) {\n        border-radius: 4px;\n        font-size: 18px;\n        height: 40px;\n        width: 120px;\n    }\n    @media screen and (max-width: 768px) {\n        border-radius: 4px;\n        font-size: 12px;\n        height: 32px;\n        width: 90px;\n    }\n"
    ]);
    Cart_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Cart_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 0px;\n    margin: 1rem 0;\n    width: 100%;\n    @media screen and (max-width: 768px) {\n        flex-direction: column;\n        margin: 0.5rem 0 0.5rem;\n    }\n    @media screen and (max-width: 600px) {\n        padding:0px 10px 0px 10px;\n    }\n"
    ]);
    Cart_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Cart_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Cart_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Cart_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0px 6px 0px 6px;\n"
    ]);
    Cart_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Cart_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    @media screen and (max-width: 768px) {\n        justify-content: space-between;\n    }\n    ",
        " {\n        &:first-child {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 21px;\n            color: ",
        ";\n            @media screen and (max-width: 768px) {\n                font-size: 14px;\n            }\n        }\n        &:last-child {\n            margin-left: 2rem;\n            font-weight: 500;\n            font-size: 18px;\n            line-height: 21px;\n            color: ",
        ";\n            @media screen and (max-width: 768px) {\n                font-size: 14px;\n            }\n        }\n    }\n"
    ]);
    Cart_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}














var Cart = function(param) {
    var listItem = param.listItem, windowSize = param.windowSize, listCart = param.listCart;
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var handleCancel = function(id) {
        var dataFilter = listCart.filter(function(item) {
            return Number(item === null || item === void 0 ? void 0 : item.id) !== Number(id);
        });
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: dataFilter
        }));
    };
    var handleChangeAmountBuy = function(amount, id, addresses, buys) {
        var data = (0,_to_consumable_array/* default */.Z)(listCart);
        var index = listCart.findIndex(function(item) {
            return item.id === id;
        });
        data.splice(index, 1, {
            buyAmount: Number(amount),
            id: id,
            addresses: addresses,
            buys: buys
        });
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: data
        }));
    };
    var total = (0,react.useMemo)(function() {
        return totalPrice(listCart, listItem);
    }, [
        listCart,
        listItem
    ]);
    var totalAmountBuy = (0,react.useMemo)(function() {
        return totalItems(listCart);
    }, [
        listCart
    ]);
    var convertTotal = new bignumber/* default */.Z(total).decimalPlaces(2, 1);
    var isGreaterthan1M = new bignumber/* default */.Z(total).isLessThan(constants/* NUMBER1M */.Q2);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC_BuyModal, {
        chainId: chainId,
        listItem: listItem,
        listCart: listCart,
        windowSize: windowSize,
        title: "X\xe1c nhận giao dịch",
        account: account,
        totalPrice: convertTotal.toString()
    }), true, true, "buy_item_".concat(account)), 1), onBuyModal = ref1[0];
    var isNaNTotal = new bignumber/* default */.Z(convertTotal).isNaN();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperChose, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsListBuy, {
                children: (listCart === null || listCart === void 0 ? void 0 : listCart.length) !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsChoseBuy, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WraperAmountCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            fontWeight: "700",
                                            children: "Bấm chọn để th\xeam v\xe0o giỏ h\xe0ng:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: new bignumber/* default */.Z(totalAmountBuy).isNaN() ? "0" : Number(totalAmountBuy.toString()).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    flexDirection: "column",
                                    width: [
                                        "100%",
                                        "100%",
                                        "60%"
                                    ],
                                    pr: [
                                        "0px",
                                        ,
                                        "20px"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalAndBuy, {
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    color: "textDisabled",
                                                    fontSize: "18px",
                                                    children: "Tổng tiền đầu tư:"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontWeight: "700",
                                                            fontSize: "18px",
                                                            color: "primaryBright",
                                                            children: new bignumber/* default */.Z(convertTotal).isNaN() ? "0" : Number(convertTotal.toString()).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontWeight: "700",
                                                            fontSize: "18px",
                                                            style: {
                                                                marginLeft: "5px"
                                                            },
                                                            children: "VND"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonBuy, {
                                                    disabled: isGreaterthan1M || !account || isNaNTotal,
                                                    style: {
                                                        minWidth: "112px",
                                                        height: "40px",
                                                        borderRadius: "4px"
                                                    },
                                                    onClick: onBuyModal,
                                                    children: t("Mua")
                                                })
                                            ]
                                        }),
                                        !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            width: "100%",
                                            justifyContent: "flex-end",
                                            mt: "3px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "primaryBright",
                                                small: true,
                                                children: "Kết nối v\xed để tiếp tục"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                            children: listCart.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemBuyPC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    index: index,
                                    handleCancel: handleCancel,
                                    handleChangeAmountBuy: handleChangeAmountBuy
                                }, item), {
                                    listItem: listItem.find(function(data) {
                                        return Number(data.id) === Number(item.id);
                                    })
                                }), "".concat(item.id));
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperChoseMobile, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsListBuyMobile, {
                children: (listCart === null || listCart === void 0 ? void 0 : listCart.length) !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexBuyMobile, {
                            children: listCart.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart_ItemBuyMobile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    index: index,
                                    handleCancel: handleCancel,
                                    handleChangeAmountBuy: handleChangeAmountBuy
                                }, item), {
                                    listItem: listItem.find(function(data) {
                                        return Number(data.id) === Number(item.id);
                                    })
                                }), "".concat(item.id));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsChoseBuy, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalAndBuy, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "textDisabled",
                                                children: "Tổng tiền:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        bold: true,
                                                        color: "primary",
                                                        children: Number(convertTotal.toString()).toLocaleString("en", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        style: {
                                                            marginLeft: "5px"
                                                        },
                                                        children: "VND"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonBuy, {
                                                disabled: isGreaterthan1M,
                                                onClick: onBuyModal,
                                                children: t("Mua")
                                            })
                                        ]
                                    })
                                }),
                                !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    width: "100%",
                                    justifyContent: "flex-end",
                                    mt: "3px",
                                    pr: "10px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primaryBright",
                                        small: true,
                                        children: "Kết nối v\xed để tiếp tục"
                                    })
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        })
    });
};
/* harmony default export */ var MarketPlace_Cart = (Cart);
var CsFlexBuyMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-0"
})(Cart_templateObject());
var WrapperChoseMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aca6ccc-1"
})(Cart_templateObject1());
var CsListBuyMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aca6ccc-2"
})(Cart_templateObject2());
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-3"
})(Cart_templateObject3());
var TotalAndBuy = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-4"
})(Cart_templateObject4(), Text/* default */.Z);
var CsButtonBuy = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-5"
})(Cart_templateObject5());
var CsChoseBuy = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-6"
})(Cart_templateObject6());
var CsListBuy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aca6ccc-7"
})(Cart_templateObject7());
var WrapperChose = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aca6ccc-8"
})(Cart_templateObject8());
var WraperAmountCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-aca6ccc-9"
})(Cart_templateObject9(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ListIcon.tsx
var ListIcon = __webpack_require__(19029);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowRIghtIcon.tsx
var ArrowRIghtIcon = __webpack_require__(96640);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowLeftIcon.tsx
var ArrowLeftIcon = __webpack_require__(73482);
// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
;// CONCATENATED MODULE: ./src/views/MarketPlace/components/CustomPaginate.tsx


function CustomPaginate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color: #13486b;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n    }\n    .page-link {\n        width: 32px;\n        height: 32px;\n        display: flex;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px !important;\n        color: #02111b;\n        border: 1px solid #efefef;\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            background: #13486b;\n            color: #fff;\n            border: 1px solid #13486b !important;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n    }\n    .page-item.active .page-link {\n        background: #13486b;\n        color: #fff;\n        border: none;\n    }\n"
    ]);
    CustomPaginate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CustomPaginate = function(param) {
    var total = param.total, pageSize = param.pageSize, setItemOffset = param.setItemOffset;
    var offset = total % pageSize === 0 ? 0 : 1;
    var perPage = Math.floor(total / pageSize);
    var pageCount = perPage + offset;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), pageActive = ref[0], setPageActive = ref[1];
    var handlePageClick = function(event) {
        setPageActive(event.selected);
        setItemOffset(event.selected * pageSize);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
        width: "100%",
        mt: "1rem",
        justifyContent: "center",
        height: "62px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
            nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRIghtIcon/* default */.Z, {}),
            previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {}),
            onPageChange: handlePageClick,
            pageCount: pageCount,
            pageClassName: "page-item",
            pageLinkClassName: "page-link",
            previousClassName: "page-item",
            previousLinkClassName: "page-link",
            nextClassName: "page-item",
            nextLinkClassName: "page-link",
            breakLabel: "...",
            breakClassName: "page-item",
            breakLinkClassName: "page-link",
            containerClassName: "pagination",
            activeClassName: "active",
            renderOnZeroPageCount: null,
            forcePage: pageActive
        })
    });
};
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6f9fa3a6-0"
})(CustomPaginate_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});

;// CONCATENATED MODULE: ./src/views/MarketPlace/components/index.ts


// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(10759);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Notice.tsx
var Notice = __webpack_require__(71024);
;// CONCATENATED MODULE: ./src/views/MarketPlace/Ccq/ItemMobile/index.tsx

function ItemMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 10px;\n    font-weight: 600;\n    padding: 3px 20px;\n    border-radius: 4px;\n    letter-spacing: 0.04em;\n    text-align: center;\n    @media screen and (max-width: 475px) {\n        padding: 3px 8px;\n    }\n"
    ]);
    ItemMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding: 6px 0;\n    align-items: center;\n    justify-content: space-between;\n"
    ]);
    ItemMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 11px;\n    font-weight: 600;\n    text-align: center;\n    color: ",
        ";\n    &:first-child {\n        text-align: left;\n    }\n"
    ]);
    ItemMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 25%;\n    height: 42px;\n    align-items: center;\n    font-size:12px;\n"
    ]);
    ItemMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    color: ",
        ';\n\n    border-radius: 4px;\n    min-width: 90px;\n    height: 32px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n    @media screen and (max-width: 475px) {\n        min-width: 75px;\n    }\n\n    &:hover {\n        border: 1px solid transparent;\n        background: "#447290";\n        /* color: ',
        "; */\n    }\n"
    ]);
    ItemMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 8px 16px;\n    overflow: hidden;\n    background: ",
        ";\n    border-bottom: 1px solid ",
        ";\n"
    ]);
    ItemMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n"
    ]);
    ItemMobile_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    @media screen and (max-width: 768px) {\n        font-size: 12px;\n    }\n"
    ]);
    ItemMobile_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ItemMobile_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    cursor: pointer;\n"
    ]);
    ItemMobile_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var ItemMobile = function(param) {
    var amount = param.amount, dayDiff = param.dayDiff, id = param.id, unitPrice = param.unitPrice, handleChoose = param.handleChoose, price = param.price, interVestTerm = param.interVestTerm, interVestTermRate = param.interVestTermRate, vestingMap = param.vestingMap, paused = param.paused, addresses = param.addresses, buys = param.buys;
    var totalVested = (0,react.useMemo)(function() {
        var ref;
        return (ref = vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        return vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length;
    }, [
        vestingMap
    ]);
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextTootip, {
        style: {
            color: "red"
        },
        children: "CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!"
    }), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_WrapperBuyItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Số lượng",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                size: 12,
                                                children: "SL"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsText, {
                                    mr: "4px",
                                    ml: "2px",
                                    children: " ".concat(Number(amount).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    }))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Kỳ trả lợi suất",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "KTLS"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextMonth, {
                                    children: [
                                        interVestTerm,
                                        " th\xe1ng"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Lợi suất ng\xe0y c\xf2n lại",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "LSNCL"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsText, {
                                    mr: "4px",
                                    ml: "2px",
                                    children: [
                                        interVestTermRate,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Đơn gi\xe1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "ĐG"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsText, {
                                    mr: "4px",
                                    ml: "2px",
                                    children: Number(unitPrice).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemWarning, {
                        children: paused && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReferenceElement, {
                                    ref: targetRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notice/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: tooltipVisible && tooltip
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Mệnh gi\xe1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "MG"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsText, {
                                    mr: "4px",
                                    ml: "2px",
                                    children: Number(price).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Ng\xe0y c\xf2n lại",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "NCL"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsText, {
                                    mr: "4px",
                                    ml: "2px",
                                    children: "".concat(dayDiff, " ").concat(config/* UNIT_DATE */.L$)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsFlexHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                    title: "Kỳ đ\xe3 nhận",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                color: "#C7C9CA",
                                                mr: "4px",
                                                children: "KĐN"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemMobile_CsText, {
                                    mr: "2px",
                                    children: [
                                        totalVested,
                                        "/",
                                        totalVestingMap
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMobile_CsItem, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                            disabled: paused,
                            onClick: function() {
                                return handleChoose(id, addresses, buys);
                            },
                            children: "Chọn"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Ccq_ItemMobile = (ItemMobile);
var CsTextMonth = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-cf704861-0"
})(ItemMobile_templateObject());
var ItemMobile_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cf704861-1"
})(ItemMobile_templateObject1());
var ItemMobile_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-cf704861-2"
})(ItemMobile_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ItemMobile_CsItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cf704861-3"
})(ItemMobile_templateObject3());
var CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-cf704861-4"
})(ItemMobile_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var ItemMobile_WrapperBuyItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf704861-5"
})(ItemMobile_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var ItemMobile_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cf704861-6"
})(ItemMobile_templateObject6());
var CsTextTootip = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-cf704861-7"
})(ItemMobile_templateObject7());
var ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf704861-8"
})(ItemMobile_templateObject8());

;// CONCATENATED MODULE: ./src/views/MarketPlace/Ccq/ItemPC.tsx

function ItemPC_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n    border-radius: 4px;\n    min-width: 112px;\n    height: 40px;\n    &.buttonChoose{\n        &:hover:not(:disabled){\n            background: #447290;\n            color: ",
        ";\n        }\n        &:hover{\n            background-color: var(--colors-backgroundDisabled);\n            border-color: var(--colors-backgroundDisabled);\n            color: ",
        ";\n        }\n    }\n"
    ]);
    ItemPC_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemPC_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding: 0px 6px 0px 6px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center top;\n"
    ]);
    ItemPC_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemPC_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    height: 70px;\n    align-items: center;\n    background: rgba(255, 255, 255, 0.62);\n    &::after {\n        content: "";\n        position: absolute;\n        left: 19%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ';\n    }\n    &::before {\n        content: "";\n        position: absolute;\n        right: 33.5%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ";\n    }\n    &:hover {\n        background: ",
        ";\n    }\n    button {\n        transition: 0.5s;\n        &:hover {\n            background: ",
        ";\n            color: ",
        ";\n            border: 1px solid transparent;\n        }\n    }\n    ",
        " {\n        height: 100%;\n        align-items:center\n    }\n"
    ]);
    ItemPC_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemPC_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    @media screen and (max-width: 768px) {\n        font-size: 12px;\n    }\n"
    ]);
    ItemPC_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ItemPC_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n    cursor: pointer;\n"
    ]);
    ItemPC_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Item = function(param) {
    var amount = param.amount, price = param.price, interVestTerm = param.interVestTerm, handleChoose = param.handleChoose, id = param.id, interVestTermRate = param.interVestTermRate, paydayNextProfit = param.paydayNextProfit, unitPrice = param.unitPrice, dayDiff = param.dayDiff, vestingMap = param.vestingMap, paused = param.paused, nftAddress = param.nftAddress, buys = param.buys;
    var totalVested = (0,react.useMemo)(function() {
        var ref;
        return (ref = vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        return vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length;
    }, [
        vestingMap
    ]);
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPC_CsTextTootip, {
        style: {
            color: "red"
        },
        children: "CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!"
    }), {
        placement: "top-end",
        tooltipOffset: [
            20,
            10
        ]
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPC_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemPC_WrapperCard, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(amount).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(price).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                    children: [
                        totalVested,
                        "/",
                        totalVestingMap
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: "".concat(interVestTerm, " th\xe1ng")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: paydayNextProfit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: "".concat(dayDiff, " ").concat(config/* UNIT_DATE */.L$)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                    children: [
                        interVestTermRate,
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                    children: Number(unitPrice).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItem, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonChoose, {
                        disabled: paused,
                        className: "buttonChoose",
                        onClick: function() {
                            handleChoose(id, nftAddress, buys);
                        },
                        children: "Chọn"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemWarning, {
                    children: paused && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPC_ReferenceElement, {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notice/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: tooltipVisible && tooltip
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ItemPC = (Item);
var CsButtonChoose = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-45d65e7-0"
})(ItemPC_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ItemPC_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45d65e7-1"
})(ItemPC_templateObject1());
var ItemPC_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-45d65e7-2"
})(ItemPC_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, CsItemSmall);
var ItemPC_CsTextTootip = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-45d65e7-3"
})(ItemPC_templateObject3());
var ItemPC_ReferenceElement = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45d65e7-4"
})(ItemPC_templateObject4());

;// CONCATENATED MODULE: ./src/views/MarketPlace/Ccq/index.tsx




function Ccq_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 18px;\n    margin: 1rem 0;\n    color: ",
        ";\n"
    ]);
    Ccq_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Ccq_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    align-items: center;\n    height: 40px;\n    padding: 0 16px;\n    background: #efefef;\n    justify-content: space-between;\n"
    ]);
    Ccq_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Ccq_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    margin-left: 14px;\n    font-size: 12px;\n"
    ]);
    Ccq_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Ccq_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    margin-right: 6px;\n    font-size: 10px;\n"
    ]);
    Ccq_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Ccq_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    Ccq_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Ccq_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    Ccq_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Ccq_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    Ccq_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










var pageSize = 7;
var Ccq = function(param) {
    var listItem = param.listItem, windowSize = param.windowSize, listCart = param.listCart;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(0), itemOffset = ref[0], setItemOffset = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChoose = function(id, addresses, buys) {
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: (0,_to_consumable_array/* default */.Z)(listCart).concat([
                {
                    buyAmount: 1,
                    id: id,
                    addresses: addresses,
                    buys: buys
                }
            ])
        }));
    };
    var filterData = listItem.filter(function(item) {
        return !listCart.find(function(data) {
            return Number(data.id === Number(item.id));
        });
    });
    var total = filterData.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnotherCCQ, {
                children: [
                    (listCart === null || listCart === void 0 ? void 0 : listCart.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeAnother, {
                        children: "Xem th\xeam c\xe1c Chứng chỉ Quỹ kh\xe1c"
                    }),
                    (listItem === null || listItem === void 0 ? void 0 : listItem.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Ccq_CsFlex, {
                        children: filterData.splice(itemOffset, pageSize).map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemPC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                handleChoose: handleChoose
                            }));
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AnotherCCQ, {
                children: (listItem === null || listItem === void 0 ? void 0 : listItem.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexAnother, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListIcon/* default */.Z, {}),
                                        (listCart === null || listCart === void 0 ? void 0 : listCart.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAnother, {
                                            children: t("Xem th\xeam c\xe1c Chứng chỉ Quỹ kh\xe1c")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextAddToCart, {
                                        children: t("Th\xeam v\xe0o giỏ")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexMobile, {
                            children: filterData.splice(itemOffset, pageSize).map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Ccq_ItemMobile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    handleChoose: handleChoose
                                }));
                            })
                        })
                    ]
                })
            }),
            (listItem === null || listItem === void 0 ? void 0 : listItem.length) > 7 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPaginate, {
                total: total,
                pageSize: pageSize,
                setItemOffset: setItemOffset
            })
        ]
    });
};
/* harmony default export */ var MarketPlace_Ccq = (Ccq);
var SeeAnother = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-0"
})(Ccq_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var FlexAnother = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-1"
})(Ccq_templateObject1());
var TextAnother = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-2"
})(Ccq_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var TextAddToCart = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-3"
})(Ccq_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var AnotherCCQ = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae0eb9f5-4"
})(Ccq_templateObject4());
var Ccq_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-5"
})(Ccq_templateObject5());
var CsFlexMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae0eb9f5-6"
})(Ccq_templateObject6());

// EXTERNAL MODULE: ./src/config/constants/ccqSupport/constants/index.ts
var ccqSupport_constants = __webpack_require__(88175);
;// CONCATENATED MODULE: ./src/state/Order/fetchData.ts









var fetchListOrder = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ccqConfig, account, chainId) {
        var calls, callsPaused, index, ref, ref1, index1, ref2, ref3, result, resulCallsPaused, listItems, index2, ref4, subIndex, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, resultListItemOrder, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                        3,
                        4
                    ];
                    calls = [];
                    callsPaused = [];
                    for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                        ;
                        calls.push({
                            address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                            name: "getListingP2P",
                            params: [
                                account
                            ]
                        });
                    }
                    for(index1 = 0; index1 < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index1++){
                        ;
                        callsPaused.push({
                            address: (ref2 = ccqConfig[index1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address,
                            name: "paused",
                            params: []
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, callsPaused, chainId)
                    ];
                case 2:
                    resulCallsPaused = _state.sent();
                    listItems = [];
                    if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
                        for(index2 = 0; index2 < (result === null || result === void 0 ? void 0 : result.length); index2++){
                            ;
                            for(subIndex = 0; subIndex < ((ref4 = result[index2][0]) === null || ref4 === void 0 ? void 0 : ref4.length); subIndex++){
                                ;
                                listItems.push({
                                    isSelling: (ref5 = result[index2][0][subIndex]) === null || ref5 === void 0 ? void 0 : ref5.isSelling,
                                    user: (ref6 = result[index2][0][subIndex]) === null || ref6 === void 0 ? void 0 : ref6.user,
                                    dateTrading: Number(new bignumber/* default */.Z((ref7 = result[index2][0][subIndex]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.sellDate) === null || ref8 === void 0 ? void 0 : ref8.toString()).toString()),
                                    amountTrading: Number(new bignumber/* default */.Z((ref9 = result[index2][0][subIndex]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.amount) === null || ref10 === void 0 ? void 0 : ref10.toString()).toString()),
                                    addressTrading: (ref11 = result[index2][0][subIndex]) === null || ref11 === void 0 ? void 0 : ref11.user,
                                    nftAddress: (ref12 = ccqConfig[index2]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.ccqWrrapped) === null || ref13 === void 0 ? void 0 : ref13.address,
                                    nftId: Number(new bignumber/* default */.Z((ref14 = result[index2][0][subIndex]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.tokenId) === null || ref15 === void 0 ? void 0 : ref15.toString()).toString()),
                                    price: Number(new bignumber/* default */.Z((ref16 = result[index2][0][subIndex]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.price) === null || ref17 === void 0 ? void 0 : ref17.toString()).dividedBy(1E18).toString()),
                                    orderId: Number(new bignumber/* default */.Z((ref18 = result[index2][0][subIndex]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.orderId) === null || ref19 === void 0 ? void 0 : ref19.toString()).toString()),
                                    paused: resulCallsPaused[index2][0]
                                });
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(listItems.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                var ref, getTermByTime;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0,multicall/* default */.Z)(ccqWrappedAbi, [
                                                    {
                                                        address: item.nftAddress,
                                                        name: "getTermByTime",
                                                        params: [
                                                            item.dateTrading
                                                        ]
                                                    }
                                                ], chainId)
                                            ];
                                        case 1:
                                            getTermByTime = _state.sent();
                                            return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                                    termByTime: new bignumber/* default */.Z((ref = getTermByTime[0]) === null || ref === void 0 ? void 0 : ref.toString()).toNumber()
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(item) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 3:
                    resultListItemOrder = _state.sent();
                    return [
                        2,
                        {
                            listItemOrder: resultListItemOrder
                        }
                    ];
                case 4:
                    return [
                        2,
                        {
                            listItemOrder: []
                        }
                    ];
                case 5:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listItemOrder: []
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchListOrder(ccqConfig, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tokenAddres, activeCCQ, account, chainId) {
        var calls, index, ref, ref1, result, data, index1, ref2, ref3, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [];
                    for(index = 0; index < (activeCCQ === null || activeCCQ === void 0 ? void 0 : activeCCQ.length); index++){
                        ;
                        calls.push({
                            address: tokenAddres,
                            name: "allowance",
                            params: [
                                account,
                                (ref = activeCCQ[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address
                            ]
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                    ];
                case 1:
                    result = _state.sent();
                    data = [];
                    if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
                        for(index1 = 0; index1 < (result === null || result === void 0 ? void 0 : result.length); index1++){
                            ;
                            data.push({
                                nftAddress: (ref2 = activeCCQ[index1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address,
                                allowance: new bignumber/* default */.Z(result[index1].toString()).toString()
                            });
                        }
                    }
                    return [
                        2,
                        {
                            listAllowanc: data
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            listAllowanc: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataUser(tokenAddres, activeCCQ, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tokenAddres, account, chainId) {
        var calls, ref, result, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [
                        {
                            address: tokenAddres,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0];
                    return [
                        2,
                        {
                            balance: new bignumber/* default */.Z(result === null || result === void 0 ? void 0 : result.toString()).toString()
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            balance: "0"
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataBalance(tokenAddres, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchVestingMap = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(listItem, chainId, account) {
        var calls, currTime, index, ref, ref1, ref2, resultGetMyVestList, resultParse, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [];
                    currTime = Date.now();
                    for(index = 0; index < (listItem === null || listItem === void 0 ? void 0 : listItem.length); index++){
                        ;
                        calls.push({
                            address: (ref = listItem[index]) === null || ref === void 0 ? void 0 : ref.nftAddress,
                            name: "getMyVestList",
                            params: [
                                (ref1 = listItem[index]) === null || ref1 === void 0 ? void 0 : ref1.nftAddress,
                                (ref2 = listItem[index]) === null || ref2 === void 0 ? void 0 : ref2.nftId
                            ]
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                    ];
                case 1:
                    resultGetMyVestList = _state.sent();
                    resultParse = listItem === null || listItem === void 0 ? void 0 : listItem.map(function(item, key) {
                        var ref;
                        var resultVestingMap = (ref = resultGetMyVestList[key][0]) === null || ref === void 0 ? void 0 : ref.map(function(res, i) {
                            return {
                                amount: new bignumber/* default */.Z(res === null || res === void 0 ? void 0 : res.amount.toString()).toString(),
                                isVested: res === null || res === void 0 ? void 0 : res.isVested,
                                vestDate: Number(new bignumber/* default */.Z(res === null || res === void 0 ? void 0 : res.vestDate.toString()).toString()),
                                intervestPayed: new bignumber/* default */.Z(res === null || res === void 0 ? void 0 : res.intervestPayed.toString()).toString(),
                                termTime: i + 1
                            };
                        });
                        var nextVestingMap = resultVestingMap.find(function(d) {
                            return currTime < (d === null || d === void 0 ? void 0 : d.vestDate) * 1000;
                        });
                        var currencyTermTime = nextVestingMap ? nextVestingMap.termTime : 0;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                            vestingMap: resultVestingMap,
                            currencyTermTime: currencyTermTime,
                            isBuyP2P: currencyTermTime === item.termByTime
                        });
                    });
                    return [
                        2,
                        {
                            listItemOrder: resultParse
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listItemOrder: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchVestingMap(listItem, chainId, account) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/asset/fetchData.ts










var fetchDataAssetItems = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ccqConfig, account, chainId) {
        var calls, index, ref, ref1, result, listItems, index1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                        3,
                        2
                    ];
                    calls = [];
                    for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                        ;
                        calls.push({
                            address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                            name: "etfInfor",
                            params: []
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                    ];
                case 1:
                    result = _state.sent();
                    listItems = [];
                    if ((result === null || result === void 0 ? void 0 : result.length) > 0) {
                        for(index1 = 0; index1 < (result === null || result === void 0 ? void 0 : result.length); index1++){
                            ;
                            listItems.push({
                                nftAddress: (ref2 = ccqConfig[index1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address,
                                expireDate: Number(new bignumber/* default */.Z((ref4 = result[index1]) === null || ref4 === void 0 ? void 0 : ref4.expireDate.toString()).toString()),
                                intervestTerm: Number(new bignumber/* default */.Z((ref5 = result[index1]) === null || ref5 === void 0 ? void 0 : ref5.intervestTerm.toString()).toString()),
                                issueDate: Number(new bignumber/* default */.Z((ref6 = result[index1]) === null || ref6 === void 0 ? void 0 : ref6.issueDate.toString()).toString()),
                                ccqName: (ref7 = result[index1]) === null || ref7 === void 0 ? void 0 : ref7.name,
                                denominations: Number(new bignumber/* default */.Z((ref8 = result[index1]) === null || ref8 === void 0 ? void 0 : ref8.price.toString()).dividedBy(1E18).toString()),
                                publisher: (ref9 = result[index1]) === null || ref9 === void 0 ? void 0 : ref9.publisher,
                                totalSupply: Number(new bignumber/* default */.Z((ref10 = result[index1]) === null || ref10 === void 0 ? void 0 : ref10.totalSupply.toString()).toString())
                            });
                        }
                    }
                    return [
                        2,
                        {
                            listWrappedItem: listItems
                        }
                    ];
                case 2:
                    return [
                        2,
                        {
                            listWrappedItem: []
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listWrappedItem: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataAssetItems(ccqConfig, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchData_fetchDataUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ccqConfig, account, chainId) {
        var fetchApproved, fetchBalance, ref, resultApproved, resultBalance, result, index, ref1, ref2, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    fetchApproved = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var callsAllowance, index, ref, ref1, ref2, ref3, resultAllowance;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        callsAllowance = [];
                                        for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                                            ;
                                            callsAllowance.push({
                                                address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                                                name: "isApprovedForAll",
                                                params: [
                                                    account,
                                                    (ref2 = ccqConfig[index]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address
                                                ]
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callsAllowance, chainId)
                                        ];
                                    case 1:
                                        resultAllowance = _state.sent();
                                        return [
                                            2,
                                            resultAllowance
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                        return function fetchApproved() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    fetchBalance = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var callsBalance, index, ref, ref1, ref2, ref3, resultBalance;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        callsBalance = [];
                                        for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                                            ;
                                            callsBalance.push({
                                                address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                                                name: "balanceOf",
                                                params: [
                                                    account,
                                                    (ref2 = ccqConfig[index]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address
                                                ]
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, callsBalance, chainId)
                                        ];
                                    case 1:
                                        resultBalance = _state.sent();
                                        return [
                                            2,
                                            resultBalance
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                        return function fetchBalance() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        Promise.all([
                            fetchApproved(),
                            fetchBalance()
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), resultApproved = ref[0], resultBalance = ref[1];
                    result = [];
                    if (resultApproved !== null && resultBalance !== null) {
                        for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                            ;
                            result.push({
                                nftAddress: (ref1 = ccqConfig[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ccqWrrapped) === null || ref2 === void 0 ? void 0 : ref2.address,
                                isApproved: false,
                                balance: "0"
                            });
                        }
                    }
                    return [
                        2,
                        {
                            dataUser: []
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            dataUser: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataUser(ccqConfig, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchIntervestTermRate = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ccqConfig, chainId) {
        var callsIntervest, index, ref, ref1, resultIntervest, result, index1, ref2, ref3, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!((ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length) > 0)) return [
                        3,
                        2
                    ];
                    callsIntervest = [];
                    for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                        ;
                        callsIntervest.push({
                            address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                            name: "intervestTermRate",
                            params: []
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, callsIntervest, chainId)
                    ];
                case 1:
                    resultIntervest = _state.sent();
                    result = [];
                    if (resultIntervest === null || resultIntervest === void 0 ? void 0 : resultIntervest.length) {
                        for(index1 = 0; index1 < (resultIntervest === null || resultIntervest === void 0 ? void 0 : resultIntervest.length); index1++){
                            ;
                            result.push({
                                intervest: new bignumber/* default */.Z(resultIntervest[index1].toString()).dividedBy(constants/* BASE_RATE_INTERVEST */.ie).multipliedBy(10).toString(),
                                nftAddress: (ref2 = ccqConfig[index1]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ccqWrrapped) === null || ref3 === void 0 ? void 0 : ref3.address
                            });
                        }
                    }
                    return [
                        2,
                        {
                            listIntervestRate: result
                        }
                    ];
                case 2:
                    return [
                        2,
                        {
                            listIntervestRate: []
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            listIntervestRate: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchIntervestTermRate(ccqConfig, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUserAssest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(ccqConfig, account, chainId) {
        var calls, index, ref, ref1, result, data, index1, ref2, subIndex, ref3, ref4, ref5, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                        3,
                        2
                    ];
                    calls = [];
                    for(index = 0; index < (ccqConfig === null || ccqConfig === void 0 ? void 0 : ccqConfig.length); index++){
                        ;
                        calls.push({
                            address: (ref = ccqConfig[index]) === null || ref === void 0 ? void 0 : (ref1 = ref.ccqWrrapped) === null || ref1 === void 0 ? void 0 : ref1.address,
                            name: "getMyAsset",
                            params: [
                                account
                            ]
                        });
                    }
                    return [
                        4,
                        (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                    ];
                case 1:
                    result = _state.sent();
                    data = [];
                    for(index1 = 0; index1 < (result === null || result === void 0 ? void 0 : result.length); index1++){
                        ;
                        for(subIndex = 0; subIndex < ((ref2 = result[index1][0]) === null || ref2 === void 0 ? void 0 : ref2.length); subIndex++){
                            ;
                            data.push({
                                nftAddress: (ref3 = ccqConfig[index1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.ccqWrrapped) === null || ref4 === void 0 ? void 0 : ref4.address,
                                nftId: Number(new bignumber/* default */.Z((ref5 = result[index1][0][subIndex]) === null || ref5 === void 0 ? void 0 : ref5.toString()).toString())
                            });
                        }
                    }
                    return [
                        2,
                        {
                            listUserAsset: data
                        }
                    ];
                case 2:
                    return [
                        2,
                        {
                            listUserAsset: []
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listUserAsset: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserAssest(ccqConfig, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUserBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(listUserAsset, listWrappedItem, listIntervestRate, account, chainId, listOrder) {
        var currTime, _loop, getBalance, getApproveForAll, getVestingMap, getPaused, getHoldingDate, ref, resultBalance, resultVestingMap, resultApprovedForAll, resultGetPaused, resultGetHoldingDate, data, index, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currTime = Date.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _loop = function(index) {
                        var ref, ref1, ref2, ref3;
                        var assetItem = listWrappedItem.find(function(item) {
                            var ref, ref1, ref2;
                            return (item === null || item === void 0 ? void 0 : (ref = item.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = listUserAsset[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nftAddress) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase());
                        });
                        var resultListOrder = listOrder.find(function(item) {
                            var ref, ref1, ref2;
                            return (item === null || item === void 0 ? void 0 : (ref = item.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = listUserAsset[index]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nftAddress) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase());
                        });
                        var dataVestingMap = [];
                        for(var vestingMap = 0; vestingMap < ((ref = resultVestingMap[index][0]) === null || ref === void 0 ? void 0 : ref.length); vestingMap++){
                            var ref4, ref5, ref6, ref7, ref8, ref9, ref10;
                            dataVestingMap.push({
                                vestAmount: new bignumber/* default */.Z((ref4 = resultVestingMap[index][0][vestingMap]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.amount) === null || ref5 === void 0 ? void 0 : ref5.toString()).dividedBy(1E18).toString(),
                                isVested: (ref6 = resultVestingMap[index][0][vestingMap]) === null || ref6 === void 0 ? void 0 : ref6.isVested,
                                nextInterestPaymentDate: Number(new bignumber/* default */.Z((ref7 = resultVestingMap[index][0][vestingMap]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.vestDate) === null || ref8 === void 0 ? void 0 : ref8.toString()).toString()),
                                intervestPayed: new bignumber/* default */.Z((ref9 = resultVestingMap[index][0][vestingMap]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.intervestPayed) === null || ref10 === void 0 ? void 0 : ref10.toString()).toString(),
                                index: vestingMap
                            });
                        }
                        var nextVestingMap = dataVestingMap.find(function(d) {
                            return currTime < d.nextInterestPaymentDate * 1000;
                        });
                        var checkDayDiff = moment_default()(moment_default()(Number(nextVestingMap === null || nextVestingMap === void 0 ? void 0 : nextVestingMap.nextInterestPaymentDate) * 1000)).diff(moment_default()(Number(Date.now())), config/* UNITDIFF */.Wt);
                        data.push({
                            nftBalance: new bignumber/* default */.Z((ref1 = resultBalance[index][0]) === null || ref1 === void 0 ? void 0 : ref1.toString()).toNumber(),
                            expireDate: assetItem === null || assetItem === void 0 ? void 0 : assetItem.expireDate,
                            intervestTerm: (assetItem === null || assetItem === void 0 ? void 0 : assetItem.intervestTerm) === 92 ? 3 : 6,
                            issueDate: assetItem === null || assetItem === void 0 ? void 0 : assetItem.issueDate,
                            ccqName: assetItem === null || assetItem === void 0 ? void 0 : assetItem.ccqName,
                            denominations: assetItem === null || assetItem === void 0 ? void 0 : assetItem.denominations,
                            publisher: assetItem === null || assetItem === void 0 ? void 0 : assetItem.publisher,
                            totalSupply: assetItem === null || assetItem === void 0 ? void 0 : assetItem.totalSupply,
                            nftAddress: assetItem === null || assetItem === void 0 ? void 0 : assetItem.nftAddress,
                            nftId: (ref2 = listUserAsset[index]) === null || ref2 === void 0 ? void 0 : ref2.nftId,
                            isExpire: currTime > (assetItem === null || assetItem === void 0 ? void 0 : assetItem.expireDate) * 1000,
                            profit: (assetItem === null || assetItem === void 0 ? void 0 : assetItem.intervestTerm) === 92 ? 8 : 9.2,
                            vestingMap: dataVestingMap.filter(function(d) {
                                return (d === null || d === void 0 ? void 0 : d.isVested) === false;
                            }),
                            isApprovedForAll: resultApprovedForAll[index][0],
                            fullVestingMap: dataVestingMap,
                            dayDiff: checkDayDiff + 1 > 92 ? 92 : checkDayDiff + 1,
                            paused: resultGetPaused[index][0],
                            holdingDate: new bignumber/* default */.Z((ref3 = resultGetHoldingDate[index][0]) === null || ref3 === void 0 ? void 0 : ref3.toString()).toNumber(),
                            isOder: !!resultListOrder,
                            orderBy: resultListOrder
                        });
                    };
                    getBalance = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var calls, index, ref, ref1, result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        calls = [];
                                        for(index = 0; index < (listUserAsset === null || listUserAsset === void 0 ? void 0 : listUserAsset.length); index++){
                                            ;
                                            calls.push({
                                                address: (ref = listUserAsset[index]) === null || ref === void 0 ? void 0 : ref.nftAddress,
                                                name: "balanceOf",
                                                params: [
                                                    account,
                                                    (ref1 = listUserAsset[index]) === null || ref1 === void 0 ? void 0 : ref1.nftId
                                                ]
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            result
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                        return function getBalance() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getApproveForAll = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var calls, index, ref, ref1, result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        calls = [];
                                        for(index = 0; index < (listUserAsset === null || listUserAsset === void 0 ? void 0 : listUserAsset.length); index++){
                                            ;
                                            calls.push({
                                                address: (ref = listUserAsset[index]) === null || ref === void 0 ? void 0 : ref.nftAddress,
                                                name: "isApprovedForAll",
                                                params: [
                                                    account,
                                                    (ref1 = listUserAsset[index]) === null || ref1 === void 0 ? void 0 : ref1.nftAddress
                                                ]
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            result
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                        return function getApproveForAll() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getVestingMap = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var calls, index, ref, ref1, result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!((account === null || account === void 0 ? void 0 : account.length) > 0)) return [
                                            3,
                                            2
                                        ];
                                        calls = [];
                                        for(index = 0; index < (listUserAsset === null || listUserAsset === void 0 ? void 0 : listUserAsset.length); index++){
                                            ;
                                            calls.push({
                                                address: (ref = listUserAsset[index]) === null || ref === void 0 ? void 0 : ref.nftAddress,
                                                name: "getMyVestList",
                                                params: [
                                                    account,
                                                    (ref1 = listUserAsset[index]) === null || ref1 === void 0 ? void 0 : ref1.nftId
                                                ]
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            result
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            null
                                        ];
                                }
                            });
                        });
                        return function getVestingMap() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getPaused = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var calls, index, ref, result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        calls = [];
                                        for(index = 0; index < (listUserAsset === null || listUserAsset === void 0 ? void 0 : listUserAsset.length); index++){
                                            ;
                                            calls.push({
                                                address: (ref = listUserAsset[index]) === null || ref === void 0 ? void 0 : ref.nftAddress,
                                                name: "paused",
                                                params: []
                                            });
                                        }
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            result
                                        ];
                                }
                            });
                        });
                        return function getPaused() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    getHoldingDate = function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function() {
                            var calls, result;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        calls = listUserAsset.map(function(item) {
                                            return {
                                                address: item.nftAddress,
                                                name: "getHoldingDate",
                                                params: [
                                                    account,
                                                    item.nftId
                                                ]
                                            };
                                        });
                                        return [
                                            4,
                                            (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                                        ];
                                    case 1:
                                        result = _state.sent();
                                        return [
                                            2,
                                            result
                                        ];
                                }
                            });
                        });
                        return function getHoldingDate() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    return [
                        4,
                        Promise.all([
                            getBalance(),
                            getVestingMap(),
                            getApproveForAll(),
                            getPaused(),
                            getHoldingDate()
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        5
                    ]), resultBalance = ref[0], resultVestingMap = ref[1], resultApprovedForAll = ref[2], resultGetPaused = ref[3], resultGetHoldingDate = ref[4];
                    data = [];
                    for(index = 0; index < (resultBalance === null || resultBalance === void 0 ? void 0 : resultBalance.length); index++)_loop(index);
                    return [
                        2,
                        {
                            listUserBalance: data.filter(function(item) {
                                return Number(item === null || item === void 0 ? void 0 : item.nftBalance) !== 0;
                            })
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            listUserBalance: []
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserBalance(listUserAsset, listWrappedItem, listIntervestRate, account, chainId, listOrder) {
        return _ref.apply(this, arguments);
    };
}();
var fetchDataBalanceAccount = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(tokenAddres, account, chainId) {
        var calls, ref, result, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    calls = [
                        {
                            address: tokenAddres,
                            name: "balanceOf",
                            params: [
                                account
                            ]
                        }
                    ];
                    return [
                        4,
                        (0,multicall/* default */.Z)(erc20/* ERC20_ABI */.RB, calls, chainId)
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0];
                    return [
                        2,
                        {
                            balance: new bignumber/* default */.Z(result === null || result === void 0 ? void 0 : result.toString()).toString()
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        {
                            balance: "0"
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDataBalanceAccount(tokenAddres, account, chainId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/asset/index.ts











var GetItemAsset = function() {
    var data = useSelector(function(state) {
        return state.asset;
    });
    var itemAssetValue = data === null || data === void 0 ? void 0 : data.itemAsset;
    return itemAssetValue;
};
var UseCoreAsset = function(tokenSupport, account, chainId) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var messageHash = GetDataAsset().messageHash;
    (0,react.useEffect)(function() {
        var getDataAsset = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var activeCCQ, listItemOrder, resultWrappedInfo, resultAsset, resultInvertRate, resultBalance, resultBalanceAccount, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                8,
                                ,
                                9
                            ]);
                            return [
                                4,
                                (0,ccqSupport_constants.UseActiveCCQ)(chainId)
                            ];
                        case 1:
                            activeCCQ = _state.sent();
                            dispatch((0,asset_actions/* fetchStatusLoading */.Xy)({
                                isLoading: true
                            }));
                            return [
                                4,
                                fetchListOrder(activeCCQ, account, chainId)
                            ];
                        case 2:
                            listItemOrder = _state.sent().listItemOrder;
                            return [
                                4,
                                fetchDataAssetItems(activeCCQ, account, chainId)
                            ];
                        case 3:
                            resultWrappedInfo = _state.sent();
                            return [
                                4,
                                fetchUserAssest(activeCCQ, account, chainId)
                            ];
                        case 4:
                            resultAsset = _state.sent();
                            return [
                                4,
                                fetchIntervestTermRate(activeCCQ, chainId)
                            ];
                        case 5:
                            resultInvertRate = _state.sent();
                            return [
                                4,
                                fetchUserBalance(resultAsset === null || resultAsset === void 0 ? void 0 : resultAsset.listUserAsset, resultWrappedInfo === null || resultWrappedInfo === void 0 ? void 0 : resultWrappedInfo.listWrappedItem, resultInvertRate === null || resultInvertRate === void 0 ? void 0 : resultInvertRate.listIntervestRate, account, chainId, listItemOrder)
                            ];
                        case 6:
                            resultBalance = _state.sent();
                            return [
                                4,
                                fetchDataBalanceAccount(tokenSupport, account, chainId)
                            ];
                        case 7:
                            resultBalanceAccount = _state.sent();
                            dispatch((0,asset_actions/* fetchAssetItems */.v$)(resultWrappedInfo));
                            dispatch((0,asset_actions/* getUserBalance */.n3)(resultBalance));
                            dispatch((0,asset_actions/* fetchStatusLoading */.Xy)({
                                isLoading: false
                            }));
                            dispatch((0,asset_actions/* getBalanceAccount */.Fi)(resultBalanceAccount));
                            return [
                                3,
                                9
                            ];
                        case 8:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                9
                            ];
                        case 9:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataAsset() {
                return _ref.apply(this, arguments);
            };
        }();
        if (chainId) {
            getDataAsset();
        } else {
            dispatch((0,asset_actions/* fetchAssetItems */.v$)({
                listWrappedItem: []
            }));
            dispatch((0,asset_actions/* getUserBalance */.n3)({
                listUserBalance: []
            }));
        }
    }, [
        account,
        chainId,
        dispatch,
        tokenSupport,
        messageHash
    ]);
};
var GetDataAsset = function() {
    var dataAsset = (0,es/* useSelector */.v9)(function(state) {
        return state.asset;
    });
    var listUserBalance = dataAsset.listUserBalance, isLoading = dataAsset.isLoading, messageHash = dataAsset.messageHash;
    var filterDataAddress = listUserBalance.reduce(function(acc, pre) {
        var index = acc.findIndex(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref1 = pre.nftAddress) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) && (item === null || item === void 0 ? void 0 : item.holdingDate) === (pre === null || pre === void 0 ? void 0 : pre.holdingDate);
        });
        if (index === -1) {
            acc.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pre), {
                buys: [
                    {
                        nftBalance: pre.nftBalance,
                        nftId: pre.nftId,
                        fullVestingMap: pre.fullVestingMap
                    }, 
                ]
            }));
        } else {
            var item = (0,_to_consumable_array/* default */.Z)(acc[index].buys);
            item.push({
                nftBalance: pre.nftBalance,
                nftId: pre.nftId,
                fullVestingMap: pre.fullVestingMap
            });
            // eslint-disable-next-line no-param-reassign
            acc[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[index]), {
                nftBalance: acc[index].nftBalance + pre.nftBalance,
                buys: item
            });
        }
        return acc;
    }, []);
    return {
        listUserBalance: (0,_to_consumable_array/* default */.Z)(filterDataAddress).sort(function(a, b) {
            return (b === null || b === void 0 ? void 0 : b.holdingDate) - (a === null || a === void 0 ? void 0 : a.holdingDate);
        }),
        isLoading: isLoading,
        messageHash: messageHash
    };
};

// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(55604);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PlayIcon.tsx
var PlayIcon = __webpack_require__(94313);
;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n    text-align: right;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    @media screen and (max-width: 586px) {\n        font-size: 24px;\n    }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 1.75rem;\n    align-items: center;\n    flex-direction: column;\n    @media screen and (max-width: 1024px) {\n        display: none;\n    }\n    ",
        " {\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 1.5;\n        color: ",
        ";\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 14px;\n        }\n    }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 65px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    @media screen and (max-width: 768px) {\n        font-size: 14px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: underline;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 14px;\n    }\n    cursor:pointer;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    min-width: 220px;\n    margin-left: 40px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1024px) {\n        min-width: 120px;\n    }\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 40px;\n        color: ",
        ";\n    }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 4rem;\n    @media screen and (max-width: 1024px) {\n        margin-top: 2rem;\n        flex-direction: column;\n    }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    width: 40%;\n    ",
        " {\n        font-size: 16px;\n        @media screen and (max-width: 1024px) {\n            font-size: 12px;\n        }\n    }\n    @media screen and (max-width: 1024px) {\n        width: 100%;\n    }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        line-height: 50px;\n        text-align: center;\n        padding: 10px 0;\n    }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 48px 0 24px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    border: 1px solid #f5f5f5;\n    ",
        " {\n        font-size: 12px;\n        font-weight: 600;\n    }\n    @media screen and (max-width: 600px) {\n        /* padding: 12px 0px 12px 0px; */\n    }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 990px;\n    @media screen and (max-width: 768px) {\n        min-width: 90%;\n        padding: 1rem 0rem 1rem 0rem;\n    }\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 34px;\n    font-weight: 700;\n    @media screen and (max-width: 768px) {\n        font-size: 24px;\n    }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: 1px solid ",
        ";\n    height: 65px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    border-radius: 12px;\n    color: ",
        ";\n    @media screen and (max-width: 768px) {\n        height: 40px;\n        font-size: 14px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 600;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    ",
        " {\n        font-size: 14px;\n        color: ",
        ";\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n            font-weight: 600;\n        }\n    }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 0rem;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        margin-top: 1rem;\n    }\n    @media screen and (max-width: 600px) {\n        margin-top: 1rem;\n    }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 1.5rem;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        margin-top: 1rem;\n    }\n    @media screen and (max-width: 600px) {\n        margin-top: 1rem;\n    }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    display: none;\n    @media screen and (max-width: 768px) {\n        width: 18px;\n        height: 18px;\n        display: block;\n    }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    display: block;\n    font-size: 14px;\n    @media screen and (max-width: 768px) {\n        font-size: 12px;\n    }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmax-width: 100%;\nalign-items: center;\njustify-content: center;\nwidth: 14.2%;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}


var styles_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme, isBuy = param.isBuy;
    return isBuy ? theme.colors.success2 : theme.colors.red;
});
var styles_CsTitleModal = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-1"
})(styles_templateObject1());
var styles_CsFlexAgree = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-2"
})(styles_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var styles_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70144ebf-3"
})(styles_templateObject3());
var styles_CsLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70144ebf-4"
})(styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var styles_TextAddr = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-5"
})(styles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var styles_WrapAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70144ebf-6"
})(styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var styles_CsFlexWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-7"
})(styles_templateObject7());
var styles_CSInfoSide = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-8"
})(styles_templateObject8(), Text/* default */.Z);
var styles_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-9"
})(styles_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70144ebf-10"
})(styles_templateObject10());
var styles_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-11"
})(styles_templateObject11(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var styles_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70144ebf-12"
})(styles_templateObject12(), Text/* default */.Z);
var styles_CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-70144ebf-13"
})(styles_templateObject13());
var CsButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-14"
})(styles_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var styles_CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-70144ebf-15"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsTextModalDetail = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-16"
})(_templateObject16());
var CsTextModalLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-17"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsTextModalValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-18"
})(_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsTextModalValuePrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-19"
})(_templateObject19(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var CustomLink = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-20"
})(_templateObject20(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsFlexLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-21"
})(_templateObject21());
var CsFlexRight = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-22"
})(_templateObject22());
var styles_CsImgCoin = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-70144ebf-23"
})(_templateObject23());
var styles_CsTextVndc = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-70144ebf-24"
})(_templateObject24(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var styles_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-70144ebf-25"
})(_templateObject25());

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/components/ModalDetail.tsx

function ModalDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n        letter-spacing: 0;\n    }\n"
    ]);
    ModalDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    font-size: 12px;\n    min-width: 100%;\n    border-radius: 4px;\n    color: ",
        ";\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    transition: 0.5s;\n    &:hover {\n        background: transparent;\n        color: ",
        ";\n        border: 1px solid ",
        ";\n    }\n    @media screen and (max-width: 768px) {\n        min-width: 100%;\n        height: 42px;\n        padding: 0;\n    }\n"
    ]);
    ModalDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var DetailModal = function(param) {
    var item = param.item, yieldsReceived = param.yieldsReceived, totalVested = param.totalVested, totalVestingMap = param.totalVestingMap, onDismiss = param.onDismiss;
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var totalPrice = (0,react.useMemo)(function() {
        return Number(new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.nftBalance).multipliedBy(item === null || item === void 0 ? void 0 : item.denominations));
    }, [
        item
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsModal, {
        title: "",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            height: "auto",
            flexDirection: "column",
            style: {
                gap: "10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextTitle, {
                        bold: true,
                        children: "Th\xf4ng tin chi tiết"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Số lượng",
                    value: item === null || item === void 0 ? void 0 : item.nftBalance,
                    isFormatNumber: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Mệnh gi\xe1 (VND)",
                    value: item === null || item === void 0 ? void 0 : item.denominations,
                    isFormatNumber: true,
                    minimum: 0,
                    maximum: 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Kỳ trả lợi suất",
                    value: item === null || item === void 0 ? void 0 : item.intervestTerm,
                    uti: "th\xe1ng"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                    value: "".concat(totalVested, "/").concat(totalVestingMap)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Lợi suất",
                    value: Number(item === null || item === void 0 ? void 0 : item.profit),
                    uti: "%",
                    isFormatNumber: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Ng\xe0y trả lợi suất kế tiếp",
                    value: convertDate(((ref = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref === void 0 ? void 0 : ref.nextInterestPaymentDate) * 1000)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Ng\xe0y c\xf2n lại",
                    value: getDateBetweenTwoDates(((ref1 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref1 === void 0 ? void 0 : ref1.nextInterestPaymentDate) * 1000),
                    uti: config/* UNIT_DATE */.L$
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Lợi suất sắp nhận",
                    value: yieldsReceived,
                    isFormatNumber: true,
                    minimum: 0,
                    maximum: 0,
                    uti: "VND"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDetail, {
                    title: "Tổng mệnh gi\xe1 (VND)",
                    value: totalPrice,
                    isFormatNumber: true,
                    minimum: 0,
                    maximum: 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mt: "1rem",
                    width: "100%",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_CsButton, {
                        onClick: function() {
                            return onDismiss();
                        },
                        children: t("Tho\xe1t")
                    })
                })
            ]
        })
    });
};
var ItemDetail = function(param) {
    var title = param.title, value = param.value, _minimum = param.minimum, minimum = _minimum === void 0 ? 0 : _minimum, _maximum = param.maximum, maximum = _maximum === void 0 ? 0 : _maximum, isFormatNumber = param.isFormatNumber, uti = param.uti;
    var t = (0,src/* useTranslation */.$G)().t;
    var formatNumber = function(number) {
        return Number(number).toLocaleString("en", {
            minimumFractionDigits: minimum,
            maximumFractionDigits: maximum
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        mt: "0.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalDetail, {
                color: "textSubtle",
                children: t(title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextModalDetail, {
                bold: true,
                children: [
                    isFormatNumber ? formatNumber(value) : value,
                    " ",
                    uti
                ]
            })
        ]
    });
};
var TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-aaf5a6ad-0"
})(ModalDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ModalDetail_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-aaf5a6ad-1"
})(ModalDetail_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
/* harmony default export */ var ModalDetail = (DetailModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/fetchData.ts








var GetNftInfo = function(nftAddress, nftId, account, chainId) {
    var ref = (0,react.useState)({
        originalInvestment: "0",
        yieldCurrent: "0",
        rate: "0",
        holdingTime: 0,
        issueDate: 0
    }), nftInfo = ref[0], setNftInfo = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var getDataNft = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, calls, ref7, resultEtfInfo, resultHoldingTime, resultIssueDate, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setLoading(true);
                            calls = [
                                {
                                    address: nftAddress,
                                    name: "getPriceWhenSellNow",
                                    params: [
                                        account,
                                        nftId
                                    ]
                                },
                                {
                                    address: nftAddress,
                                    name: "getHoldingDate",
                                    params: [
                                        account,
                                        nftId
                                    ]
                                },
                                {
                                    address: nftAddress,
                                    name: "etfInfor",
                                    params: []
                                }
                            ];
                            return [
                                4,
                                (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                            ];
                        case 1:
                            ref7 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                3
                            ]), resultEtfInfo = ref7[0], resultHoldingTime = ref7[1], resultIssueDate = ref7[2];
                            setNftInfo({
                                originalInvestment: new bignumber/* default */.Z((ref = resultEtfInfo[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.toString()).dividedBy(1E18).toString(),
                                yieldCurrent: new bignumber/* default */.Z((ref2 = resultEtfInfo[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profit) === null || ref3 === void 0 ? void 0 : ref3.toString()).dividedBy(1E18).toString(),
                                rate: new bignumber/* default */.Z((ref4 = resultEtfInfo[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.rate) === null || ref5 === void 0 ? void 0 : ref5.toString()).dividedBy(10).toString(),
                                holdingTime: Number(new bignumber/* default */.Z((ref6 = resultHoldingTime[0]) === null || ref6 === void 0 ? void 0 : ref6.toString()).toString()) * 1000,
                                issueDate: Number(new bignumber/* default */.Z(resultIssueDate === null || resultIssueDate === void 0 ? void 0 : resultIssueDate.issueDate.toString()).toString()) * 1000
                            });
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataNft() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((nftAddress === null || nftAddress === void 0 ? void 0 : nftAddress.length) > 0) {
            getDataNft();
        }
    }, [
        nftId,
        chainId,
        account,
        nftAddress
    ]);
    return {
        nftInfo: nftInfo,
        isLoading: isLoading
    };
};
var GetPriceAtTime = function(nftAddress, holdingTime, chainId) {
    var ref = (0,react.useState)({
        priceAtTime: "0"
    }), priceAtTime = ref[0], setPriceAtTime = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var getPriceAtTime = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, calls, ref1, result, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setLoading(true);
                            calls = [
                                {
                                    address: nftAddress,
                                    name: "getPriceAtTime",
                                    params: [
                                        holdingTime
                                    ]
                                }
                            ];
                            return [
                                4,
                                (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                            ];
                        case 1:
                            ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                1
                            ]), result = ref1[0];
                            setPriceAtTime({
                                priceAtTime: new bignumber/* default */.Z((ref = result[0]) === null || ref === void 0 ? void 0 : ref.toString()).dividedBy(1E18).toString()
                            });
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getPriceAtTime() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((nftAddress === null || nftAddress === void 0 ? void 0 : nftAddress.length) > 0) {
            getPriceAtTime();
        }
    }, [
        chainId,
        nftAddress,
        holdingTime
    ]);
    return {
        priceAtTime: priceAtTime,
        isLoading: isLoading
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useClaim.tsx












var useClaim = function(nftAddress, buys, index, account, chainId, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedClaim = ref[0], setRequestClaim = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingClaim = ref2[0], setPenddingClaim = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var checkHarvest = buys.filter(function(item) {
        return !item.fullVestingMap[index].isVested;
    });
    var _tokenIds = checkHarvest.map(function(item) {
        return item.nftId;
    });
    var handleClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPenddingClaim(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "harvest", [
                            _tokenIds,
                            index
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Nhận lợi suất th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestClaim(false);
                        setPenddingClaim(false);
                        onDismiss();
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                    } else {
                        setRequestClaim(false);
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setPenddingClaim(false);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    handleRejected(e);
                    setPenddingClaim(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        _tokenIds,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        index,
        onDismiss,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleClaim: handleClaim,
        requestedClaim: requestedClaim,
        pendingClaim: pendingClaim
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/components/ProfitReceivedModal.tsx




function ProfitReceivedModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n        letter-spacing: 0;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 45%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    color: ",
        ";\n    &:first-child {\n        text-align: left;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    transition: 0.5s;\n    @media screen and (max-width: 1000px) {\n        border-radius: 4px;\n        min-width: 165px;\n        font-size: 14px;\n        height: 40px;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    margin-top: 3rem;\n    @media screen and (max-width: 1000px) {\n        flex-direction: column;\n        margin-top: 2rem;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    ProfitReceivedModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 12px 0;\n    align-items: center;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    /* justify-content: center; */\n"
    ]);
    ProfitReceivedModal_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ProfitReceivedModal_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    ProfitReceivedModal_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}














var ProfitReceivedModal = function(_param) {
    var handleOpenLink = function handleOpenLink(address) {
        window.open((0,utils/* getBlockExploreLink */.C)(address, "address", chainId));
    };
    var sAccount = function sAccount(dataAddress) {
        if ((dataAddress === null || dataAddress === void 0 ? void 0 : dataAddress.length) > 0) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var account = _param.account, chainId = _param.chainId, price = _param.price, profit = _param.profit, currentyield = _param.currentyield, origininvest = _param.origininvest, interestPayDate = _param.interestPayDate, dayleft = _param.dayleft, windowSize = _param.windowSize, title = _param.title, dataUser = _param.dataUser, onDismiss = _param.onDismiss, props = (0,_object_without_properties/* default */.Z)(_param, [
        "account",
        "chainId",
        "price",
        "profit",
        "currentyield",
        "origininvest",
        "interestPayDate",
        "dayleft",
        "windowSize",
        "title",
        "dataUser",
        "onDismiss"
    ]);
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref1 = useClaim(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftAddress, dataUser === null || dataUser === void 0 ? void 0 : dataUser.buys, dataUser === null || dataUser === void 0 ? void 0 : dataUser.vestingMap[0].index, account, chainId, onDismiss), handleClaim = ref1.handleClaim, requestedClaim = ref1.requestedClaim, pendingClaim = ref1.pendingClaim;
    var currentYield = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(currentyield).multipliedBy(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance).toString();
    }, [
        currentyield,
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance
    ]);
    var nftInfo = GetNftInfo(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftAddress, dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftId, account, chainId).nftInfo;
    // const { priceAtTime, isLoading } = GetPriceAtTime( dataUser?.nftAddress, nftInfo?.holdingTime/1000, chainId)
    var investmentAmount = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance).multipliedBy(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment).toString();
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance,
        nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment
    ]);
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.fullVestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitReceivedModal_TextTitle, {
                    children: t("Th\xf4ng tin Chứng chỉ Quỹ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfitReceivedModal_WrapperItemHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Lợi suất"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "LS hiện tại"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Lợi suất hiện tại (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Gốc đầu tư"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Gốc đầu tư (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Ng\xe0y trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Ng\xe0y c\xf2n lại"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitReceivedModal_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfitReceivedModal_WrapperCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: Number(price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: profit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            totalVested,
                                            "/",
                                            totalVestingMap
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: Number(currentYield).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: Number(investmentAmount).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: convertDate(interestPayDate * 1000)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            dayleft,
                                            " ",
                                            config/* UNIT_DATE */.L$
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapItemMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        width: "21%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "4px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        children: Number(price).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        width: "21%",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "4px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            totalVested,
                                                            "/",
                                                            totalVestingMap
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        width: "21%",
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: profit
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                mt: "1rem",
                                alignItems: "center",
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        minWidth: "33%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Ng\xe0y c\xf2n lại",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: [
                                                            dayleft,
                                                            " ",
                                                            config/* UNIT_DATE */.L$
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        minWidth: "33%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Gốc đầu tư (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: Number(investmentAmount).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexHeaderMb, {
                                        minWidth: "21%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: convertDate(interestPayDate * 1000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfitReceivedModal_CsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                fontWeight: "700",
                                children: t("Th\xf4ng tin giao dịch")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1.5rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                        children: t("Địa chỉ v\xed thụ hưởng")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink, {
                                        style: {
                                            textAlign: "right"
                                        },
                                        onClick: function() {
                                            return handleOpenLink(account);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontWeight: "600",
                                                children: sAccount(account)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLeft, {
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                        children: "Ng\xe0y giao dịch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalValue, {
                                            children: convertDate(Date.now())
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexRight, {
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                        children: "Nhận lợi suất (1 kỳ)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "flex-end",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalValuePrice, {
                                                        children: Number(currentYield).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextVndc, {
                                                        fontWeight: "700",
                                                        ml: "5px",
                                                        children: "VND"
                                                    })
                                                ]
                                            }),
                                            Number(currentYield) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                mt: "4px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsUnit, {
                                                    style: {
                                                        color: "#8C8D8E",
                                                        fontSize: "12px"
                                                    },
                                                    children: " (Tương đương ".concat(Number(currentYield).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }), " điểm VNDC)")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            dataUser.isOder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                style: {
                    textAlign: "center",
                    color: "red",
                    fontSize: "13px",
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "10px"
                },
                children: "Đ\xe3 hết kỳ nhận lợi suất vui l\xf2ng hủy tất cả giao dịch thỏa thuận!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                style: {
                    marginTop: "24px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitReceivedModal_CsButtonConfirm, {
                    onClick: handleClaim,
                    disabled: pendingClaim || requestedClaim || (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused) || (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isOder),
                    endIcon: pendingClaim ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "textSubtle"
                    }) : "null",
                    children: requestedClaim ? t("Đ\xe3 nhận lợi suất") : t("Nhận lợi suất")
                })
            }),
            (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused) === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "2rem"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "12px",
                        ,
                        ,
                        "14px"
                    ],
                    color: "red",
                    children: t("CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!")
                })
            })
        ]
    }));
};
var ProfitReceivedModal_TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-0"
})(ProfitReceivedModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-1"
})(ProfitReceivedModal_templateObject1());
var ProfitReceivedModal_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-2"
})(ProfitReceivedModal_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ProfitReceivedModal_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-3"
})(ProfitReceivedModal_templateObject3());
var ProfitReceivedModal_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-4"
})(ProfitReceivedModal_templateObject4());
var ProfitReceivedModal_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-5"
})(ProfitReceivedModal_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var ProfitReceivedModal_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3ea7320-6"
})(ProfitReceivedModal_templateObject6());
var ProfitReceivedModal_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-7"
})(ProfitReceivedModal_templateObject7(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsFlexHeaderMb = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f3ea7320-8"
})(ProfitReceivedModal_templateObject8());
var CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f3ea7320-9"
})(ProfitReceivedModal_templateObject9());
/* harmony default export */ var components_ProfitReceivedModal = (ProfitReceivedModal);

;// CONCATENATED MODULE: ./src/components/ExchangeToken.tsx

var ExchangeToken = function(param) {
    var price = param.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            color: "#8C8D8E",
            fontSize: "12px"
        },
        children: " (Tương đương ".concat(Number(price).toLocaleString("en", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }), " điểm VNDC)")
    });
}; // flexDirection="column" alignItems="flex-end"

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useApproveRedeem.tsx







// import { usePiBMarketplace } from 'hooks/useContract'





var useApproveRedeem = function(nftAddress, account, chainId) {
    var t = (0,src/* useTranslation */.$G)().t;
    var handleRejected = useUserRejected().handleRejected;
    var ref = (0,react.useState)(false), requestedApproveRedeem = ref[0], setRequestApproveRedeem = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingApproveRedeem = ref2[0], setPenddingApproveRedeem = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleApproveRedeem = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPenddingApproveRedeem(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "setApprovalForAll", [
                            nftAddress,
                            true
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Chấp thuận th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestApproveRedeem(true);
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    handleRejected(e);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        nftAddress,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleApproveRedeem: handleApproveRedeem,
        requestedApproveRedeem: requestedApproveRedeem,
        pendingApproveRedeem: pendingApproveRedeem
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useRedeem.tsx







// import { usePiBMarketplace } from 'hooks/useContract'





var useRedeem = function(nftAddress, buys, account, chainId, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedRedeem = ref[0], setRequestRedeem = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingRedeem = ref2[0], setPendingRedeem = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleRedeem = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tokenIds, amounts, tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingRedeem(true);
                    tokenIds = buys.map(function(item) {
                        return item.nftId;
                    });
                    amounts = buys.map(function(item) {
                        return item.nftBalance;
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "redeem", [
                            tokenIds,
                            amounts
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        setPendingRedeem(false);
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                        toastSuccess(t("Đ\xe1o hạn th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestRedeem(true);
                        onDismiss();
                    } else {
                        setPendingRedeem(false);
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    handleRejected(e);
                    setPendingRedeem(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        buys,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        onDismiss,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleRedeem: handleRedeem,
        requestedRedeem: requestedRedeem,
        pendingRedeem: pendingRedeem
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/components/ReceivedAll.tsx




function ReceivedAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n    display: none;\n    @media screen and (max-width: 768px) {\n        display: block;\n        width: 20px;\n        height: 20px;\n    }\n"
    ]);
    ReceivedAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n    }\n"
    ]);
    ReceivedAll_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 45%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    ReceivedAll_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    color: ",
        ";\n    &:first-child {\n        text-align: left;\n    }\n"
    ]);
    ReceivedAll_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 280px;\n    border-radius: 4px;\n    align-items: center;\n    color: ",
        ";\n"
    ]);
    ReceivedAll_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 260px;\n    transition: 0.5s;\n    @media screen and (max-width: 1000px) {\n        border-radius: 4px;\n        min-width: 165px;\n        font-size: 14px;\n        height: 40px;\n    }\n"
    ]);
    ReceivedAll_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: underline;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 40px;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 18px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 14px;\n    }\n    cursor: ",
        ";\n"
    ]);
    ReceivedAll_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    margin-top: 3rem;\n    @media screen and (max-width: 1000px) {\n        flex-direction: column;\n        margin-top: 2rem;\n    }\n"
    ]);
    ReceivedAll_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n    }\n"
    ]);
    ReceivedAll_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    ReceivedAll_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 24px 0;\n    align-items: center;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    ReceivedAll_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    /* justify-content: center; */\n"
    ]);
    ReceivedAll_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function ReceivedAll_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    ReceivedAll_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
















var ReceivedAll = function(_param) {
    var sAccount = function sAccount(dataAddress) {
        if ((dataAddress === null || dataAddress === void 0 ? void 0 : dataAddress.length) > 0) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var handleOpenLink = function handleOpenLink() {
        window.open((0,utils/* getBlockExploreLink */.C)(account, "address", chainId));
    };
    var price = _param.price, profit = _param.profit, currentyield = _param.currentyield, origininvest = _param.origininvest, interestPayDate = _param.interestPayDate, dayleft = _param.dayleft, windowSize = _param.windowSize, title = _param.title, account = _param.account, chainId = _param.chainId, dataUser = _param.dataUser, onDismiss = _param.onDismiss, props = (0,_object_without_properties/* default */.Z)(_param, [
        "price",
        "profit",
        "currentyield",
        "origininvest",
        "interestPayDate",
        "dayleft",
        "windowSize",
        "title",
        "account",
        "chainId",
        "dataUser",
        "onDismiss"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,src/* useTranslation */.$G)().t;
    var actuallyReceived = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance).multipliedBy(dataUser === null || dataUser === void 0 ? void 0 : dataUser.denominations).toString();
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.denominations,
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance
    ]);
    var ref5 = useApproveRedeem(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftAddress, account, chainId), handleApproveRedeem = ref5.handleApproveRedeem, requestedApproveRedeem = ref5.requestedApproveRedeem, pendingApproveRedeem = ref5.pendingApproveRedeem;
    var ref6 = useRedeem(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftAddress, dataUser === null || dataUser === void 0 ? void 0 : dataUser.buys, account, chainId, onDismiss), handleRedeem = ref6.handleRedeem, requestedRedeem = ref6.requestedRedeem, pendingRedeem = ref6.pendingRedeem;
    var currentTime = Math.floor(Date.now() / 1000);
    var priceAtTime = GetPriceAtTime(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftAddress, currentTime, chainId).priceAtTime;
    var totalPriceAtTime = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(priceAtTime === null || priceAtTime === void 0 ? void 0 : priceAtTime.priceAtTime).multipliedBy(dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance).toString();
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.nftBalance,
        priceAtTime === null || priceAtTime === void 0 ? void 0 : priceAtTime.priceAtTime
    ]);
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : dataUser.fullVestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        dataUser === null || dataUser === void 0 ? void 0 : (ref = dataUser.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                mt: "1.5rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_TextTitle, {
                    children: t("Th\xf4ng tin Chứng chỉ Quỹ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceivedAll_WrapperItemHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: t("Lợi suất")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "LS hiện tại"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Lợi suất hiện tại (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Gốc đầu tư"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Gốc đầu tư sau khi đ\xe3 nhận lợi suất (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: t("Ng\xe0y đ\xe1o hạn")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: t("Ng\xe0y c\xf2n lại")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceivedAll_WrapperCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: Number(price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: profit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            totalVested,
                                            "/",
                                            totalVestingMap
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isExpire) && (dataUser === null || dataUser === void 0 ? void 0 : (ref1 = dataUser.vestingMap) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 ? "0" : Number(currentyield).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z(totalPriceAtTime).isNaN() ? "0" : Number(totalPriceAtTime).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: convertDate((dataUser === null || dataUser === void 0 ? void 0 : dataUser.expireDate) * 1000)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isExpire) && (dataUser === null || dataUser === void 0 ? void 0 : (ref2 = dataUser.vestingMap) === null || ref2 === void 0 ? void 0 : ref2.length) === 0 ? "0" : "".concat(dayleft, " ").concat(config/* UNIT_DATE */.L$)
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapItemMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        minWidth: "25%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Mệnh gi\xe1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        fontSize: "12px",
                                                        color: "textSubtle",
                                                        children: "MG:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            "\xa0",
                                                            Number(price).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        minWidth: "25%",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                        children: [
                                                            totalVested,
                                                            "/",
                                                            totalVestingMap
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        minWidth: "25%",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isExpire) && (dataUser === null || dataUser === void 0 ? void 0 : (ref3 = dataUser.vestingMap) === null || ref3 === void 0 ? void 0 : ref3.length) === 0 ? convertDate((dataUser === null || dataUser === void 0 ? void 0 : dataUser.expireDate) * 1000) : convertDate(interestPayDate * 1000)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                mt: "1rem",
                                alignItems: "center",
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        minWidth: "30%",
                                        justifyContent: "flex-start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Ng\xe0y c\xf2n lại",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isExpire) && (dataUser === null || dataUser === void 0 ? void 0 : (ref4 = dataUser.vestingMap) === null || ref4 === void 0 ? void 0 : ref4.length) === 0 ? "0" : "".concat(dayleft, " ").concat(config/* UNIT_DATE */.L$)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        minWidth: "33%",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Gốc đầu tư sau khi đ\xe3 nhận lợi suất (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: Number(totalPriceAtTime).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsFlexHeaderMb, {
                                        width: "21%",
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                            title: "Lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                style: {
                                                    cursor: "pointer",
                                                    gap: "2px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        ml: "4px",
                                                        children: profit
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceivedAll_CsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceivedAll_CsBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                fontWeight: "700",
                                children: t("Th\xf4ng tin giao dịch")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                width: "100%",
                                mt: [
                                    "1rem",
                                    ,
                                    "1.5rem"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "40%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                            children: t("Địa chỉ v\xed thụ hưởng")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink, {
                                        style: {
                                            textAlign: "right"
                                        },
                                        onClick: handleOpenLink,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                fontSize: "14px",
                                                fontWeight: "700",
                                                children: sAccount(account)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReceivedAll_CsBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexLeft, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                        fontWeight: "500",
                                        children: t("Ng\xe0y giao dịch")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalValue, {
                                            children: convertDate(Date.now())
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1.5rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextModalLabel, {
                                        fontWeight: "500",
                                        children: [
                                            t("Gốc đầu tư"),
                                            " (VND)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalValuePrice, {
                                                        children: new bignumber/* default */.Z(totalPriceAtTime).isNaN() ? "0" : Number(origininvest).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextVndc, {
                                                        fontWeight: "700",
                                                        style: {
                                                            marginLeft: "5px"
                                                        },
                                                        children: "VND"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeToken, {
                                                price: origininvest
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                width: "100%",
                                mt: [
                                    "1rem",
                                    ,
                                    "1.5rem"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "40%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalLabel, {
                                            children: t("Thực nhận")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlexReceived, {
                                        justifyContent: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextModalValuePrice, {
                                                            children: new bignumber/* default */.Z(actuallyReceived).isNaN() ? "0" : Number(actuallyReceived).toLocaleString("en", {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextVndc, {
                                                            fontWeight: "700",
                                                            style: {
                                                                marginLeft: "5px"
                                                            },
                                                            children: "VND"
                                                        })
                                                    ]
                                                }),
                                                new bignumber/* default */.Z(actuallyReceived).isNaN() ? "" : Number(actuallyReceived) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    mt: "4px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsUnit, {
                                                        style: {
                                                            color: "#8C8D8E"
                                                        },
                                                        children: " (Tương đương ".concat(Number(actuallyReceived).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }), " điểm VNDC)")
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "2rem",
                    ,
                    "2rem"
                ],
                children: (dataUser === null || dataUser === void 0 ? void 0 : dataUser.isApprovedForAll) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsButtonConfirm, {
                    onClick: handleRedeem,
                    disabled: pendingRedeem || requestedRedeem || (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused),
                    endIcon: pendingRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "textSubtle"
                    }) : "null",
                    children: requestedRedeem ? t("Đ\xe1o hạn th\xe0nh c\xf4ng") : t("Đ\xe1o hạn")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: requestedApproveRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsButtonConfirm, {
                        onClick: handleRedeem,
                        disabled: pendingRedeem || requestedRedeem || (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused) === true,
                        endIcon: pendingRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "textSubtle"
                        }) : "null",
                        children: requestedRedeem ? t("Đ\xe1o hạn th\xe0nh c\xf4ng") : t("Đ\xe1o hạn")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceivedAll_CsButtonConfirm, {
                        onClick: handleApproveRedeem,
                        disabled: pendingApproveRedeem || requestedApproveRedeem || (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused) === true,
                        endIcon: pendingApproveRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "textSubtle"
                        }) : "",
                        children: t("Chấp thuận")
                    })
                })
            }),
            (dataUser === null || dataUser === void 0 ? void 0 : dataUser.paused) === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "1rem"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "12px",
                        ,
                        ,
                        "14px"
                    ],
                    color: "red",
                    children: t("CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!")
                })
            })
        ]
    }));
};
var ReceivedAll_CsImgCoin = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-f6116790-0"
})(ReceivedAll_templateObject());
var ReceivedAll_TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f6116790-1"
})(ReceivedAll_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ReceivedAll_CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f6116790-2"
})(ReceivedAll_templateObject2());
var ReceivedAll_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f6116790-3"
})(ReceivedAll_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsFlexReceived = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6116790-4"
})(ReceivedAll_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ReceivedAll_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-f6116790-5"
})(ReceivedAll_templateObject5());
var ReceivedAll_CsLink = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6116790-6"
})(ReceivedAll_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
}, function(param) {
    var disabled = param.disabled;
    return disabled ? "not-allowed" : "pointer";
});
var ReceivedAll_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6116790-7"
})(ReceivedAll_templateObject7());
var ReceivedAll_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6116790-8"
})(ReceivedAll_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var ReceivedAll_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6116790-9"
})(ReceivedAll_templateObject9());
var ReceivedAll_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6116790-10"
})(ReceivedAll_templateObject10(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var ReceivedAll_CsFlexHeaderMb = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f6116790-11"
})(ReceivedAll_templateObject11());
var ReceivedAll_CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-f6116790-12"
})(ReceivedAll_templateObject12());
/* harmony default export */ var components_ReceivedAll = (ReceivedAll);

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/CheckboxV2.tsx
var CheckboxV2 = __webpack_require__(54379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/PastIcon.tsx
var PastIcon = __webpack_require__(128);
// EXTERNAL MODULE: ./node_modules/web3-utils/lib/index.js
var lib = __webpack_require__(18269);
;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useDownload.tsx






var useDownload = function(raw) {
    var ref = (0,react.useState)(false), penddingDowload = ref[0], setPenddingDownLoad = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastError = ref1.toastError, toastSuccess = ref1.toastSuccess;
    var handleDownload = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    setPenddingDownLoad(!false);
                    return [
                        4,
                        axiosClient.post("/pdf-generator/etf-transfer", raw, {
                            responseType: "arraybuffer",
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "*"
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    file_download_default()(response.data, "hop_dong_chuyen_nhuong.pdf");
                    toastSuccess("Tải xuống th\xe0nh c\xf4ng.");
                    return [
                        3,
                        4
                    ];
                case 2:
                    error = _state.sent();
                    toastError("Tải xuống thất bại. Vui l\xf2ng thử lại.");
                    return [
                        3,
                        4
                    ];
                case 3:
                    setPenddingDownLoad(false);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        raw,
        toastError,
        toastSuccess
    ]);
    return {
        penddingDowload: penddingDowload,
        handleDownload: handleDownload
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useListp2p.tsx













var useListp2p = function(nftAddress, buyer, buys, amount, price, account, chainId, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedListp2p = ref[0], setRequestListp2p = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingListp2p = ref2[0], setPenddingListp2p = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleListp2p = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var buysSort, newData, amountBuy, resultFilter, i, element, quantityToBuy, tokenIds, amounts, tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPenddingListp2p(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    buysSort = buys.sort(function(a, b) {
                        return a.nftBalance - b.nftBalance;
                    });
                    newData = (0,_to_consumable_array/* default */.Z)(buysSort);
                    amountBuy = amount;
                    resultFilter = [];
                    for(i = 0; i < newData.length && amountBuy > 0; i++){
                        element = newData[i];
                        quantityToBuy = Math.min(amountBuy, element.nftBalance);
                        resultFilter.push({
                            nftId: element.nftId,
                            nftBalance: quantityToBuy
                        });
                        newData[i].nftBalance -= quantityToBuy;
                        amountBuy -= quantityToBuy;
                    }
                    tokenIds = resultFilter.map(function(item) {
                        return item.nftId;
                    });
                    amounts = resultFilter.map(function(item) {
                        return item.nftBalance;
                    });
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "listP2P", [
                            buyer,
                            tokenIds,
                            amounts,
                            price
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                        setPenddingListp2p(false);
                        toastSuccess(t("B\xe1n thỏa thuận th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestListp2p(true);
                        onDismiss();
                    } else {
                        setPenddingListp2p(false);
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    handleRejected(e);
                    setPenddingListp2p(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        amount,
        buyer,
        buys,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        onDismiss,
        price,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleListp2p: handleListp2p,
        requestedListp2p: requestedListp2p,
        pendingListp2p: pendingListp2p
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/hook/useSellNow.tsx








// import { usePiBMarketplace } from 'hooks/useContract'





var useSellnow = function(nftAddress, buys, amount, account, chainId, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedSellnow = ref[0], setRequestSellnow = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingSellNow = ref2[0], setPendingSellNow = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleSellnow = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var buysSort, newData, amountBuy, resultFilter, i, element, quantityToBuy, tokenIds, amounts, tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingSellNow(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    buysSort = buys.sort(function(a, b) {
                        return a.nftBalance - b.nftBalance;
                    });
                    newData = (0,_to_consumable_array/* default */.Z)(buysSort);
                    amountBuy = amount;
                    resultFilter = [];
                    for(i = 0; i < newData.length && amountBuy > 0; i++){
                        element = newData[i];
                        quantityToBuy = Math.min(amountBuy, element.nftBalance);
                        resultFilter.push({
                            nftId: element.nftId,
                            nftBalance: quantityToBuy
                        });
                        newData[i].nftBalance -= quantityToBuy;
                        amountBuy -= quantityToBuy;
                    }
                    tokenIds = resultFilter.map(function(item) {
                        return item.nftId;
                    });
                    amounts = resultFilter.map(function(item) {
                        return item.nftBalance;
                    });
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "sellNow", [
                            tokenIds,
                            amounts
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        dispatch((0,asset_actions/* actionDispatchAssetMessage */.lx)({
                            messageHash: receipt.transactionHash
                        }));
                        toastSuccess(t("B\xe1n ngay th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestSellnow(true);
                        onDismiss();
                        setPendingSellNow(false);
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setPendingSellNow(false);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    handleRejected(e);
                    setPendingSellNow(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        amount,
        buys,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        onDismiss,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleSellnow: handleSellnow,
        requestedSellnow: requestedSellnow,
        pendingSellNow: pendingSellNow
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/components/SellModal.tsx
/* eslint-disable no-param-reassign */ 





function SellModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    transition: 0.5s;\n    @media screen and (max-width: 1000px) {\n        border-radius: 4px;\n        min-width: 165px;\n        font-size: 14px;\n        height: 40px;\n    }\n"
    ]);
    SellModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SellModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    @media screen and (max-width: 767px) {\n        display: flex;\n    }\n"
    ]);
    SellModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SellModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    cursor: pointer;\n    @media screen and (max-width: 767px) {\n        display: none;\n    }\n"
    ]);
    SellModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SellModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 12px;\n    }\n"
    ]);
    SellModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SellModal_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    outline: none;\n    &:focus-visible {\n        outline: none;\n    }\n    ::placeholder {\n        color: ",
        ";\n        opacity: 1;\n    }\n"
    ]);
    SellModal_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SellModal_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    padding-right: 10px;\n    &:active {\n        transform: translateY(1px);\n    }\n"
    ]);
    SellModal_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SellModal_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    font-weight: 500;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 12px;\n    }\n"
    ]);
    SellModal_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SellModal_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    white-space: nowrap;\n    font-weight: 700;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    SellModal_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SellModal_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 14px;\n    white-space: nowrap;\n    font-weight: 700;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    SellModal_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SellModal_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n    }\n"
    ]);
    SellModal_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SellModal_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 40%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    SellModal_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SellModal_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    SellModal_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SellModal_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    font-weight: 500;\n    text-align: center;\n    color: ",
        ";\n    &:first-child {\n        text-align: left;\n    }\n"
    ]);
    SellModal_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SellModal_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 46px;\n    width: 335px;\n    padding: 0 24px;\n    border-radius: 4px;\n    align-items: center;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1000px) {\n        width: 220px;\n        height: 40px;\n    }\n    input {\n        text-align: left;\n        height: 100%;\n        width: 100%;\n        border: none;\n        color: ",
        ";\n        font-weight: 600;\n        border-radius: 0;\n        padding-right: 10px;\n    }\n"
    ]);
    SellModal_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SellModal_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    width: 170px;\n    padding: 0 16px;\n    border-radius: 4px;\n    align-items: center;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1000px) {\n        width: 220px;\n    }\n    input {\n        color: ",
        ";\n        text-align: right;\n        font-weight: 600;\n        border-radius: 0;\n        &::placeholder {\n            font-size: 14px;\n        }\n    }\n"
    ]);
    SellModal_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SellModal_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    color: ",
        ";\n    padding: 0;\n    width: 100%;\n    text-align: center;\n    border: none;\n    box-shadow: none;\n    height: 100%;\n    font-size: 16px;\n    @media screen and (max-width: 1000px) {\n        font-size: 14px;\n    }\n"
    ]);
    SellModal_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function SellModal_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: none;\n    color: ",
        ";\n    padding: 0;\n    width: 100%;\n    text-align: center;\n    border: none;\n    box-shadow: none;\n    height: 100%;\n    font-size: 14px;\n    &::placeholder {\n        color: ",
        ";\n    }\n    @media screen and (max-width: 1000px) {\n        font-size: 12px;\n    }\n"
    ]);
    SellModal_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function SellModal_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid transparent;\n    background: ",
        ";\n    border-radius: 4px;\n    box-shadow: none;\n    padding: 4px;\n    height: 24px;\n    width: 24px;\n    cursor: pointer;\n    @media screen and (max-width: 1000px) {\n        padding: 8px;\n        height: 16px;\n        width: 16px;\n    }\n"
    ]);
    SellModal_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function SellModal_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    gap: 4px;\n    align-items: center;\n    background: ",
        ";\n    border-radius: 4px;\n    width: 115px;\n    height: 34px;\n    padding: 4px;\n    @media screen and (max-width: 1000px) {\n        height: 28px;\n        gap: 2px;\n        width: 95px;\n    }\n"
    ]);
    SellModal_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function SellModal_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    transition: 0.5s;\n    @media screen and (max-width: 1000px) {\n        border-radius: 4px;\n        min-width: 165px;\n        font-size: 14px;\n        height: 40px;\n    }\n"
    ]);
    SellModal_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function SellModal_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    margin-top: 1rem;\n    @media screen and (max-width: 1000px) {\n        flex-direction: column;\n        margin-top: 2rem;\n    }\n"
    ]);
    SellModal_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function SellModal_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n    }\n"
    ]);
    SellModal_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function SellModal_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    SellModal_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function SellModal_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 12px 0;\n    align-items: center;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    SellModal_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function SellModal_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    /* justify-content: center; */\n"
    ]);
    SellModal_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function SellModal_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    SellModal_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}






















var SellModal = function(_param) {
    var handleOpenLink = function handleOpenLink(address) {
        window.open((0,utils/* getBlockExploreLink */.C)(address, "address", chainId));
    };
    var sAccount = function sAccount(dataAddress) {
        if ((dataAddress === null || dataAddress === void 0 ? void 0 : dataAddress.length) > 0) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var item = _param.item, windowSize = _param.windowSize, title = _param.title, account = _param.account, chainId = _param.chainId, onDismiss = _param.onDismiss, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "windowSize",
        "title",
        "account",
        "chainId",
        "onDismiss"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref9 = (0,react.useState)(true), sellNow = ref9[0], setSellNow = ref9[1];
    var ref10 = (0,react.useState)(1), amountBuy = ref10[0], setAmountBuy = ref10[1];
    var ref11 = (0,react.useState)(""), addressBuyer = ref11[0], setAddressBuyer = ref11[1];
    var ref12 = (0,react.useState)(null), addressBuyerEllipsis = ref12[0], setaddressBuyerEllipsis = ref12[1];
    var ref13 = (0,react.useState)(), fillprice = ref13[0], setFillprie = ref13[1];
    var checkDisableBtnBuy = !sellNow && ((0,lib.isAddress)(addressBuyer) === false || fillprice === "" || Number(amountBuy) > Number(item === null || item === void 0 ? void 0 : item.nftAddress));
    // const isAllowance = new BigNumber(dataAsset?.dataUser?.allowance).isLessThan(item?.investmentAmount);
    (0,react.useEffect)(function() {
        setFillprie("");
    }, [
        sellNow
    ]);
    (0,react.useEffect)(function() {
        if (window.screen.width < 321) {
            var accEllipsis = (0,lib.isAddress)(addressBuyer) === true && addressBuyer ? "".concat(addressBuyer.substring(0, 2), "...").concat(addressBuyer.substring(addressBuyer.length - 2)) : null;
            setaddressBuyerEllipsis(accEllipsis);
        }
        if (window.screen.width > 322) {
            var accEllipsis1 = (0,lib.isAddress)(addressBuyer) === true && addressBuyer ? "".concat(addressBuyer.substring(0, 4), "...").concat(addressBuyer.substring(addressBuyer.length - 4)) : null;
            setaddressBuyerEllipsis(accEllipsis1);
        }
    }, [
        addressBuyer
    ]);
    var handleChangeSell = function(value) {
        setSellNow(value);
    };
    var handlePlus = function() {
        setAmountBuy(amountBuy + 1);
    };
    var handleMinus = function() {
        setAmountBuy(amountBuy - 1);
    };
    var handleChangeInput = function(e) {
        var value = e.target.value;
        if (/^\d+$/.test(value) || value === "") {
            if (Number(value) >= (item === null || item === void 0 ? void 0 : item.nftBalance)) {
                setAmountBuy(item === null || item === void 0 ? void 0 : item.nftBalance);
            } else {
                setAmountBuy(Number(value));
            }
        }
    };
    var handleChangeAddress = function(e) {
        if (!/^(0x)?[0-9a-f]{40}$/i.test(e)) {
            setAddressBuyer(e.target.value);
        }
    };
    // onPaste
    var pasteHandler = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (ref1 = navigator === null || navigator === void 0 ? void 0 : (ref = navigator.clipboard) === null || ref === void 0 ? void 0 : ref.readText()) === null || ref1 === void 0 ? void 0 : ref1.then(function(clipText) {
                                setAddressBuyer(clipText);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function pasteHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref14 = useApproveRedeem(item === null || item === void 0 ? void 0 : item.nftAddress, account, chainId), handleApproveRedeem = ref14.handleApproveRedeem, requestedApproveRedeem = ref14.requestedApproveRedeem, pendingApproveRedeem = ref14.pendingApproveRedeem;
    var ref15 = useListp2p(item === null || item === void 0 ? void 0 : item.nftAddress, addressBuyer, item === null || item === void 0 ? void 0 : item.buys, amountBuy, fillprice, account, chainId, onDismiss), handleListp2p = ref15.handleListp2p, pendingListp2p = ref15.pendingListp2p;
    var ref16 = useSellnow(item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.buys, amountBuy, account, chainId, onDismiss), handleSellnow = ref16.handleSellnow, pendingSellNow = ref16.pendingSellNow;
    var raw = JSON.stringify({
        "buyerWalletAddress": sellNow ? item === null || item === void 0 ? void 0 : item.nftAddress : addressBuyer,
        "sellerWalletAddress": account,
        "pendingEtf": [
            {
                "numericalOrder": "1",
                "etfId": "".concat(item === null || item === void 0 ? void 0 : item.nftId),
                "parValue": "".concat(Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }), " VND"),
                "interest": "".concat(Number(item === null || item === void 0 ? void 0 : item.profit), "%"),
                "incomingInterestDate": convertDate(((ref = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref === void 0 ? void 0 : ref.nextInterestPaymentDate) * 1000),
                "releaseDate": convertDate(Number(item === null || item === void 0 ? void 0 : item.issueDate) * 1000),
                "maturityDate": convertDate(Number(item === null || item === void 0 ? void 0 : item.expireDate) * 1000),
                "transferValue": "".concat(Number(fillprice).toLocaleString("en", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }), " VND")
            }
        ],
        "transferedEtf": [
            {
                "numericalOrder": "1",
                "etfId": "".concat(item === null || item === void 0 ? void 0 : item.nftId),
                "transferDate": convertDate(Date.now())
            }
        ],
        "transferDate": convertDate(Date.now()),
        "totalTransferValue": sellNow ? "".concat(Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }), " VND") : "".concat(Number(fillprice).toLocaleString("en", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }), " VND")
    });
    var ref17 = useDownload(raw), penddingDowload = ref17.penddingDowload, handleDownload = ref17.handleDownload;
    var nftInfo = GetNftInfo(item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.nftId, account, chainId).nftInfo;
    var holdingTime = moment_default()(Date.now()).diff(moment_default()(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.holdingTime), config/* UNITDIFF */.Wt);
    var currentYield = (0,react.useMemo)(function() {
        if (holdingTime <= 0) {
            return 0;
        }
        return new bignumber/* default */.Z(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.yieldCurrent).multipliedBy(amountBuy).decimalPlaces(2, 1).toString();
    }, [
        amountBuy,
        holdingTime,
        nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.yieldCurrent
    ]);
    var investmentAmount = (0,react.useMemo)(function() {
        return new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.nftBalance).multipliedBy(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment).toString();
    }, [
        item,
        nftInfo
    ]);
    var toltalPriceSellNow = (0,react.useMemo)(function() {
        if (holdingTime <= 0) {
            return new bignumber/* default */.Z(new bignumber/* default */.Z(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment)).multipliedBy(amountBuy).toString();
        }
        return new bignumber/* default */.Z(new bignumber/* default */.Z(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment).plus(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.yieldCurrent)).multipliedBy(amountBuy).toString();
    }, [
        amountBuy,
        holdingTime,
        nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.originalInvestment,
        nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.yieldCurrent
    ]);
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.fullVestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.fullVestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref1 = item.fullVestingMap) === null || ref1 === void 0 ? void 0 : ref1.length
    ]);
    var marketPrice = Number(toltalPriceSellNow) / 100 * 20; // => 20%  market price
    var lessMarketPrice = Number(toltalPriceSellNow) - marketPrice;
    var biggerMarketPrice = marketPrice + Number(toltalPriceSellNow);
    var isLessMarketPrice = Number(fillprice) <= Number(toltalPriceSellNow) - marketPrice;
    var isBiggerMarketPrice = Number(fillprice) >= marketPrice + Number(toltalPriceSellNow);
    var isSalesConfirmation = isLessMarketPrice || isBiggerMarketPrice;
    var isCheckIssueDate = (item === null || item === void 0 ? void 0 : item.issueDate) * 1000 < Date.now();
    var ComponentConfirmation = function(param) {
        var compare = param.compare;
        return compare && !sellNow && amountBuy !== 0 && Number(fillprice) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isLessMarketPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "red",
                        fontSize: "12px",
                        children: [
                            "Tổng tiền thỏa thuận phải lớn hơn 80% gi\xe1 thị trường (",
                            Number(lessMarketPrice).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }),
                            " VND)"
                        ]
                    })
                }),
                isBiggerMarketPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "red",
                        fontSize: "12px",
                        children: [
                            "Tổng tiền thỏa thuận phải thấp hơn 120% gi\xe1 thị trường (",
                            Number(biggerMarketPrice).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            }),
                            " VND)"
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_TextTitle, {
                    children: t("Th\xf4ng tin Chứng chỉ Quỹ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_WrapperItemHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: t("Lợi suất")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "LS hiện tại"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Lợi suất hiện tại (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Gốc đầu tư"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Gốc đầu tư (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Ng\xe0y trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: t("Ng\xe0y c\xf2n lại")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_WrapperCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.denominations).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            Number(item === null || item === void 0 ? void 0 : item.profit),
                                            " %"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            totalVested,
                                            "/",
                                            totalVestingMap
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: holdingTime <= 0 ? 0 : Number(new bignumber/* default */.Z(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.yieldCurrent).multipliedBy(item === null || item === void 0 ? void 0 : item.nftBalance).toString()).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z(investmentAmount).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : Number(investmentAmount).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: convertDate(((ref2 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref2 === void 0 ? void 0 : ref2.nextInterestPaymentDate) * 1000)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z((ref3 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref3 === void 0 ? void 0 : ref3.nextInterestPaymentDate).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(getDateBetweenTwoDates(((ref4 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref4 === void 0 ? void 0 : ref4.nextInterestPaymentDate) * 1000), " ").concat(config/* UNIT_DATE */.L$)
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapItemMobile, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    minWidth: "25%",
                                    justifyContent: "flex-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Mệnh gi\xe1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    ml: "4px",
                                                    children: new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.denominations).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    width: "25%",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        totalVested,
                                                        "/",
                                                        totalVestingMap
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    width: "25%",
                                    justifyContent: "flex-end",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Lợi suất",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    children: new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.profit).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : "".concat(item === null || item === void 0 ? void 0 : item.profit, "%")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            justifyContent: "space-between",
                            mt: "1rem",
                            alignItems: "center",
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    minWidth: "30%",
                                    justifyContent: "flex-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Ng\xe0y c\xf2n lại",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    ml: "4px",
                                                    children: new bignumber/* default */.Z((ref5 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref5 === void 0 ? void 0 : ref5.nextInterestPaymentDate).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : "".concat(getDateBetweenTwoDates(((ref6 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref6 === void 0 ? void 0 : ref6.nextInterestPaymentDate) * 1000), " ").concat(config/* UNIT_DATE */.L$)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    width: "33%",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Gốc đầu tư (VND)",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "4px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    children: new bignumber/* default */.Z(investmentAmount).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : Number(investmentAmount).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsFlexHeaderMb, {
                                    minWidth: "21%",
                                    justifyContent: "flex-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                        title: "Ng\xe0y trả lợi suất",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            style: {
                                                cursor: "pointer",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    ml: "4px",
                                                    children: new bignumber/* default */.Z((ref7 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref7 === void 0 ? void 0 : ref7.nextInterestPaymentDate).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : convertDate(((ref8 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref8 === void 0 ? void 0 : ref8.nextInterestPaymentDate) * 1000)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_CsFlex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsBoxLeft, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "text",
                                        fontWeight: "700",
                                        children: t("Th\xf4ng tin giao dịch")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexMaxAbove, {
                                        width: "30%",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                                children: t("Tối đa")
                                            }),
                                            new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.nftBalance).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                width: "42px"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "primaryBright",
                                                bold: true,
                                                fontSize: "14px",
                                                children: item === null || item === void 0 ? void 0 : item.nftBalance
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "CCQ"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                width: "100%",
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                style: {
                                    gap: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: [
                                            "100%",
                                            ,
                                            "60%"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                                children: t("Số lượng giao dịch")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_WrapCount, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_ButtonQuanlity, {
                                                        disabled: amountBuy <= 1,
                                                        onClick: handleMinus,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputQuantity, {
                                                        type: "text",
                                                        scale: "lg",
                                                        inputMode: "numeric",
                                                        placeholder: "".concat(amountBuy),
                                                        value: amountBuy,
                                                        onChange: handleChangeInput
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_ButtonQuanlity, {
                                                        disabled: Number(amountBuy) >= Number(item === null || item === void 0 ? void 0 : item.nftBalance),
                                                        onClick: handlePlus,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexMaxUnder, {
                                        width: "30%",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                                children: t("Tối đa")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.nftBalance).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        width: "42px"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        color: "primaryBright",
                                                        bold: true,
                                                        children: item === null || item === void 0 ? void 0 : item.nftBalance
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        bold: true,
                                                        fontSize: "14px",
                                                        children: "\xa0 CCQ"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            Number(amountBuy) > Number(item === null || item === void 0 ? void 0 : item.nftBalance) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                mt: "10px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "red",
                                    fontSize: "12px",
                                    children: "Số lượng giao dịch nhiều hơn số lượng đang sở hữu"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "space-between",
                                width: "100%",
                                mt: [
                                    "1rem",
                                    ,
                                    "1.5rem"
                                ],
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: [
                                            "100%",
                                            ,
                                            "40%"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                            children: t("Phương thức b\xe1n")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            "100%",
                                            ,
                                            "50%"
                                        ],
                                        mt: [
                                            "0.5rem",
                                            ,
                                            "0"
                                        ],
                                        justifyContent: "space-between",
                                        style: {
                                            gap: "10px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                                        onChange: function() {
                                                            return handleChangeSell(true);
                                                        },
                                                        checked: sellNow === !false
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValue, {
                                                        ml: [
                                                            "4px",
                                                            ,
                                                            "6px"
                                                        ],
                                                        children: t("B\xe1n ngay")
                                                    })
                                                ]
                                            }),
                                            isCheckIssueDate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxV2/* default */.Z, {
                                                        onChange: function() {
                                                            return handleChangeSell(false);
                                                        },
                                                        checked: sellNow === false
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValue, {
                                                        ml: [
                                                            "4px",
                                                            ,
                                                            "6px"
                                                        ],
                                                        children: t("B\xe1n thỏa thuận")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            sellNow === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        width: "100%",
                                        mt: [
                                            "1rem",
                                            ,
                                            "1.5rem"
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                width: "40%",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                                    children: t("Tổng tiền thỏa thuận")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexTotal, {
                                                justifyContent: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsNumericFormat, {
                                                        value: fillprice,
                                                        decimalScale: 0,
                                                        thousandSeparator: !false,
                                                        placeholder: "100,000",
                                                        // eslint-disable-next-line no-return-assign, no-param-reassign
                                                        onFocus: function(e) {
                                                            return e.target.placeholder = "";
                                                        },
                                                        onValueChange: function(values) {
                                                            var value = values.value;
                                                            if (Number(value) >= 0) {
                                                                setFillprie(value);
                                                            }
                                                        },
                                                        maxLength: 35,
                                                        allowNegative: false
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        bold: true,
                                                        fontSize: "14px",
                                                        ml: "5px",
                                                        children: "VND"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentConfirmation, {
                                        compare: windowSize <= 1000
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_CsBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                        children: t("Ng\xe0y giao dịch")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValue, {
                                            children: convertDate(new Date().getTime())
                                        })
                                    })
                                ]
                            }),
                            sellNow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                        children: t("Địa chỉ v\xed thụ hưởng")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                        title: account,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomLink, {
                                            style: {
                                                textAlign: "right"
                                            },
                                            onClick: function() {
                                                return handleOpenLink(account);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    fontWeight: "700",
                                                    children: sAccount(account)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                        children: t("Địa chỉ v\xed người mua")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexAddress, {
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsPastIcon, {
                                                        role: "presentation",
                                                        onClick: pasteHandler,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PastIcon/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                        title: addressBuyer || addressBuyer,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CustomInput, {
                                                            placeholder: "",
                                                            type: "text",
                                                            value: addressBuyerEllipsis || addressBuyer,
                                                            onChange: handleChangeAddress
                                                        })
                                                    })
                                                ]
                                            }),
                                            addressBuyer !== "" && !(0,lib.isAddress)(addressBuyer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextError, {
                                                mt: "6px",
                                                children: "Địa chỉ v\xed sai định dạng"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                        children: t("Tổng gi\xe1 trị giao dịch")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValuePrice, {
                                                            children: sellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: (toltalPriceSellNow === null || toltalPriceSellNow === void 0 ? void 0 : toltalPriceSellNow.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: Number(toltalPriceSellNow).toLocaleString("en", {
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })
                                                                }) : "0"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                children: (fillprice === null || fillprice === void 0 ? void 0 : fillprice.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: Number(fillprice).toLocaleString("en", {
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })
                                                                }) : "0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            fontSize: [
                                                                "12px",
                                                                ,
                                                                "14px"
                                                            ],
                                                            color: "text",
                                                            bold: true,
                                                            ml: "5px",
                                                            children: "VND"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeToken, {
                                                    price: sellNow ? toltalPriceSellNow : fillprice
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                mt: [
                                    "1rem",
                                    ,
                                    "1rem"
                                ],
                                width: "100%",
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                                        children: t("Lợi suất hiện tại")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        alignItems: "flex-end",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        alignItems: "center",
                                                        children: new bignumber/* default */.Z(currentYield).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            width: "42px"
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValuePrice, {
                                                                fontWeight: "700",
                                                                fontSize: "14px",
                                                                children: Number(currentYield).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        fontSize: [
                                                            "12px",
                                                            ,
                                                            "14px"
                                                        ],
                                                        color: "text",
                                                        bold: true,
                                                        ml: "5px",
                                                        children: "VND"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                mt: "4px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellModal_CsUnit, {
                                                    style: {
                                                        color: "#8C8D8E"
                                                    },
                                                    children: [
                                                        "(~",
                                                        holdingTime <= 0 ? 0 : nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.rate,
                                                        "%)"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentConfirmation, {
                compare: windowSize >= 1000
            }),
            !sellNow && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mt: [
                        "1rem",
                        ,
                        "1rem"
                    ],
                    width: [
                        "100%",
                        ,
                        ,
                        "50%"
                    ],
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLabel, {
                            children: t("Gi\xe1 thị trường")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextValuePrice, {
                                    children: !sellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: (toltalPriceSellNow === null || toltalPriceSellNow === void 0 ? void 0 : toltalPriceSellNow.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: Number(toltalPriceSellNow).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        }) : "0"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: (fillprice === null || fillprice === void 0 ? void 0 : fillprice.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: Number(fillprice).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        }) : "0"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "text",
                                    bold: true,
                                    ml: "5px",
                                    children: "VND"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "1.5rem"
                ],
                children: (account === null || account === void 0 ? void 0 : account.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (item === null || item === void 0 ? void 0 : item.isApprovedForAll) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: sellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsButtonConfirm, {
                            disabled: pendingSellNow || (item === null || item === void 0 ? void 0 : item.paused) || amountBuy === 0 || !isCheckIssueDate,
                            onClick: handleSellnow,
                            endIcon: pendingSellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                spin: true,
                                color: "textSubtle"
                            }) : null,
                            children: "X\xe1c nhận b\xe1n"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                (account === null || account === void 0 ? void 0 : account.toLowerCase()) === (addressBuyer === null || addressBuyer === void 0 ? void 0 : addressBuyer.toLowerCase()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    style: {
                                        textAlign: "center",
                                        color: "red",
                                        fontSize: "13px",
                                        marginTop: "10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px"
                                    },
                                    children: "Địa chỉ v\xed tr\xf9ng, vui l\xf2ng thay đổi!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsButtonConfirm, {
                                    disabled: !isCheckIssueDate || checkDisableBtnBuy || pendingListp2p || (item === null || item === void 0 ? void 0 : item.paused) || amountBuy === 0 || isSalesConfirmation || (account === null || account === void 0 ? void 0 : account.toLowerCase()) === (addressBuyer === null || addressBuyer === void 0 ? void 0 : addressBuyer.toLowerCase()),
                                    onClick: handleListp2p,
                                    endIcon: pendingListp2p ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                        spin: true,
                                        color: "textSubtle"
                                    }) : null,
                                    children: "X\xe1c nhận b\xe1n"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: requestedApproveRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: sellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsButtonConfirm, {
                                disabled: pendingSellNow || (item === null || item === void 0 ? void 0 : item.paused) || amountBuy === 0 || !isCheckIssueDate,
                                onClick: handleSellnow,
                                endIcon: pendingSellNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                }) : null,
                                children: "X\xe1c nhận b\xe1n"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsButtonConfirm, {
                                disabled: checkDisableBtnBuy || pendingListp2p || (item === null || item === void 0 ? void 0 : item.paused) || isSalesConfirmation || amountBuy === 0 || !isCheckIssueDate,
                                onClick: handleListp2p,
                                endIcon: pendingListp2p ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                }) : null,
                                children: "X\xe1c nhận b\xe1n"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SellModal_CsButtonConfirm, {
                            disabled: pendingApproveRedeem || (item === null || item === void 0 ? void 0 : item.paused) || !isCheckIssueDate,
                            onClick: handleApproveRedeem,
                            endIcon: pendingApproveRedeem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                spin: true,
                                color: "textSubtle"
                            }) : null,
                            children: "Chấp thuận"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsConnectWalletButton, {})
                })
            }),
            (item === null || item === void 0 ? void 0 : item.paused) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "1rem"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "12px",
                        ,
                        ,
                        "14px"
                    ],
                    color: "red",
                    children: t("CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!")
                })
            }),
            addressBuyer && fillprice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CsFlexAgree, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Bằng c\xe1ch “X\xe1c nhận b\xe1n” t\xf4i đồng \xfd với")
                    }),
                    checkDisableBtnBuy || penddingDowload ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsLink, {
                        children: t("hợp đồng chuyển nhượng Chứng chỉ Quỹ ")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsLink, {
                        onClick: handleDownload,
                        children: t("hợp đồng chuyển nhượng Chứng chỉ Quỹ ")
                    })
                ]
            })
        ]
    }));
};
var CsConnectWalletButton = (0,styled_components_browser_esm/* default */.ZP)(ConnectWalletButton/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-0"
})(SellModal_templateObject());
var CsFlexMaxAbove = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-1"
})(SellModal_templateObject1());
var CsFlexMaxUnder = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-2"
})(SellModal_templateObject2());
var CsTextError = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-3"
})(SellModal_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var SellModal_CsNumericFormat = (0,styled_components_browser_esm/* default */.ZP)(react_number_format_es/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-4"
})(SellModal_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsPastIcon = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-5"
})(SellModal_templateObject5());
var TextLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-6"
})(SellModal_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TextValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-7"
})(SellModal_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var TextValuePrice = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-8"
})(SellModal_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var SellModal_TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-9"
})(SellModal_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var SellModal_CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-10"
})(SellModal_templateObject10());
var CsBoxLeft = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-11"
})(SellModal_templateObject11());
var SellModal_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-12"
})(SellModal_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsFlexTotal = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-13"
})(SellModal_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsFlexAddress = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-14"
})(SellModal_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var SellModal_CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-15"
})(SellModal_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CustomInputQuantity = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-16"
})(SellModal_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var SellModal_ButtonQuanlity = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-17"
})(SellModal_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var SellModal_WrapCount = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-18"
})(SellModal_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.colors.success3;
});
var SellModal_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-19"
})(SellModal_templateObject19());
var SellModal_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-20"
})(SellModal_templateObject20());
var SellModal_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-21"
})(SellModal_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var SellModal_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c68d0c77-22"
})(SellModal_templateObject22());
var SellModal_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-23"
})(SellModal_templateObject23(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var SellModal_CsFlexHeaderMb = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c68d0c77-24"
})(SellModal_templateObject24());
var SellModal_CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c68d0c77-25"
})(SellModal_templateObject25());
/* harmony default export */ var components_SellModal = (SellModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/components/Row.tsx


function components_Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 10px;\n    font-weight: 500;\n    padding: 3px 15px;\n    border-radius: 4px;\n    letter-spacing: 0.04em;\n    text-align: center;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 400px){\n        padding: 3px 8px;\n    }\n"
    ]);
    components_Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_Row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 12px 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    ",
        " {\n        margin: 8px 0;\n        font-size: 12px;\n        font-weight: 600;\n        &:last-child {\n            text-align: right;\n        }\n    }\n"
    ]);
    components_Row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Row_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: column;\n"
    ]);
    Row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Row_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    Row_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Row_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    Row_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Row_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    padding: 26px;\n    height: 80px !important;\n    align-items: center;\n    position: relative;\n    flex-direction: row;\n    border-radius: 20px;\n    margin-top: 24px;\n    justify-content: space-between;\n    border: 1px solid ",
        ";\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n        line-height: 19px;\n    }\n"
    ]);
    Row_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Row_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    font-size: 12px;\n    font-weight: 600;\n    min-width: 130px;\n    border-radius: 4px;\n    background: transparent;\n    color: ",
        ";\n    border: 1px solid ",
        ";\n    transition: 0.5s;\n    &:hover {\n        background: ",
        ";\n        color: ",
        ";\n        border: 1px solid transparent;\n    }\n    @media screen and (max-width: 768px) {\n        width: 100%;\n        height: 36px;\n        padding: 0;\n    }\n    @media screen and (max-width: 500px) {\n        min-width: 90px;\n    }\n"
    ]);
    Row_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Row_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    font-size: 12px;\n    font-weight: 600;\n    min-width: 130px;\n    border-radius: 4px;\n    background: ",
        ";\n    color: ",
        ";\n    border: 1px solid transparent;\n    transition: 0.5s;\n    &:hover {\n        background: transparent;\n        color: ",
        ";\n        border: 1px solid ",
        ";\n    }\n    @media screen and (max-width: 768px) {\n        width: 100%;\n        height: 36px;\n        padding: 0;\n    }\n    @media screen and (max-width: 500px) {\n        min-width: 90px;\n    }\n"
    ]);
    Row_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Row_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-end;\n    width: 15%;\n    height: 40px;\n    @media screen and (max-width: 768px) {\n        width: 25%;\n    }\n"
    ]);
    Row_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}











var Row_Row = function(param) {
    var item = param.item, windowSize = param.windowSize, account = param.account, chainId = param.chainId, vestingMap = param.vestingMap, currentTime = param.currentTime, indexRow = param.indexRow;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var yieldsReceived = (0,react.useMemo)(function() {
        var ref;
        return new bignumber/* default */.Z((ref = vestingMap[0]) === null || ref === void 0 ? void 0 : ref.vestAmount).multipliedBy(item === null || item === void 0 ? void 0 : item.nftBalance).toString();
    }, [
        item === null || item === void 0 ? void 0 : item.nftBalance,
        vestingMap
    ]) // lợi suất sắp nhận
    ;
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfitReceivedModal, {
        chainId: chainId,
        account: account,
        price: item === null || item === void 0 ? void 0 : item.denominations,
        profit: "".concat(Number(item === null || item === void 0 ? void 0 : item.profit), "%"),
        currentyield: (ref = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref === void 0 ? void 0 : ref.vestAmount,
        origininvest: Number(item === null || item === void 0 ? void 0 : item.denominations) * Number(item === null || item === void 0 ? void 0 : item.nftBalance),
        interestPayDate: (ref1 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref1 === void 0 ? void 0 : ref1.nextInterestPaymentDate,
        dayleft: getDateBetweenTwoDates(((ref2 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref2 === void 0 ? void 0 : ref2.nextInterestPaymentDate) * 1000),
        windowSize: windowSize,
        title: "Th\xf4ng tin Chứng chỉ Quỹ",
        dataUser: item
    }), true, true, "modal_profitreceivedmodal_".concat(indexRow)), 1), onProfitReceivedModal = ref17[0];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReceivedAll, {
        chainId: chainId,
        account: account,
        price: item === null || item === void 0 ? void 0 : item.denominations,
        profit: "".concat(Number(item === null || item === void 0 ? void 0 : item.profit), "%"),
        currentyield: (ref3 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref3 === void 0 ? void 0 : ref3.vestAmount,
        origininvest: Number(item === null || item === void 0 ? void 0 : item.denominations) * Number(item === null || item === void 0 ? void 0 : item.nftBalance),
        interestPayDate: (ref4 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref4 === void 0 ? void 0 : ref4.nextInterestPaymentDate,
        dayleft: getDateBetweenTwoDates(((ref5 = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref5 === void 0 ? void 0 : ref5.nextInterestPaymentDate) * 1000),
        windowSize: windowSize,
        title: "Th\xf4ng tin Chứng chỉ Quỹ",
        dataUser: item
    }), true, true, "modal_receivedAll_".concat(item === null || item === void 0 ? void 0 : item.nftAddress, "_").concat(indexRow)), 1), onReceivedAll = ref18[0];
    var ref19 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SellModal, {
        item: item,
        windowSize: windowSize,
        title: "Th\xf4ng tin Chứng chỉ Quỹ",
        account: account,
        chainId: chainId
    }), true, true, "modal_sell_".concat(item === null || item === void 0 ? void 0 : item.nftAddress, "_").concat(indexRow)), 1), onSellModal = ref19[0];
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.fullVestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.fullVestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.fullVestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref6 = item.fullVestingMap) === null || ref6 === void 0 ? void 0 : ref6.length
    ]);
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail, {
        item: item,
        totalVested: totalVested,
        totalVestingMap: totalVestingMap,
        yieldsReceived: yieldsReceived
    }), true, true, "modal_detals_".concat(item === null || item === void 0 ? void 0 : item.nftAddress, "_").concat(indexRow)), 1), openDetailModal = ref20[0];
    var totalPrice = (0,react.useMemo)(function() {
        return Number(item.denominations) * Number(item === null || item === void 0 ? void 0 : item.nftBalance);
    }, [
        item
    ]);
    var isTimeCanClaim = currentTime > ((ref7 = vestingMap[0]) === null || ref7 === void 0 ? void 0 : ref7.nextInterestPaymentDate) * 1000;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: windowSize > 768 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperTable, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperTableContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "9.4%",
                            children: item === null || item === void 0 ? void 0 : item.nftBalance
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "9.4%",
                            children: Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            width: "9.4%",
                            children: [
                                item === null || item === void 0 ? void 0 : item.intervestTerm,
                                " th\xe1ng"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            width: "9.4%",
                            children: [
                                totalVested,
                                "/",
                                totalVestingMap
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            width: "9.4%",
                            children: [
                                " ",
                                Number(item === null || item === void 0 ? void 0 : item.profit),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "9.4%",
                            justifyContent: "center",
                            children: (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? convertDate((item === null || item === void 0 ? void 0 : item.expireDate) * 1000) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: convertDate(((ref8 = vestingMap[0]) === null || ref8 === void 0 ? void 0 : ref8.nextInterestPaymentDate) * 1000)
                            })
                        }),
                        (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            width: "9.4%",
                            children: [
                                "0 ",
                                config/* UNIT_DATE */.L$
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: new bignumber/* default */.Z(((ref9 = vestingMap[0]) === null || ref9 === void 0 ? void 0 : ref9.nextInterestPaymentDate) * 1000).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "10%",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: "42px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                width: "10%",
                                children: [
                                    getDateBetweenTwoDates(((ref10 = vestingMap[0]) === null || ref10 === void 0 ? void 0 : ref10.nextInterestPaymentDate) * 1000),
                                    " ",
                                    config/* UNIT_DATE */.L$
                                ]
                            })
                        }),
                        (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "9.4%",
                            children: "0"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: new bignumber/* default */.Z((ref11 = vestingMap[0]) === null || ref11 === void 0 ? void 0 : ref11.vestAmount).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "10%",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: "42px"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                width: "10%",
                                children: [
                                    " ",
                                    Number(yieldsReceived).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "9.4%",
                            children: totalPrice.toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WraperBtnSell, {
                            children: (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: currentTime > Number((ref12 = vestingMap[0]) === null || ref12 === void 0 ? void 0 : ref12.nextInterestPaymentDate) * 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonReceiProfit, {
                                    disabled: !isTimeCanClaim,
                                    onClick: onProfitReceivedModal,
                                    children: "Nhận lợi suất"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButton, {
                                    onClick: onSellModal,
                                    disabled: (item === null || item === void 0 ? void 0 : item.issueDate) * 1000 > Date.now(),
                                    children: "B\xe1n"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: (item === null || item === void 0 ? void 0 : item.isExpire) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButton, {
                                    onClick: onReceivedAll,
                                    children: "Đ\xe1o hạn"
                                })
                            })
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperTableMobile, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_WrapItemMobile, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        mt: "0.5rem",
                        alignItems: "center",
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "25%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {
                                        width: "20px",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        onClick: openDetailModal
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        children: [
                                            "SL:",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        children: [
                                            "\xa0",
                                            item === null || item === void 0 ? void 0 : item.nftBalance
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "25%",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_CsTextMonth, {
                                    children: [
                                        item === null || item === void 0 ? void 0 : item.intervestTerm,
                                        " th\xe1ng"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "25%",
                                justifyContent: "center",
                                children: (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        "0 ",
                                        config/* UNIT_DATE */.L$
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: new bignumber/* default */.Z(((ref13 = vestingMap[0]) === null || ref13 === void 0 ? void 0 : ref13.nextInterestPaymentDate) * 1000).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        width: "42px"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        children: [
                                            getDateBetweenTwoDates(((ref14 = vestingMap[0]) === null || ref14 === void 0 ? void 0 : ref14.nextInterestPaymentDate) * 1000),
                                            " ",
                                            config/* UNIT_DATE */.L$
                                        ]
                                    })
                                })
                            }),
                            (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "25%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        "0 ",
                                        config/* UNIT_DATE */.L$
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: new bignumber/* default */.Z(((ref15 = vestingMap[0]) === null || ref15 === void 0 ? void 0 : ref15.nextInterestPaymentDate) * 1000).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    width: "25%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        width: "42px"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "25%",
                                    children: Number(item === null || item === void 0 ? void 0 : item.denominations).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "space-between",
                        mt: "0.5rem",
                        alignItems: "center",
                        flexWrap: "wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: [
                                    "20%",
                                    "25%",
                                    "25%",
                                    "25%"
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        children: [
                                            "LSSN:",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        children: [
                                            "\xa0",
                                            (item === null || item === void 0 ? void 0 : item.isExpire) && (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) === 0 ? "0" : Number(yieldsReceived).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: [
                                    "28%",
                                    "25%",
                                    "25%",
                                    "25%"
                                ],
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: totalPrice.toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: [
                                    "28%",
                                    "25%",
                                    "25%",
                                    "25%"
                                ],
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    children: [
                                        totalVested,
                                        "/",
                                        totalVestingMap
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(WraperBtnSell, {
                                children: (vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: currentTime > Number((ref16 = vestingMap[0]) === null || ref16 === void 0 ? void 0 : ref16.nextInterestPaymentDate) * 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonReceiProfit, {
                                        disabled: !isTimeCanClaim,
                                        onClick: onProfitReceivedModal,
                                        children: "Nhận lợi suất"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButton, {
                                        disabled: (item === null || item === void 0 ? void 0 : item.issueDate) * 1000 > Date.now(),
                                        onClick: onSellModal,
                                        children: "B\xe1n"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: (item === null || item === void 0 ? void 0 : item.isExpire) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButton, {
                                        onClick: onReceivedAll,
                                        children: "Đ\xe1o hạn"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_Row = (Row_Row);
var Row_CsTextMonth = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-2a91671b-0"
})(components_Row_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var Row_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a91671b-1"
})(components_Row_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var WrapperTableMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2a91671b-2"
})(Row_templateObject2());
var WrapperTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a91671b-3"
})(Row_templateObject3());
var WrapperTableContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2a91671b-4"
})(Row_templateObject4());
var WrapItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2a91671b-5"
})(Row_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, Text/* default */.Z);
var Row_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-2a91671b-6"
})(Row_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return disabled ? "#E6E8ec" : theme.colors.primary;
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return disabled ? "#8C8D8E" : theme.colors.white;
});
var CsButtonReceiProfit = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-2a91671b-7"
})(Row_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var WraperBtnSell = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2a91671b-8"
})(Row_templateObject8());

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsAsset/index.tsx


function TabsAsset_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n    width: 9.4%;\n"
    ]);
    TabsAsset_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsAsset_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 100px;\n    margin-top: 60px;\n    align-items: center;\n    @media screen and (max-width: 1200px){\n        gap: 60px;\n        ",
        "{\n            font-size: 22px;\n        }\n    }\n    @media screen and (max-width: 1000px){\n        gap: 60px;\n        margin-top: 30px;\n        margin-bottom: 20px;\n        ",
        "{\n            font-size: 18px;\n        }\n    }\n    @media screen and (max-width: 767px){\n        gap: 20px;\n        margin-top: 30px;\n        grid-template-columns: repeat(1, minmax(0, 1fr));\n        ",
        "{\n            font-size: 16px;\n        }\n    }\n    @media screen and (max-width: 600px){\n        ",
        "{\n            font-size: 14px;\n        }\n    }\n    h6 {\n        font-size: 1.25rem;\n        color: #8c8d8e;\n        font-weight: 500;\n    }\n    p {\n        color: #f9a138;\n        font-size: 1.75rem;\n        font-weight: 500;\n        span {\n            color: #02111b;\n            font-weight: 600;\n        }\n    }\n    ",
        " {\n        justify-content: space-between;\n    }\n"
    ]);
    TabsAsset_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabsAsset_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: relative;\n    flex-direction: row;\n    border-radius: 20px;\n    margin: 40px 0 0px 0;\n    padding: 0 26px;\n    align-items: center;\n    justify-content: space-between;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    TabsAsset_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabsAsset_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    width: 100%;\n    justify-content: center;\n    margin-top:1rem;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color: #13486b;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n    }\n    .page-link {\n        width: 32px;\n        height: 32px;\n        display: flex;\n        font-size: 14px !important;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px !important;\n        color: #02111b;\n        border: 1px solid #efefef;\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            background: #13486b;\n            color: #fff;\n            border: 1px solid #13486b !important;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n    }\n    .page-item.active .page-link {\n        background: #13486b;\n        color: #fff;\n        border: none;\n    }\n"
    ]);
    TabsAsset_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var TabsAsset_pageSize = 7;
var TabsAsset = function(param) {
    var windowSize = param.windowSize;
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    var currentTime = Date.now();
    var token = renderToken(chainId);
    UseCoreAsset(token === null || token === void 0 ? void 0 : token.address, account, chainId);
    var ref2 = GetDataAsset(), listUserBalance = ref2.listUserBalance, isLoading = ref2.isLoading;
    var listAssetItem = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(listUserBalance);
    }, [
        listUserBalance
    ]);
    var sortList = (0,_to_consumable_array/* default */.Z)(listAssetItem).sort(function(a, b) {
        return (b === null || b === void 0 ? void 0 : b.holdingDate) - (a === null || a === void 0 ? void 0 : a.holdingDate);
    });
    var totalAmount = (0,react.useMemo)(function() {
        return sortList.reduce(function(acc, item) {
            return acc + Number(item.nftBalance);
        }, 0);
    }, [
        sortList
    ]);
    var totalPrice = (0,react.useMemo)(function() {
        return sortList.reduce(function(acc, item) {
            return acc + Number(item.denominations) * Number(item === null || item === void 0 ? void 0 : item.nftBalance);
        }, 0);
    }, [
        sortList
    ]);
    var totalYieldReceive = (0,react.useMemo)(function() {
        return sortList.reduce(function(acc, item) {
            var ref;
            return acc + Number(((ref = item === null || item === void 0 ? void 0 : item.vestingMap[0]) === null || ref === void 0 ? void 0 : ref.vestAmount) || 0) * Number(item === null || item === void 0 ? void 0 : item.nftBalance);
        }, 0);
    }, [
        sortList
    ]);
    var total = sortList.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperTotal, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "20px",
                                color: "#8C8D8E",
                                children: "Tổng mệnh gi\xe1"
                            }),
                            new bignumber/* default */.Z(totalPrice).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "0"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primaryBright",
                                        fontSize: "28px",
                                        children: totalPrice.toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "28px",
                                        bold: true,
                                        ml: "5px",
                                        children: "VND"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "20px",
                                color: "#8C8D8E",
                                children: "Tổng lợi suất sắp nhận"
                            }),
                            new bignumber/* default */.Z(totalYieldReceive).isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "0"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primaryBright",
                                        fontSize: "28px",
                                        children: totalYieldReceive.toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "28px",
                                        bold: true,
                                        ml: "5px",
                                        children: "VND"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            windowSize > 768 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperTableHeader, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsAsset_CsFlexHeader, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            mr: "0.2rem",
                            children: [
                                "SL (",
                                totalAmount.toLocaleString("en", {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                }),
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "Mệnh gi\xe1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Mệnh gi\xe1 (VND)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "Kỳ nhận LS"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Kỳ nhận lợi suất",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "Kỳ đ\xe3 nhận"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "LS/năm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Lợi suất/năm",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "Ng\xe0y trả LS"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Ng\xe0y trả lợi suất",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        width: "9.4%",
                        children: "Ng\xe0y c\xf2n lại"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "LSSN"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Lợi suất sắp nhận (VND)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsAsset_CsFlexHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mr: "0.2rem",
                                children: "Tổng MG"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: "Tổng mệnh gi\xe1 (VND)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        width: "15%"
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: "1.5rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "textSubtle"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: sortList.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: "1.5rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Kh\xf4ng c\xf3 dữ liệu"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        sortList.splice(itemOffset, TabsAsset_pageSize).map(function(data, key) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_Row, {
                                item: data,
                                windowSize: windowSize,
                                account: account,
                                chainId: chainId,
                                vestingMap: data === null || data === void 0 ? void 0 : data.vestingMap,
                                currentTime: currentTime,
                                indexRow: key
                            });
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsAsset_CustomFlex, {
                            children: sortList.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPaginate, {
                                total: total,
                                pageSize: TabsAsset_pageSize,
                                setItemOffset: setItemOffset
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var TabsAsset_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7fb0b11-0"
})(TabsAsset_templateObject());
var WrapperTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e7fb0b11-1"
})(TabsAsset_templateObject1(), Text/* default */.Z, Text/* default */.Z, Text/* default */.Z, Text/* default */.Z, Flex/* default */.Z);
var WrapperTableHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7fb0b11-2"
})(TabsAsset_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsAsset_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7fb0b11-3"
})(TabsAsset_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
/* harmony default export */ var FooterTabs_TabsAsset = (TabsAsset);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 52 modules
var TextField = __webpack_require__(49833);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js + 86 modules
var DesktopDatePicker = __webpack_require__(5651);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/index.js + 1 modules
var AdapterDayjs = __webpack_require__(26829);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Search.tsx
var Search = __webpack_require__(19881);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(76376);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/IconSort.tsx
var IconSort = __webpack_require__(51421);
;// CONCATENATED MODULE: ./src/components/Select/SelectCustom.tsx




function SelectCustom_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  transition: border-radius 0.15s;\n  color: #fdb533;\n  > svg {\n    fill: #fff !important;\n  }\n\n  @media screen and (max-width: 600px) {\n    padding: 0 10px;\n  }\n"
    ]);
    SelectCustom_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 179px;\n  height: 100%;\n  max-height:250px;\n  padding: 12px;\n  position: absolute;\n  overflow-y: hidden;\n  overflow-x:hidden;\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  box-sizing: border-box;\n  border-radius: 10px;\n  background: ",
        ";\n  /* color: ",
        " !important; */\n  ",
        " {\n    min-width: 50px;\n  }\n"
    ]);
    SelectCustom_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        /* box-shadow: ",
        "; */\n      }\n\n      ",
        " {\n        height: auto;\n        transform: scaleY(1);\n        opacity: 1;\n        border-top-width: 0;\n        box-shadow: ",
        ";\n        width: 100%;\n        background: #ffffff;\n        top: 49px;\n        border-radius: 8px;\n      }\n    "
    ]);
    SelectCustom_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  width: ",
        "px;\n  position: relative;\n  width: 180px;\n  height: 48px;\n  box-sizing: border-box;\n  @media only screen and (max-width: 1024px){\n        width: 160px;\n    }\n  @media only screen and (max-width: 1000px) {\n    width: 100%;\n    height: 42px;\n  }\n  ",
        " {\n    // border-right: 0.15px solid rgba(151, 151, 151, 0.69);\n  }\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n\n  ",
        " {\n    min-width: 100px;\n  }\n\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    fill: ",
        ";\n    @media only screen and (max-width: 1000px) {\n      right: 6px;\n    }\n  }\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n  }\n"
    ]);
    SelectCustom_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  background:  ",
        ";\n  z-index: ",
        ";\n"
    ]);
    SelectCustom_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 8px 16px;\n  border-radius:6px;\n  @media only screen and (max-width: 1000px) {\n    padding: 4px 8px;\n  }\n  div{\n    font-size: 14px;\n  }\n  &:hover {\n    background: ",
        ";\n    > div {\n      color: #fff !important;\n    }\n  }\n"
    ]);
    SelectCustom_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SelectCustom_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 320px) {\n    padding: 0px\n  }\n"
    ]);
    SelectCustom_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6219156-0"
})(SelectCustom_templateObject());
var DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6219156-1"
})(SelectCustom_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "#fdb533" : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6219156-2"
})(SelectCustom_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(SelectCustom_templateObject2(), DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    });
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-f6219156-3"
})(SelectCustom_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-f6219156-4"
})(SelectCustom_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var SelectCustom = function(_param) {
    var options = _param.options, onChange = _param.onChange, onOptionChange = _param.onOptionChange, defaultOptionIndex = _param.defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onChange",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react.useState)(0), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var toggling = function(event) {
        if (options.length > 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    var theme = (0,useTheme/* default */.ZP)().theme;
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOpen: isOpen,
        ref: containerRef
    }, containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "14px",
                        ,
                        "16px"
                    ],
                    color: "primary",
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                color: theme.isDark ? "#fff" : "#000",
                onClick: toggling
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownList, {
                    ref: dropdownRef,
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Select_SelectCustom = (SelectCustom);
var CustomListItem = (0,styled_components_browser_esm/* default */.ZP)(ListItem).withConfig({
    componentId: "sc-f6219156-5"
})(SelectCustom_templateObject6());

// EXTERNAL MODULE: ./src/state/index.ts + 35 modules
var state = __webpack_require__(79454);
// EXTERNAL MODULE: ./src/state/history/actions.ts
var history_actions = __webpack_require__(32752);
;// CONCATENATED MODULE: ./src/state/history/fetchData.ts




var renderType = function(type) {
    if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === "buy") {
        return 1;
    }
    return 2;
};
var fetchListHistory = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(account, itemOffset, pageActive, fromData, toData, searchData, orderTypeData, chainId) {
        var ref, ref1, ref2, ref3, response, dataTemp, result, index, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axiosClient.get("/trade-history", {
                            headers: {
                                "Content-Type": "application/json",
                                "Accept": "*"
                            },
                            params: {
                                userWalletAddress: account,
                                pageSize: itemOffset,
                                pageIndex: pageActive + 1,
                                search: searchData,
                                orderType: orderTypeData,
                                fromDate: fromData,
                                toDate: toData,
                                chainKey: (0,config/* chainKey */._X)(chainId)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    dataTemp = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data;
                    result = [];
                    for(index = 0; index < (dataTemp === null || dataTemp === void 0 ? void 0 : (ref1 = dataTemp.items) === null || ref1 === void 0 ? void 0 : ref1.length); index++){
                        ;
                        result.push({
                            historyId: (ref4 = dataTemp === null || dataTemp === void 0 ? void 0 : dataTemp.items[index]) === null || ref4 === void 0 ? void 0 : ref4.tokenId,
                            dayTrading: (ref5 = dataTemp.items[index]) === null || ref5 === void 0 ? void 0 : ref5.createdAt,
                            transaction: (ref6 = dataTemp.items[index]) === null || ref6 === void 0 ? void 0 : ref6.transactionNumber,
                            jointsOrderQuantity: (ref7 = dataTemp.items[index]) === null || ref7 === void 0 ? void 0 : ref7.tradedQuantity,
                            totalTxValue: Number((ref8 = dataTemp.items[index]) === null || ref8 === void 0 ? void 0 : ref8.totalValue),
                            status: (ref9 = dataTemp.items[index]) === null || ref9 === void 0 ? void 0 : ref9.status,
                            seller: (ref10 = dataTemp.items[index]) === null || ref10 === void 0 ? void 0 : ref10.sellerAddress,
                            buyer: (ref11 = dataTemp.items[index]) === null || ref11 === void 0 ? void 0 : ref11.buyerAddress,
                            etfContract: (ref12 = dataTemp.items[index]) === null || ref12 === void 0 ? void 0 : ref12.etfContract,
                            eventType: (ref13 = dataTemp.items[index]) === null || ref13 === void 0 ? void 0 : ref13.eventType,
                            isSeller: (account === null || account === void 0 ? void 0 : account.toLowerCase()) === ((ref14 = dataTemp.items[index]) === null || ref14 === void 0 ? void 0 : ref14.sellerAddress.toLowerCase())
                        });
                    }
                    return [
                        2,
                        {
                            listItemHistory: result,
                            totalItem: response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.totalItems
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listItemHistory: [],
                            totalItem: 0
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchListHistory(account, itemOffset, pageActive, fromData, toData, searchData, orderTypeData, chainId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/history/index.ts






var UseCoreListHistory = function(account, pageSize, pageIndex, fromData, toData, searchData, orderTypeData, chainId) {
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,useRefreshEffect/* useSlowRefreshEffect */.X)(function() {
        var getDataListHistory = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            dispatch((0,history_actions/* fetchStatusLoading */.Xy)({
                                isLoading: true
                            }));
                            return [
                                4,
                                fetchListHistory(account, pageSize, pageIndex, fromData, toData, searchData, orderTypeData, chainId)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,history_actions/* listItemHistory */.Ft)({
                                listItemHistory: result === null || result === void 0 ? void 0 : result.listItemHistory
                            }));
                            dispatch((0,history_actions/* getTotalItem */.xE)({
                                totalItem: result === null || result === void 0 ? void 0 : result.totalItem
                            }));
                            dispatch((0,history_actions/* fetchStatusLoading */.Xy)({
                                isLoading: false
                            }));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataListHistory() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account === null || account === void 0 ? void 0 : account.length) {
            getDataListHistory();
        } else {
            dispatch((0,history_actions/* listItemHistory */.Ft)({
                listItemHistory: []
            }));
        }
    }, [
        account,
        dispatch,
        fromData,
        orderTypeData,
        pageIndex,
        pageSize,
        searchData,
        toData
    ]);
};
var GetListHistory = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.history;
    });
    return data;
};
var GetItemHistory = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.history;
    });
    var itemHistoryValue = data === null || data === void 0 ? void 0 : data.itemHistory;
    return itemHistoryValue;
};

;// CONCATENATED MODULE: ./src/utils/renderProfit.tsx

function renderProfit_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 600;\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    renderProfit_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var renderProfitPercent = function(holdingDate) {
    if (holdingDate < 15) {
        return "6.0%";
    }
    if (holdingDate >= 15 && holdingDate < 30) {
        return "7.0%";
    }
    if (holdingDate >= 30 && holdingDate < 92) {
        return "8.0%";
    }
    if (holdingDate >= 92 && holdingDate < 184) {
        return "9.2%";
    }
    return "";
};
var renderProfit_renderType = function(isSeller, eventType) {
    if (!isSeller) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderProfit_CsText, {
            color: "success3",
            children: "Mua"
        });
    }
    if (isSeller) {
        if (eventType === "_eventSellNow") return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderProfit_CsText, {
            color: "red",
            children: "B\xe1n ngay"
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderProfit_CsText, {
            color: "red",
            children: "B\xe1n thoả thuận"
        });
    }
    return null;
};
var renderStatus = function(status) {
    if ((status === null || status === void 0 ? void 0 : status.toLowerCase()) === "success") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderProfit_CsText, {
            color: "success3",
            children: "Th\xe0nh c\xf4ng"
        });
    }
    if ((status === null || status === void 0 ? void 0 : status.toLowerCase()) === "cancel") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderProfit_CsText, {
            color: "red",
            children: "Đ\xe3 hủy"
        });
    }
    return null;
};
var renderProfit_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-5eacfcd1-0"
})(renderProfit_templateObject());
var renderAddressByType = function(isSeller, buyer, seller) {
    if (isSeller) {
        return seller;
    }
    if (!isSeller) {
        return buyer;
    }
    return null;
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsHistory/styles.tsx

function TabsHistory_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 45%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    TabsHistory_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    margin-top: 4rem;\n    @media screen and (max-width: 1000px) {\n        flex-direction: column;\n        margin-top: 2rem;\n    }\n"
    ]);
    TabsHistory_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n    text-align: right;\n"
    ]);
    TabsHistory_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    @media screen and (max-width: 586px) {\n        font-size: 24px;\n    }\n"
    ]);
    TabsHistory_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 1.5rem;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    flex-direction: column;\n    ",
        " {\n        text-decoration: underline;\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 1.5;\n        color: ",
        ";\n        @media screen and (max-width: 586px) {\n            font-size: 14px;\n        }\n    }\n"
    ]);
    TabsHistory_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 65px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    @media screen and (max-width: 768px) {\n        font-size: 14px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 112px;\n        border-radius: 4px;\n    }\n"
    ]);
    TabsHistory_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: underline;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.5;\n    color: ",
        ";\n    @media screen and (max-width: 586px) {\n        font-size: 14px;\n    }\n"
    ]);
    TabsHistory_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: ",
        ";\n"
    ]);
    TabsHistory_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    min-width: 220px;\n    margin-left: 40px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1024px) {\n        min-width: 120px;\n    }\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 40px;\n        color: ",
        ";\n    }\n"
    ]);
    TabsHistory_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 4rem;\n    @media screen and (max-width: 1024px) {\n        margin-top: 2rem;\n        flex-direction: column;\n    }\n"
    ]);
    TabsHistory_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    width: 40%;\n    ",
        " {\n        font-size: 16px;\n        @media screen and (max-width: 1024px) {\n            font-size: 12px;\n        }\n    }\n    @media screen and (max-width: 1024px) {\n        width: 100%;\n    }\n"
    ]);
    TabsHistory_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        line-height: 50px;\n        text-align: center;\n        padding: 10px 0;\n    }\n"
    ]);
    TabsHistory_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    TabsHistory_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 48px 0 24px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    TabsHistory_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function TabsHistory_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    background: ",
        ";\n    @media screen and (max-width: 600px) {\n        padding: 10px;\n    }\n    ",
        " {\n        font-size: 12px;\n        &:first-child {\n            font-weight: 500;\n            color: ",
        ";\n        }\n    }\n"
    ]);
    TabsHistory_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n    min-width: 990px;\n    @media screen and (max-width: 1024px) {\n        min-width: 90%;\n        padding: 0;\n    }\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 34px;\n    font-weight: 700;\n    @media screen and (max-width: 768px) {\n        font-size: 24px;\n    }\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: 1px solid ",
        ";\n    height: 65px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 210px;\n    border-radius: 12px;\n    color: ",
        ";\n    @media screen and (max-width: 768px) {\n        height: 40px;\n        font-size: 14px;\n        min-width: 120px;\n        border-radius: 4px;\n    }\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n        letter-spacing: 0;\n    }\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    ",
        " {\n        font-size: 16px;\n        color: ",
        ";\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n            font-weight: 600;\n        }\n    }\n"
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}


var styles_CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-0"
})(TabsHistory_styles_templateObject());
var styles_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-1"
})(TabsHistory_styles_templateObject1());
var TabsHistory_styles_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-2"
})(TabsHistory_styles_templateObject2(), function(param) {
    var theme = param.theme, isBuy = param.isBuy;
    return isBuy ? theme.colors.success2 : theme.colors.red;
});
var TabsHistory_styles_CsTitleModal = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-3"
})(TabsHistory_styles_templateObject3());
var TabsHistory_styles_CsFlexAgree = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-4"
})(TabsHistory_styles_templateObject4(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var TabsHistory_styles_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-5"
})(TabsHistory_styles_templateObject5());
var TabsHistory_styles_CsLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-a6b36e26-6"
})(TabsHistory_styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var TabsHistory_styles_TextAddr = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-7"
})(TabsHistory_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsHistory_styles_WrapAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6b36e26-8"
})(TabsHistory_styles_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var TabsHistory_styles_CsFlexWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-9"
})(TabsHistory_styles_templateObject9());
var TabsHistory_styles_CSInfoSide = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-10"
})(TabsHistory_styles_templateObject10(), Text/* default */.Z);
var TabsHistory_styles_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-11"
})(TabsHistory_styles_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var TabsHistory_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6b36e26-12"
})(TabsHistory_styles_templateObject12());
var TabsHistory_styles_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-13"
})(TabsHistory_styles_templateObject13(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsHistory_styles_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a6b36e26-14"
})(TabsHistory_styles_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsHistory_styles_CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-a6b36e26-15"
})(styles_templateObject15());
var styles_CsButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-16"
})(styles_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var TabsHistory_styles_CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-17"
})(styles_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var styles_TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-18"
})(styles_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsTextMobile = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-19"
})(styles_templateObject19());
var styles_CustomLink = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a6b36e26-20"
})(styles_templateObject20(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsHistory/components/ModalDetail.tsx

function components_ModalDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: 0.5s;\n    &:hover {\n        background: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n    }\n"
    ]);
    components_ModalDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ModalDetail_DetailModal = function(param) {
    var onDismiss = param.onDismiss, csAddress = param.csAddress, handleOpenLink = param.handleOpenLink;
    var handleClickOut = function handleClickOut() {
        // router.push(`/edit/${id}`)
        onDismiss();
    };
    var itemHistoryValue = GetItemHistory();
    var t = (0,src/* useTranslation */.$G)().t;
    var eventType = itemHistoryValue.eventType, jointsOrderQuantity = itemHistoryValue.jointsOrderQuantity, dayTrading = itemHistoryValue.dayTrading, status = itemHistoryValue.status, isSeller = itemHistoryValue.isSeller, seller = itemHistoryValue.seller, buyer = itemHistoryValue.buyer, totalTxValue = itemHistoryValue.totalTxValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsHistory_styles_CsModal, {
        title: "",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            height: "auto",
            flexDirection: "column",
            style: {
                gap: "10px"
            },
            mt: "1rem",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_TextTitle, {
                        bold: true,
                        children: "Th\xf4ng tin chi tiết"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            color: "textSubtle",
                            children: "Loại lệnh"
                        }),
                        renderProfit_renderType(isSeller, eventType)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            color: "textSubtle",
                            children: "Ng\xe0y giao dịch"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            bold: true,
                            children: convertDate(dayTrading)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            color: "textSubtle",
                            children: "Số lượng"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            bold: true,
                            children: jointsOrderQuantity
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            color: "textSubtle",
                            children: "Tổng gi\xe1 trị giao dịch (VND)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            bold: true,
                            children: Number(totalTxValue).toLocaleString("en", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            color: "textSubtle",
                            children: "Trạng th\xe1i"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            children: renderStatus(status)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsTextMobile, {
                            color: "textSubtle",
                            children: [
                                "Địa chỉ v\xed",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " giao dịch thỏa thuận"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextMobile, {
                            bold: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CustomLink, {
                                style: {
                                    textAlign: "right"
                                },
                                onClick: function() {
                                    return handleOpenLink(renderAddressByType(isSeller, buyer, seller), "address");
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: csAddress(renderAddressByType(isSeller, buyer, seller))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mt: "1rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalDetail_CsButton, {
                        onClick: handleClickOut,
                        height: "42px",
                        width: "100%",
                        style: {
                            borderRadius: "8px"
                        },
                        children: "Tho\xe1t"
                    })
                })
            ]
        })
    });
};
var components_ModalDetail_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-735262e2-0"
})(components_ModalDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
/* harmony default export */ var components_ModalDetail = (ModalDetail_DetailModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsHistory/index.tsx






function TabsHistory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    TabsHistory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 12px 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    ",
        " {\n        font-size: 12px;\n        font-weight: 600;\n        &:last-child {\n            text-align: left;\n        }\n    }\n"
    ]);
    TabsHistory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding-bottom: 20px;\n    flex-direction: column;\n"
    ]);
    TabsHistory_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-top: 2rem;\n    @media only screen and (max-width: 1000px) {\n        width: 100%;\n        margin-top: 1rem;\n        flex-direction: column;\n    }\n"
    ]);
    TabsHistory_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    gap: 10px;\n    justify-content: space-between;\n    @media only screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    TabsHistory_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 33%;\n    @media only screen and (max-width: 1000px) {\n    }\n"
    ]);
    TabsHistory_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    height: 48px !important;\n    width: 180px;\n    @media only screen and (max-width: 1024px) {\n        width: 160px;\n    }\n    @media only screen and (max-width: 1000px) {\n        width: 100% !important;\n        height: 42px !important;\n    }\n    > div {\n        border-radius: 12px !important;\n        height: 100% !important;\n        width: 100% !important;\n        box-sizing: border-box;\n        position: relative;\n        font-size: 14px;\n        @media only screen and (max-width: 1000px) {\n            font-size: 12px;\n            .MuiInputAdornment-positionEnd {\n                button {\n                    padding: 8px;\n                    font-size: 12px;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                    }\n                }\n            }\n        }\n    }\n    @media only screen and (max-width: 600px) {\n        width: 100%;\n    }\n"
    ]);
    TabsHistory_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    TabsHistory_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: relative;\n    flex-direction: row;\n    border-radius: 20px;\n    margin: 40px 0 0px 0;\n    padding: 0 26px;\n    align-items: center;\n    justify-content: space-between;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    TabsHistory_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    TabsHistory_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    height: 71px;\n    padding: 26px;\n    align-items: center;\n    position: relative;\n    flex-direction: row;\n    border-radius: 20px;\n    margin-top: 24px;\n    justify-content: space-between;\n    border: 1px solid ",
        ";\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n    }\n    button {\n        color: ",
        ";\n        background: transparent;\n        border-radius: 4px;\n        font-weight: 700;\n        height: 40px;\n        width: 143px;\n        padding: 0 11px;\n        font-size: 14px;\n    }\n"
    ]);
    TabsHistory_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n"
    ]);
    TabsHistory_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: 1px solid ",
        ";\n"
    ]);
    TabsHistory_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    width: 20%;\n"
    ]);
    TabsHistory_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    align-items: flex-start;\n    flex-direction: column;\n    flex: 1;\n"
    ]);
    TabsHistory_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-wrap: wrap;\n    max-width: 450px;\n    align-items: center;\n    justify-content: center;\n    @media screen and (max-width: 1000px) {\n        margin-top: 1rem;\n        max-width: 100%;\n    }\n"
    ]);
    TabsHistory_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 12px;\n    border: 1px solid transparent;\n    background: transparent !important;\n    border: 1px solid ",
        ";\n    > input {\n        background: ",
        " !important;\n        border: none;\n        border-radius: 0;\n        height: 48px;\n        font-size: 16px;\n        @media screen and (max-width: 1000px) {\n            background: transparent !important;\n            height: 42px;\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n            height: 42px;\n            background: transparent !important;\n        }\n        ::placeholder {\n            color: ",
        ";\n        }\n    }\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n    }\n"
    ]);
    TabsHistory_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function TabsHistory_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color: #13486b;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n    }\n    .page-link {\n        width: 32px;\n        height: 32px;\n        display: flex;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px !important;\n        color: #02111b;\n        border: 1px solid #efefef;\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            background: #13486b;\n            color: #fff;\n            border: 1px solid #13486b !important;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n    }\n    .page-item.active .page-link {\n        background: #13486b;\n        color: #fff;\n        border: none;\n    }\n"
    ]);
    TabsHistory_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






















var TabsHistory_pageSize = 18;
var TabsHistory = function(param) {
    var windowSize = param.windowSize;
    var handleOpenLink = function handleOpenLink(address, type) {
        window.open((0,utils/* getBlockExploreLink */.C)(address, type, chainId));
    };
    var csAddress = function csAddress(dataAddress) {
        if (dataAddress) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var t = (0,src/* useTranslation */.$G)().t;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    // history
    var ref1 = (0,react.useState)(""), searchQuery = ref1[0], setSearchQuery = ref1[1];
    var dataHistory = GetListHistory();
    var isLoading = dataHistory.isLoading;
    var convertStartDate = new Date(dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.startDay).toISOString();
    var convertEndDate = new Date(dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.endDay).toISOString();
    UseCoreListHistory(account, TabsHistory_pageSize, dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.pagenumbermkl, convertStartDate, convertEndDate, searchQuery, dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.type, chainId);
    var listHistory = dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.listItemHistory;
    var filterDataHistory = listHistory.reduce(function(acc, pre) {
        var index = acc.findIndex(function(item) {
            var ref, ref1, ref2, ref3;
            return (item === null || item === void 0 ? void 0 : (ref = item.transaction) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref1 = pre.transaction) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) && (item === null || item === void 0 ? void 0 : (ref2 = item.etfContract) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref3 = pre.etfContract) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase());
        });
        if (index === -1) {
            acc.push(pre);
        } else {
            // eslint-disable-next-line no-param-reassign
            acc[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[index]), {
                jointsOrderQuantity: acc[index].jointsOrderQuantity + pre.jointsOrderQuantity,
                totalTxValue: acc[index].totalTxValue + pre.totalTxValue
            });
        }
        return acc;
    }, []);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalDetail, {
        handleOpenLink: handleOpenLink,
        csAddress: csAddress
    })), 1), openDetailModal = ref2[0];
    var handleStartDate = function(event) {
        var newDate = moment_default()(new Date(event)).startOf("day").toISOString();
        dispatch((0,history_actions/* selectStartDay */.d5)({
            startDay: newDate
        }));
    };
    var handleEndDate = function(event) {
        var newDate = moment_default()(new Date(event)).endOf("day").toISOString();
        dispatch((0,history_actions/* selectEndDay */.wn)({
            endDay: newDate
        }));
    };
    var onKeyDown = function(e) {
        e.preventDefault();
    };
    // select sort value
    var handleSelectType = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,history_actions/* fetchNumberPageCurrent */.zf)({
                                pagenumbermkl: 0
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,history_actions/* selectType */.lr)({
                                type: (ref = option.value) === null || ref === void 0 ? void 0 : ref.toString()
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectType(option) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSearchQuery = function(event) {
        dispatch((0,history_actions/* fetchNumberPageCurrent */.zf)({
            pagenumbermkl: 0
        }));
        setSearchQuery(event.target.value);
    };
    var handleOpenModalDetail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var findItconfirm;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        findItconfirm = filterDataHistory === null || filterDataHistory === void 0 ? void 0 : filterDataHistory.find(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.historyId) === id;
                        });
                        return [
                            4,
                            dispatch((0,history_actions/* itemHistory */.m5)({
                                itemHistory: findItconfirm
                            }))
                        ];
                    case 1:
                        _state.sent();
                        openDetailModal();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOpenModalDetail(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePageClick = function(event) {
        dispatch((0,history_actions/* fetchNumberPageCurrent */.zf)({
            pagenumbermkl: event.selected
        }));
    };
    var validateMaxDateForStart = (0,react.useMemo)(function() {
        var formatTime = "YYYY-MM-DD HH:mm:ss";
        var newDate = moment_default()(new Date()).format(formatTime);
        var fromDate = moment_default()(new Date(dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.endDay)).format(formatTime);
        if (moment_default()(newDate).valueOf() > moment_default()(fromDate).valueOf()) return new Date(dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.endDay);
        return new Date();
    }, [
        dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.endDay
    ]);
    var pageCount = (0,react.useMemo)(function() {
        return Math.ceil((dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.totalItem) / TabsHistory_pageSize);
    }, [
        dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.totalItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_WrapperTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsWrapFilter, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLeft, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlexSort, {
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: "textSubtle",
                                                fontSize: [
                                                    "12px",
                                                    ,
                                                    "14px"
                                                ],
                                                mb: "5px",
                                                children: t("Loại lệnh")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_SelectCustom, {
                                                options: [
                                                    {
                                                        label: "Tất cả",
                                                        value: ""
                                                    },
                                                    {
                                                        label: "Mua",
                                                        value: "buy"
                                                    },
                                                    {
                                                        label: "B\xe1n ngay",
                                                        value: "sellNow"
                                                    },
                                                    {
                                                        label: "B\xe1n thoả thuận",
                                                        value: "sellP2P"
                                                    }, 
                                                ],
                                                onOptionChange: handleSelectType,
                                                defaultOptionIndex: 0
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_CustomFlex, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mb: "5px",
                                                color: "textSubtle",
                                                fontSize: [
                                                    "12px",
                                                    ,
                                                    "14px"
                                                ],
                                                children: t("Từ ng\xe0y")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                                dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCalendar, {
                                                    // label="Date desktop"
                                                    inputFormat: "DD/MM/YYYY",
                                                    value: dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.startDay,
                                                    maxDate: validateMaxDateForStart,
                                                    onChange: handleStartDate,
                                                    renderInput: function(params) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                            onKeyDown: onKeyDown
                                                        }));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_CustomFlex, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mb: "5px",
                                                color: "textSubtle",
                                                fontSize: [
                                                    "12px",
                                                    ,
                                                    "14px"
                                                ],
                                                children: t("Đến ng\xe0y")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                                dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCalendar, {
                                                    // label="Date desktop"
                                                    inputFormat: "DD/MM/YYYY",
                                                    value: dataHistory.endDay,
                                                    minDate: new Date(dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.startDay),
                                                    maxDate: new Date(),
                                                    onChange: handleEndDate,
                                                    renderInput: function(params) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                            onKeyDown: onKeyDown
                                                        }));
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterControls, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputGroup, {
                                    startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                        color: "textDisabled",
                                        width: "24px"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        value: searchQuery,
                                        placeholder: "T\xecm kiếm theo m\xe3 số giao dịch",
                                        onChange: handleChangeSearchQuery
                                    })
                                })
                            })
                        ]
                    }),
                    windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_WrapperTableHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "15%",
                                        children: "Loại lệnh"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "15%",
                                        children: "M\xe3 số giao dịch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "15%",
                                        children: "Ng\xe0y giao dịch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "15%",
                                        children: "Số lượng"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_CsFlexHeader, {
                                        width: "15%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Tổng gi\xe1 trị"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Tổng gi\xe1 trị giao dịch (VND)",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_CsFlexHeader, {
                                        width: "15%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Địa chỉ"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                title: "Địa chỉ v\xed giao dịch thoả thuận",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "20%",
                                        children: "Trạng th\xe1i"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsHistory_WrapperTableContent, {
                                children: (filterDataHistory === null || filterDataHistory === void 0 ? void 0 : filterDataHistory.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: filterDataHistory.map(function(item) {
                                        var historyId = item.historyId, jointsOrderQuantity = item.jointsOrderQuantity, transaction = item.transaction, dayTrading = item.dayTrading, status = item.status, isSeller = item.isSeller, seller = item.seller, buyer = item.buyer, eventType = item.eventType, totalTxValue = item.totalTxValue;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_WrapItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                    justifyContent: "center",
                                                    width: "15%",
                                                    children: renderProfit_renderType(isSeller, eventType)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CustomLink, {
                                                    width: "15%",
                                                    onClick: function() {
                                                        return handleOpenLink(transaction, "transaction");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            children: csAddress(transaction)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    width: "15%",
                                                    children: convertDate(dayTrading)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    width: "15%",
                                                    children: jointsOrderQuantity
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    width: "15%",
                                                    children: Number(totalTxValue).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CustomLink, {
                                                    width: "15%",
                                                    onClick: function() {
                                                        return handleOpenLink(renderAddressByType(isSeller, isSeller ? buyer : seller, isSeller ? buyer : seller), "address");
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                                            title: renderAddressByType(isSeller, isSeller ? buyer : seller, isSeller ? buyer : seller),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: csAddress(renderAddressByType(isSeller, isSeller ? buyer : seller, isSeller ? buyer : seller))
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsHistory_WraperBtnSell, {
                                                    width: "15%",
                                                    children: renderStatus(status)
                                                })
                                            ]
                                        });
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "100%",
                                        textAlign: "center",
                                        mt: "2rem",
                                        children: "Kh\xf4ng c\xf3 dữ liệu"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsHistory_WrapperTableMobile, {
                            children: (filterDataHistory === null || filterDataHistory === void 0 ? void 0 : filterDataHistory.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: filterDataHistory === null || filterDataHistory === void 0 ? void 0 : filterDataHistory.map(function(item) {
                                    var historyId = item.historyId, jointsOrderQuantity = item.jointsOrderQuantity, transaction = item.transaction, dayTrading = item.dayTrading, status = item.status, isSeller = item.isSeller, eventType = item.eventType, totalTxValue = item.totalTxValue;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsHistory_WrapItemMobile, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                width: "100%",
                                                justifyContent: "space-between",
                                                mt: "0.5rem",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        justifyContent: "left",
                                                        width: "25%",
                                                        style: {
                                                            position: "relative",
                                                            right: "18px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {
                                                                onClick: function() {
                                                                    return handleOpenModalDetail(historyId);
                                                                },
                                                                width: "20px",
                                                                style: {
                                                                    cursor: "pointer"
                                                                }
                                                            }),
                                                            renderProfit_renderType(isSeller, eventType)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "25%",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_CustomLink, {
                                                            onClick: function() {
                                                                return handleOpenLink(transaction, "transaction");
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    style: {
                                                                        width: "65px"
                                                                    },
                                                                    children: csAddress(transaction)
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "25%",
                                                        style: {
                                                            textAlign: "right"
                                                        },
                                                        children: convertDate(dayTrading)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                width: "100%",
                                                justifyContent: "space-between",
                                                mt: "0.5rem",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "30%",
                                                        children: jointsOrderQuantity
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        width: "30%",
                                                        style: {
                                                            textAlign: "center"
                                                        },
                                                        children: Number(totalTxValue).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        width: "30%",
                                                        justifyContent: "flex-end",
                                                        children: renderStatus(status)
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "100%",
                                    textAlign: "center",
                                    mt: "2rem",
                                    children: "Kh\xf4ng c\xf3 dữ liệu"
                                })
                            })
                        })
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: "3rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                    spin: true,
                    color: "textSubtle"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: filterDataHistory.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPagination, {
                    width: "100%",
                    mt: "1rem",
                    justifyContent: "center",
                    height: "62px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                        nextLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRIghtIcon/* default */.Z, {}),
                        previousLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {}),
                        onPageChange: handlePageClick,
                        pageCount: pageCount,
                        pageClassName: "page-item",
                        pageLinkClassName: "page-link",
                        previousClassName: "page-item",
                        previousLinkClassName: "page-link",
                        nextClassName: "page-item",
                        nextLinkClassName: "page-link",
                        breakLabel: "...",
                        breakClassName: "page-item",
                        breakLinkClassName: "page-link",
                        containerClassName: "pagination",
                        activeClassName: "active",
                        renderOnZeroPageCount: null,
                        forcePage: dataHistory === null || dataHistory === void 0 ? void 0 : dataHistory.pagenumbermkl
                    })
                }) : ""
            })
        ]
    });
};
var TabsHistory_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-0"
})(TabsHistory_templateObject());
var TabsHistory_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab854bcc-1"
})(TabsHistory_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var TabsHistory_WrapperTableMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-2"
})(TabsHistory_templateObject2());
var CsWrapFilter = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-3"
})(TabsHistory_templateObject3());
var FlexLeft = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-4"
})(TabsHistory_templateObject4());
var TabsHistory_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-5"
})(TabsHistory_templateObject5());
var CustomCalendar = (0,styled_components_browser_esm/* default */.ZP)(DesktopDatePicker/* DesktopDatePicker */.$).withConfig({
    componentId: "sc-ab854bcc-6"
})(TabsHistory_templateObject6());
var TabsHistory_WrapperTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab854bcc-7"
})(TabsHistory_templateObject7());
var TabsHistory_WrapperTableHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-8"
})(TabsHistory_templateObject8(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsHistory_WrapperTableContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-9"
})(TabsHistory_templateObject9());
var TabsHistory_WrapItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-10"
})(TabsHistory_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var TabsHistory_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-11"
})(TabsHistory_templateObject11(), function(param) {
    var theme = param.theme, isBuy = param.isBuy;
    return isBuy === 1 ? theme.colors.success2 : theme.colors.red;
});
var TabsHistory_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-12"
})(TabsHistory_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var TabsHistory_WraperBtnSell = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-13"
})(TabsHistory_templateObject13());
var CsFlexSort = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-14"
})(TabsHistory_templateObject14());
var FilterControls = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-15"
})(TabsHistory_templateObject15());
var CustomInputGroup = (0,styled_components_browser_esm/* default */.ZP)(InputGroup/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-16"
})(TabsHistory_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
var CustomPagination = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ab854bcc-17"
})(TabsHistory_templateObject17(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
/* harmony default export */ var FooterTabs_TabsHistory = (TabsHistory);

// EXTERNAL MODULE: ./src/state/Order/actions.ts
var Order_actions = __webpack_require__(43790);
;// CONCATENATED MODULE: ./src/state/Order/index.ts











var UseCoreListOrder = function(tokenSupport, account, chainId) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var messageHash = GetDataListOrder().messageHash;
    (0,react.useEffect)(function() {
        var getDataListOrder = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var activeCCQ, ref, result, resultAllowance, resultBalance, resultVestingmap, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            dispatch((0,Order_actions/* fetchStatusLoading */.Xy)({
                                isLoading: true
                            }));
                            return [
                                4,
                                (0,ccqSupport_constants.UseActiveCCQ)(chainId)
                            ];
                        case 1:
                            activeCCQ = _state.sent();
                            return [
                                4,
                                Promise.all([
                                    fetchListOrder(activeCCQ, account, chainId),
                                    fetchDataUser(tokenSupport, activeCCQ, account, chainId),
                                    fetchDataBalance(tokenSupport, account, chainId)
                                ])
                            ];
                        case 2:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                3
                            ]), result = ref[0], resultAllowance = ref[1], resultBalance = ref[2];
                            return [
                                4,
                                fetchVestingMap(result === null || result === void 0 ? void 0 : result.listItemOrder, chainId, account)
                            ];
                        case 3:
                            resultVestingmap = _state.sent();
                            dispatch((0,Order_actions/* listItemOrder */.y6)(resultVestingmap));
                            dispatch((0,Order_actions/* getBalance */.sb)(resultBalance));
                            dispatch((0,Order_actions/* getAllowance */.RC)(resultAllowance));
                            dispatch((0,Order_actions/* fetchStatusLoading */.Xy)({
                                isLoading: false
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataListOrder() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((account === null || account === void 0 ? void 0 : account.length) > 0) {
            getDataListOrder();
        } else {
            dispatch((0,Order_actions/* listItemOrder */.y6)({
                listItemOrder: []
            }));
        }
    }, [
        account,
        chainId,
        dispatch,
        tokenSupport,
        messageHash
    ]);
};
var GetItemOrder = function() {
    var data = useSelector(function(state) {
        return state.order;
    });
    var itemOrderValue = data === null || data === void 0 ? void 0 : data.itemOrder;
    return itemOrderValue;
};
var GetDataListOrder = function() {
    var dataListOrder = (0,es/* useSelector */.v9)(function(state) {
        return state.order;
    });
    var isLoading = dataListOrder.isLoading, listAllowanc = dataListOrder.listAllowanc, balance = dataListOrder.balance, messageHash = dataListOrder.messageHash;
    var filterDataAddress = dataListOrder.listItemOrder.reduce(function(acc, pre) {
        var index = acc.findIndex(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref1 = pre.nftAddress) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) && (item === null || item === void 0 ? void 0 : item.dateTrading) === (pre === null || pre === void 0 ? void 0 : pre.dateTrading);
        });
        if (index === -1) {
            acc.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pre), {
                buys: [
                    {
                        amountTrading: pre.amountTrading,
                        orderId: pre.orderId
                    }, 
                ]
            }));
        } else {
            var item = (0,_to_consumable_array/* default */.Z)(acc[index].buys);
            item.push({
                amountTrading: pre.amountTrading,
                orderId: pre.orderId
            });
            // eslint-disable-next-line no-param-reassign
            acc[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[index]), {
                amountTrading: acc[index].amountTrading + pre.amountTrading,
                buys: item
            });
        }
        return acc;
    }, []);
    return {
        listItemOrder: filterDataAddress,
        isLoading: isLoading,
        listAllowanc: listAllowanc,
        balance: balance,
        messageHash: messageHash
    };
};

;// CONCATENATED MODULE: ./src/utils/renderStatus.ts
function renderStatus_renderStatus(status) {
    if (status === 1) {
        return "Th\xe0nh c\xf4ng";
    }
    if (status === 2) {
        return "Đang chờ x\xe1c nhận";
    }
    if (status === 3) {
        return "Đ\xe3 huỷ";
    }
    return "Đang chờ x\xe1c nhận";
}

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/styles.tsx

function components_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n    text-align: right;\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    components_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    @media screen and (max-width: 586px) {\n        font-size: 24px;\n    }\n"
    ]);
    components_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 1.5rem;\n    align-items: center;\n    flex-direction: column;\n    @media screen and (max-width: 1024px) {\n        display: none;\n    }\n    ",
        " {\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 1.5;\n        color: ",
        ";\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 18px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n        }\n    }\n"
    ]);
    components_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-decoration: underline;\n    font-size: 16px;\n    padding: 0px;\n    height: fit-content;\n    font-weight: 700;\n    line-height: 1.5;\n    color: ",
        ";\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 18px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    components_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function components_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: transparent;\n    border: 1px solid ",
        ";\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 230px;\n    border-radius: 12px;\n    color: ",
        ";\n    transition: 0.5s;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        height: 40px;\n        font-size: 14px;\n        min-width: 230px;\n        border-radius: 4px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    components_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function components_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 60px;\n    font-size: 20px;\n    font-weight: 700;\n    min-width: 230px;\n    transition: 0.5s;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n        height: 40px;\n        min-width: 230px;\n        border-radius: 4px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n        line-height: 1.5;\n        height: 40px;\n        min-width: 50%;\n        border-radius: 4px;\n    }\n"
    ]);
    components_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function components_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    color: ",
        ";\n"
    ]);
    components_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function components_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    min-width: 220px;\n    margin-left: 40px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 1024px) {\n        min-width: 120px;\n    }\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 40px;\n        color: ",
        ";\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n        }\n    }\n"
    ]);
    components_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function components_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 4rem;\n    @media screen and (max-width: 1024px) {\n        margin-top: 2rem;\n        flex-direction: column;\n    }\n"
    ]);
    components_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function components_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-between;\n    align-items: center;\n    width: 40%;\n    ",
        " {\n        font-size: 16px;\n        @media screen and (max-width: 1024px) {\n            font-size: 12px;\n        }\n    }\n    @media screen and (max-width: 1024px) {\n        width: 100%;\n    }\n"
    ]);
    components_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function components_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 48px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background: ",
        ";\n    &:hover {\n        background: #f5f5f58a;\n    }\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n    }\n"
    ]);
    components_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function components_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    components_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function components_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 24px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    components_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function components_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.5rem;\n    margin-bottom: 1.5rem;\n    border: 1px solid #f5f5f5;\n    border-radius: 4px;\n"
    ]);
    components_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function components_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 28px;\n    ",
        " {\n        gap: 0.875rem !important;\n        flex-direction: row-reverse;\n        @media screen and (max-width: 768px) {\n            display: flex;\n            flex-direction: column;\n        }\n    }\n"
    ]);
    components_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function components_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 4px;\n    padding: 4px 0px;\n    span {\n        color: ",
        ";\n        font-weight: 600;\n        font-size: 12px;\n    }\n"
    ]);
    components_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function components_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 12px;\n    margin-top: 16px;\n    border-radius: 4px;\n    background: ",
        ";\n    ",
        " {\n        font-size: 12px;\n        font-weight: 600;\n    }\n    @media screen and (max-width: 1000px) {\n        padding: 0;\n    }\n"
    ]);
    components_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function components_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 24px ;\n    min-width: 990px;\n    @media screen and (max-width: 768px) {\n        min-width: 90%;\n        padding: 0px 0px 24px 0px;\n    }\n"
    ]);
    components_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function components_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 34px;\n    font-weight: 700;\n    @media screen and (max-width: 768px) {\n        font-size: 24px;\n    }\n"
    ]);
    components_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function components_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 34px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    color: ",
        ";\n    @media screen and (max-width: 1000px) {\n        font-size: 24px;\n        letter-spacing: 0;\n    }\n"
    ]);
    components_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function components_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    components_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    color: ",
        " !important;\n    font-weight:bold;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    ",
        " {\n        font-size: 14px;\n        color: ",
        ";\n        @media screen and (min-width: 601px) and (max-width: 1000px) {\n            font-size: 14px;\n        }\n        @media screen and (max-width: 600px) {\n            font-size: 12px;\n            font-weight: 600;\n        }\n    }\n    svg {\n        &:active {\n            transform: translateY(1px);\n        }\n    }\n"
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 22px;\n    height: 22px;\n    display: none;\n    @media screen and (max-width: 768px) {\n        display: block;\n    }\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmax-width: 100%;\nalign-items: center;\njustify-content: center;\nwidth: 14.2%;\n"
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}


var components_styles_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-0"
})(components_styles_templateObject(), function(param) {
    var theme = param.theme, isBuy = param.isBuy;
    return isBuy ? theme.colors.success2 : theme.colors.red;
});
var components_styles_CsTitleModal = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-1"
})(components_styles_templateObject1());
var components_styles_CsFlexAgree = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-2"
})(components_styles_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var components_styles_CsLink = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text"
}).withConfig({
    componentId: "sc-b4e5c760-3"
})(components_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var components_styles_CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-4"
})(components_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var components_styles_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-5"
})(components_styles_templateObject5());
var components_styles_TextAddr = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-6"
})(components_styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var components_styles_WrapAddress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-7"
})(components_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.border;
}, Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var components_styles_CsFlexWrapInfo = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-8"
})(components_styles_templateObject8());
var components_styles_CSInfoSide = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-9"
})(components_styles_templateObject9(), Text/* default */.Z);
var components_styles_WrapperCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-10"
})(components_styles_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var components_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-11"
})(components_styles_templateObject11());
var components_styles_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-12"
})(components_styles_templateObject12(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var WrapQuantity = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-13"
})(components_styles_templateObject13());
var styles_WrapperButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-14"
})(components_styles_templateObject14(), Flex/* default */.Z);
var CsMonth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-15"
})(components_styles_templateObject15(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var components_styles_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b4e5c760-16"
})(components_styles_templateObject16(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, Text/* default */.Z);
var components_styles_CsModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-b4e5c760-17"
})(components_styles_templateObject17());
var components_styles_CsButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-18"
})(components_styles_templateObject18(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var components_styles_TextTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-19"
})(components_styles_templateObject19(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var styles_CsTextMobile = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-20"
})(components_styles_templateObject20());
var CsTextValue = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-21"
})(styles_templateObject21(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var components_styles_CustomLink = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-22"
})(styles_templateObject22(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var components_styles_CsImgCoin = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-b4e5c760-23"
})(styles_templateObject23());
var components_styles_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b4e5c760-24"
})(styles_templateObject24());

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/ModalDetail.tsx

function TabsOrder_components_ModalDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transition: 0.5s;\n    &:hover {\n        background: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n    }\n"
    ]);
    TabsOrder_components_ModalDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_ModalDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        " !important;\n    text-align: right;\n    font-size: 16px;\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 14px;\n    }\n    @media screen and (max-width: 600px) {\n        font-size: 12px;\n    }\n"
    ]);
    components_ModalDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var components_ModalDetail_DetailModal = function(param) {
    var onDismiss = param.onDismiss, sAccount = param.sAccount, handleOpenLink = param.handleOpenLink, item = param.item, account = param.account, chainId = param.chainId;
    var handleClickOut = function handleClickOut() {
        onDismiss();
    };
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsModal, {
        title: "",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            width: "100%",
            height: "auto",
            flexDirection: "column",
            style: {
                gap: "10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_TextTitle, {
                        bold: true,
                        children: "Th\xf4ng tin chi tiết"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                            color: "textSubtle",
                            children: "Loại lệnh"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_CsText, {
                            bold: true,
                            width: "15%",
                            isOnSale: item === null || item === void 0 ? void 0 : item.isSelling,
                            children: (item === null || item === void 0 ? void 0 : item.isSelling) ? t("B\xe1n") : t("Mua")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: "0.5rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                            color: "textSubtle",
                            children: "Kỳ đ\xe3 nhận /Tổng kỳ"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            fontSize: "12px",
                            bold: true,
                            children: [
                                totalVested,
                                "/",
                                totalVestingMap
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_ItemDetail, {
                    title: "Ng\xe0y giao dịch",
                    value: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_ItemDetail, {
                    title: "Số lượng giao dịch",
                    value: item === null || item === void 0 ? void 0 : item.amountTrading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_ItemDetail, {
                    title: "Tổng gi\xe1 trị giao dịch (VND)",
                    value: Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_ItemDetail, {
                    title: "Trạng th\xe1i",
                    value: "Đang chờ x\xe1c nhận"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDetail_ItemDetail, {
                    title: "Địa chỉ v\xed giao dịch thỏa thuận",
                    value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CustomLink, {
                        style: {
                            textAlign: "right"
                        },
                        onClick: function() {
                            return handleOpenLink(item === null || item === void 0 ? void 0 : item.addressTrading);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                style: {
                                    fontWeight: "600"
                                },
                                children: sAccount(item === null || item === void 0 ? void 0 : item.addressTrading)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mt: "1rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CSButton, {
                        onClick: handleClickOut,
                        height: "42px",
                        width: "100%",
                        style: {
                            borderRadius: "8px"
                        },
                        children: "Tho\xe1t"
                    })
                })
            ]
        })
    });
};
var ModalDetail_ItemDetail = function(param) {
    var title = param.title, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        mt: "0.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                color: "textSubtle",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                bold: true,
                children: value
            })
        ]
    });
};
var CSButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-49e730b6-0"
})(TabsOrder_components_ModalDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ModalDetail_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-49e730b6-1"
})(components_ModalDetail_templateObject1(), function(param) {
    var theme = param.theme, isOnSale = param.isOnSale;
    return isOnSale ? theme.colors.red : "#81D401";
});
/* harmony default export */ var TabsOrder_components_ModalDetail = (components_ModalDetail_DetailModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/hook/fetchData.ts







var fetchData_GetNftInfo = function(nftAddress, sellerAddress, nftId, account, chainId) {
    var ref = (0,react.useState)({
        publisher: "",
        name: "",
        price: "0",
        issueDate: 0,
        expireDate: 0,
        intervestTerm: 0,
        totalSupply: 0,
        profit: "0",
        nextInterestPaymentDate: 0
    }), nftInfo = ref[0], setNftInfo = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    (0,react.useEffect)(function() {
        var getDataNft = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, calls, ref7, resultEtfInfo, resultProfit, resultVestingMap, vestingMap, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setLoading(true);
                            calls = [
                                {
                                    address: nftAddress,
                                    name: "etfInfor",
                                    params: []
                                },
                                {
                                    address: nftAddress,
                                    name: "intervestTermRate",
                                    params: []
                                },
                                {
                                    address: nftAddress,
                                    name: "getMyVestList",
                                    params: [
                                        nftAddress,
                                        nftId
                                    ]
                                }
                            ];
                            return [
                                4,
                                (0,multicall/* default */.Z)(ccqWrappedAbi, calls, chainId)
                            ];
                        case 1:
                            ref7 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                3
                            ]), resultEtfInfo = ref7[0], resultProfit = ref7[1], resultVestingMap = ref7[2];
                            vestingMap = (ref = resultVestingMap[0]) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return (item === null || item === void 0 ? void 0 : item.isVested) === false;
                            });
                            setNftInfo({
                                publisher: resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : resultEtfInfo.publisher,
                                name: resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : resultEtfInfo.name,
                                price: new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref1 = resultEtfInfo.price) === null || ref1 === void 0 ? void 0 : ref1.toString()).dividedBy(1E18).toString(),
                                issueDate: Number(new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref2 = resultEtfInfo.issueDate) === null || ref2 === void 0 ? void 0 : ref2.toString()).toString()),
                                expireDate: Number(new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref3 = resultEtfInfo.expireDate) === null || ref3 === void 0 ? void 0 : ref3.toString()).toString()),
                                intervestTerm: Number(new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref4 = resultEtfInfo.intervestTerm) === null || ref4 === void 0 ? void 0 : ref4.toString()).toString()) === 92 ? 3 : 6,
                                totalSupply: Number(new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref5 = resultEtfInfo.totalSupply) === null || ref5 === void 0 ? void 0 : ref5.toString()).toString()),
                                profit: Number(new bignumber/* default */.Z(resultEtfInfo === null || resultEtfInfo === void 0 ? void 0 : (ref6 = resultEtfInfo.intervestTerm) === null || ref6 === void 0 ? void 0 : ref6.toString()).toString()) === 92 ? "8" : "9.2",
                                nextInterestPaymentDate: Number(vestingMap === null || vestingMap === void 0 ? void 0 : vestingMap.vestDate)
                            });
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDataNft() {
                return _ref.apply(this, arguments);
            };
        }();
        if ((account === null || account === void 0 ? void 0 : account.length) > 0) {
            getDataNft();
        }
    }, [
        nftId,
        chainId,
        account,
        nftAddress,
        sellerAddress
    ]);
    return {
        nftInfo: nftInfo,
        isLoading: isLoading
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/ItemTransaction.tsx

function ItemTransaction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n"
    ]);
    ItemTransaction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ItemTransaction_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 16px;\n    display: grid;\n    gap: 10.625rem;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n"
    ]);
    ItemTransaction_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ItemTransaction_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: #02111b;\n    font-weight: 600;\n    font-size: 16px;\n"
    ]);
    ItemTransaction_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ItemTransaction_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    ItemTransaction_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var ItemTransaction = function(param) {
    var titleOrderQuantity = param.titleOrderQuantity, valueOrderQuantity = param.valueOrderQuantity, utiOrderQuantity = param.utiOrderQuantity, valueTransactionMethod = param.valueTransactionMethod, dateTransaction = param.dateTransaction, addressBuy = param.addressBuy, totalMoney = param.totalMoney, textAlert = param.textAlert;
    var sAccount = function sAccount(dataAddress) {
        if (dataAddress) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var handleOpenLink = function() {
        window.open((0,utils/* getBlockExploreLink */.C)(addressBuy, "address", chainId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionInformation, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTransaction_Item, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTransaction_TextLabel, {
                        children: "Th\xf4ng tin giao dịch"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel, {
                        title: titleOrderQuantity,
                        options: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    color: "primaryBright",
                                    children: valueOrderQuantity
                                }),
                                utiOrderQuantity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "#02111B",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    ml: "3px",
                                    children: utiOrderQuantity
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel, {
                        title: "Phương thức giao dịch",
                        value: valueTransactionMethod
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel, {
                        title: "Ng\xe0y giao dịch",
                        value: dateTransaction
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel, {
                        title: textAlert,
                        options: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return handleOpenLink();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                    title: addressBuy,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: sAccount(addressBuy)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {
                                    fontSize: "14px"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemLabel, {
                        title: "Tổng tiền thỏa thuận",
                        options: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "flex-end",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#F9A138",
                                            fontSize: "14px",
                                            children: Number(totalMoney).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#02111B",
                                            fontWeight: "700",
                                            ml: "5px",
                                            fontSize: "14px",
                                            children: "VND"
                                        })
                                    ]
                                }),
                                Number(totalMoney) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTransaction_CsUnit, {
                                    style: {
                                        color: "#8C8D8E"
                                    },
                                    children: " (Tương đương ".concat(Number(totalMoney).toLocaleString("en", {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0
                                    }), " điểm VNDC)")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var ItemLabel = function(param) {
    var title = param.title, value = param.value, options = param.options;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        justifyContent: "space-between",
        mt: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "#8C8D8E",
                fontSize: "14px",
                fontWeight: "500",
                children: title
            }),
            options || /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "#02111B",
                fontSize: "14px",
                fontWeight: "500",
                children: value
            })
        ]
    });
};
var ItemTransaction_Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84f5c80-0"
})(ItemTransaction_templateObject());
var TransactionInformation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b84f5c80-1"
})(ItemTransaction_templateObject1());
var ItemTransaction_TextLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-b84f5c80-2"
})(ItemTransaction_templateObject2());
var ItemTransaction_CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b84f5c80-3"
})(ItemTransaction_templateObject3());

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/hook/useDelist.tsx












var useDelistp2p = function(account, chainId, nftAddress, buys, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useToast/* useToast */.p)(), toastSuccess = ref.toastSuccess, toastError = ref.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref1 = (0,react.useState)(false), pendingDelistp2p = ref1[0], setPenddingDelistp2p = ref1[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleDelistp2p = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var orderIds, tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPenddingDelistp2p(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    orderIds = buys.map(function(item) {
                        return item.orderId;
                    });
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "deListingP2P", [
                            orderIds
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("X\xe1c nhận hủy th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setPenddingDelistp2p(false);
                        onDismiss();
                        dispatch((0,Order_actions/* actionDispatchMessage */.EN)({
                            messageHash: receipt.transactionHash
                        }));
                    } else {
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setPenddingDelistp2p(false);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    handleRejected(e);
                    setPenddingDelistp2p(false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        buys,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        onDismiss,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleDelistp2p: handleDelistp2p,
        pendingDelistp2p: pendingDelistp2p
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/hook/useBuyP2P.tsx












var useBuyP2P = function(account, chainId, nftAddress, buys, onDismiss) {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), requestedBuyP2P = ref[0], setRequestBuyP2P = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var ref2 = (0,react.useState)(false), pendingBuyP2P = ref2[0], setPenddingBuyP2P = ref2[1];
    var contractWrapped = (0,useContract/* useWrapped */.GB)(nftAddress);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRejected = useUserRejected().handleRejected;
    var handleBuyP2P = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var orderIds, tx, receipt, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    orderIds = buys.map(function(item) {
                        return item.orderId;
                    });
                    setPenddingBuyP2P(true);
                    return [
                        4,
                        callWithMarketGasPrice(contractWrapped, "buyP2P", [
                            orderIds
                        ])
                    ];
                case 1:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 2:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("X\xe1c nhận mua th\xe0nh c\xf4ng"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestBuyP2P(true);
                        onDismiss();
                        dispatch((0,Order_actions/* actionDispatchMessage */.EN)({
                            messageHash: receipt.transactionHash
                        }));
                        setPenddingBuyP2P(false);
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setPenddingBuyP2P(false);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    setPenddingBuyP2P(false);
                    handleRejected(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        buys,
        callWithMarketGasPrice,
        contractWrapped,
        dispatch,
        handleRejected,
        onDismiss,
        t,
        toastError,
        toastSuccess
    ]);
    return {
        handleBuyP2P: handleBuyP2P,
        requestedBuyP2P: requestedBuyP2P,
        pendingBuyP2P: pendingBuyP2P
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/hook/useApprove.tsx















var useApprove_useApprove = function(contractAddress, tokenAddress, account, chainId) {
    var ref = (0,react.useState)(false), requestedApproval = ref[0], setRequestedApproval = ref[1];
    var ref1 = (0,useToast/* useToast */.p)(), toastSuccess = ref1.toastSuccess, toastError = ref1.toastError;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var address = (0,useContract/* useERC20 */.X_)(tokenAddress);
    var ref2 = (0,react.useState)(false), pendingTx = ref2[0], setPendingTx = ref2[1];
    var handleRejected = useUserRejected().handleRejected;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleApprove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var tx, receipt, e, activeCCQ, resultAllowance, e1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPendingTx(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        10
                    ]);
                    return [
                        4,
                        callWithMarketGasPrice(address, "approve", [
                            contractAddress,
                            bignumbers/* MaxUint256 */.Bz
                        ])
                    ];
                case 2:
                    tx = _state.sent();
                    return [
                        4,
                        tx.wait()
                    ];
                case 3:
                    receipt = _state.sent();
                    if (receipt.status) {
                        toastSuccess(t("Hợp đồng đ\xe3 k\xedch hoạt"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash
                        }));
                        setRequestedApproval(true);
                        setPendingTx(false);
                        dispatch((0,Order_actions/* actionDispatchMessage */.EN)({
                            messageHash: receipt.transactionHash
                        }));
                    } else {
                        // user rejected tx or didn't go thru
                        toastError(t("Đ\xe3 c\xf3 lỗi xảy ra"), t("X\xe1c nhận giao dịch, v\xe0 đảm bảo rằng bạn đủ token trong v\xed để xử l\xfd giao dịch!"));
                        setPendingTx(false);
                    }
                    return [
                        3,
                        10
                    ];
                case 4:
                    e = _state.sent();
                    console.error(e);
                    handleRejected(e);
                    setPendingTx(false);
                    return [
                        3,
                        10
                    ];
                case 5:
                    _state.trys.push([
                        5,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        (0,ccqSupport_constants.UseActiveCCQ)(chainId)
                    ];
                case 6:
                    activeCCQ = _state.sent();
                    return [
                        4,
                        fetchDataUser(tokenAddress, activeCCQ, account, chainId)
                    ];
                case 7:
                    resultAllowance = _state.sent();
                    dispatch((0,Order_actions/* getAllowance */.RC)(resultAllowance));
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    console.log(e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    }), [
        account,
        address,
        callWithMarketGasPrice,
        chainId,
        contractAddress,
        dispatch,
        handleRejected,
        t,
        toastError,
        toastSuccess,
        tokenAddress
    ]);
    return {
        handleApprove: handleApprove,
        requestedApproval: requestedApproval,
        pendingTx: pendingTx
    };
};

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/ConfirmModalPC.tsx




function ConfirmModalPC_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    /* justify-content: center; */\n"
    ]);
    ConfirmModalPC_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmModalPC_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    ConfirmModalPC_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var ConfirmModalPC = function(_param) {
    var handleOpenLink = _param.handleOpenLink, sAccount = _param.sAccount, title = _param.title, onDismiss = _param.onDismiss, item = _param.item, account = _param.account, chainId = _param.chainId, itemAllowance = _param.itemAllowance, balance = _param.balance, tokenAddress = _param.tokenAddress, props = (0,_object_without_properties/* default */.Z)(_param, [
        "handleOpenLink",
        "sAccount",
        "title",
        "onDismiss",
        "item",
        "account",
        "chainId",
        "itemAllowance",
        "balance",
        "tokenAddress"
    ]);
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var windowSize = (0,getWindowSize/* default */.Z)();
    var ref2 = fetchData_GetNftInfo(item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.addressTrading, item === null || item === void 0 ? void 0 : item.nftId, account, chainId), nftInfo = ref2.nftInfo, isLoading = ref2.isLoading;
    var isNotBalance = new bignumber/* default */.Z(balance).isLessThan(item === null || item === void 0 ? void 0 : item.amountTrading);
    var isNotAllowance = new bignumber/* default */.Z(itemAllowance === null || itemAllowance === void 0 ? void 0 : itemAllowance.allowance).isLessThan(item === null || item === void 0 ? void 0 : item.amountTrading);
    // for download
    var raw = JSON.stringify({
        "buyerWalletAddress": account,
        "sellerWalletAddress": item === null || item === void 0 ? void 0 : item.addressTrading,
        "pendingEtf": [
            {
                "numericalOrder": "1",
                "etfId": "".concat(item === null || item === void 0 ? void 0 : item.nftId),
                "parValue": "".concat(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.price).toLocaleString("en", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }), " VND"),
                "interest": "".concat(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.profit) * 100, "%"),
                "incomingInterestDate": convertDate((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000),
                "releaseDate": convertDate(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.issueDate) * 1000),
                "maturityDate": convertDate(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.expireDate) * 1000),
                "transferValue": "".concat(Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }), " VND")
            }
        ],
        "transferedEtf": [
            {
                "numericalOrder": "1",
                "etfId": "".concat(item === null || item === void 0 ? void 0 : item.nftId),
                "transferDate": convertDate(Date.now())
            }
        ],
        "transferDate": convertDate(Date.now()),
        "totalTransferValue": "".concat(Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }), " VND")
    });
    var ref3 = useDownload(raw), penddingDowload = ref3.penddingDowload, handleDownload = ref3.handleDownload;
    // for reject-confirm
    var ref4 = useDelistp2p(account, chainId, item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.buys, onDismiss), handleDelistp2p = ref4.handleDelistp2p, pendingDelistp2p = ref4.pendingDelistp2p;
    var ref5 = useBuyP2P(account, chainId, item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.buys, onDismiss), handleBuyP2P = ref5.handleBuyP2P, pendingBuyP2P = ref5.pendingBuyP2P;
    var ref6 = useApprove_useApprove(item === null || item === void 0 ? void 0 : item.nftAddress, tokenAddress, account, chainId), handleApprove = ref6.handleApprove, pendingTx = ref6.pendingTx;
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsTitleModal, {
                    color: "text",
                    fontSize: "28px",
                    fontWeight: "700",
                    children: t("X\xe1c nhận giao dịch")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_WrapperItemHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Lợi suất"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Ng\xe0y trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Ng\xe0y c\xf2n lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Gi\xe1 trị"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Gi\xe1 trị (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_WrapperCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.profit).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        }), "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: [
                                            totalVested,
                                            "/",
                                            totalVestingMap
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.intervestTerm, " th\xe1ng")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(convertDate((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(getDateBetweenTwoDates((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000), " ").concat(config/* UNIT_DATE */.L$)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.price).isNaN() ? "0" : Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTransaction, {
                            titleOrderQuantity: "Số lượng giao dịch",
                            valueOrderQuantity: item === null || item === void 0 ? void 0 : (ref1 = item.amountTrading) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                            valueTransactionMethod: "Mua thỏa thuận",
                            dateTransaction: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000),
                            addressBuy: item === null || item === void 0 ? void 0 : item.addressTrading,
                            totalMoney: Number(item === null || item === void 0 ? void 0 : item.price),
                            utiOrderQuantity: "CCQ",
                            textAlert: "Địa chỉ v\xed người b\xe1n"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_WrapItemMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapQuantity, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                                            gap: "8px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "flex-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Mệnh gi\xe1 (VND)",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.price).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                children: [
                                                                    totalVested,
                                                                    "/",
                                                                    totalVestingMap
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : "".concat(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.profit, "%")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        style: {
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                                            gap: "8px",
                                            marginTop: "8px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "flex-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Kỳ trả lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsMonth, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                        width: "42px"
                                                                    }) : "".concat(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.intervestTerm, " th\xe1ng")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Ng\xe0y c\xf2n lại",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                width: "42px"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                bold: true,
                                                                children: [
                                                                    getDateBetweenTwoDates((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000),
                                                                    " ",
                                                                    config/* UNIT_DATE */.L$
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Ng\xe0y trả lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : "".concat(convertDate((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                style: {
                                    color: "#02111b",
                                    fontWeight: 700,
                                    fontSize: "0.875rem"
                                },
                                children: "Th\xf4ng tin chứng chỉ quỹ"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "1rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        children: "Ng\xe0y giao dịch"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true,
                                        children: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "1.313rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        children: "Địa chỉ v\xed người b\xe1n"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CustomLink, {
                                        style: {
                                            textAlign: "right"
                                        },
                                        onClick: function() {
                                            return handleOpenLink(item === null || item === void 0 ? void 0 : item.addressTrading);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                style: {
                                                    color: "#02111b",
                                                    fontWeight: "bold"
                                                },
                                                children: sAccount(item === null || item === void 0 ? void 0 : item.addressTrading)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "1.313rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        children: "Số lượng giao dịch (CCQ)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: item === null || item === void 0 ? void 0 : item.amountTrading
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "1.313rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        children: "Phương thức b\xe1n "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: "B\xe1n thỏa thuận"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: "1.313rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "textSubtle",
                                        children: "Tổng tiền thỏa thuận"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            flexDirection: "column",
                                            alignItems: "flex-end",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    mb: "4px",
                                                    children: [
                                                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                            width: "42px"
                                                        }) : Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            style: {
                                                                marginLeft: "5px"
                                                            },
                                                            children: "VND"
                                                        })
                                                    ]
                                                }),
                                                !isLoading && Number(item === null || item === void 0 ? void 0 : item.price) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmModalPC_CsUnit, {
                                                    style: {
                                                        color: "#8C8D8E"
                                                    },
                                                    children: " (Tương đương ".concat(Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    }), " điểm VNDC)")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapperButton, {
                children: [
                    !item.isBuyP2P && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        style: {
                            textAlign: "center",
                            color: "red",
                            fontSize: "13px",
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "10px"
                        },
                        children: "Đ\xe3 hết kỳ nhận lợi suất của CCQ kh\xf4ng thể thực hiện giao dịch, vui l\xf2ng x\xe1c nhận hủy!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        justifyContent: "center",
                        style: {
                            gap: "1.5rem"
                        },
                        children: [
                            isNotAllowance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsButtonConfirm, {
                                onClick: handleApprove,
                                disabled: pendingTx || isNotBalance || pendingDelistp2p || pendingBuyP2P || (item === null || item === void 0 ? void 0 : item.paused) || !item.isBuyP2P,
                                endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                }) : "",
                                children: t("Chấp thuận")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsButtonConfirm, {
                                disabled: pendingBuyP2P || isNotBalance || pendingDelistp2p || (item === null || item === void 0 ? void 0 : item.paused) || !item.isBuyP2P,
                                onClick: handleBuyP2P,
                                endIcon: pendingBuyP2P ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                }) : "",
                                children: t("X\xe1c nhận mua")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsButtonCancel, {
                                disabled: pendingDelistp2p || pendingBuyP2P || (item === null || item === void 0 ? void 0 : item.paused),
                                onClick: handleDelistp2p,
                                endIcon: pendingDelistp2p ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                }) : "",
                                children: t("X\xe1c nhận hủy")
                            })
                        ]
                    })
                ]
            }),
            isNotBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "primaryBright",
                    children: "Số dư VNDC kh\xf4ng đủ"
                })
            }),
            (item === null || item === void 0 ? void 0 : item.paused) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "1rem"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "12px",
                        ,
                        ,
                        "14px"
                    ],
                    color: "red",
                    children: t("CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!")
                })
            }),
            item.isBuyP2P && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexAgree, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: t("Bằng c\xe1ch “X\xe1c nhận mua” t\xf4i đồng \xfd với")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsLink, {
                        disabled: penddingDowload,
                        onClick: handleDownload,
                        children: t("hợp đồng chuyển nhượng Chứng chỉ Quỹ ")
                    })
                ]
            })
        ]
    }));
};
var ConfirmModalPC_CsFlexHeaderMb = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-91aea6c5-0"
})(ConfirmModalPC_templateObject());
var ConfirmModalPC_CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-91aea6c5-1"
})(ConfirmModalPC_templateObject1());
/* harmony default export */ var components_ConfirmModalPC = (ConfirmModalPC);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/ModalCancel.tsx




function ModalCancel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 22px;\n    height: 22px;\n    display: none;\n    @media screen and (max-width: 768px) {\n        display: block;\n    }\n"
    ]);
    ModalCancel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalCancel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n"
    ]);
    ModalCancel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalCancel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 24px 0 24px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    ModalCancel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalCancel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 28px;\n    font-weight: 700;\n    @media screen and (max-width: 768px) {\n        font-size: 24px;\n    }\n"
    ]);
    ModalCancel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalCancel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    /* justify-content: center; */\n"
    ]);
    ModalCancel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalCancel_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 12px;\n    margin-top: 4px;\n    @media screen and (max-width: 600px) {\n        font-size: 10px;\n    }\n"
    ]);
    ModalCancel_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var CancelModal = function(_param) {
    var sAccount = _param.sAccount, handleOpenLink = _param.handleOpenLink, onDismiss = _param.onDismiss, item = _param.item, title = _param.title, account = _param.account, chainId = _param.chainId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "sAccount",
        "handleOpenLink",
        "onDismiss",
        "item",
        "title",
        "account",
        "chainId"
    ]);
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var windowSize = (0,getWindowSize/* default */.Z)();
    var ref2 = fetchData_GetNftInfo(item === null || item === void 0 ? void 0 : item.nftAddress, account, item === null || item === void 0 ? void 0 : item.nftId, account, chainId), nftInfo = ref2.nftInfo, isLoading = ref2.isLoading;
    var ref3 = useDelistp2p(account, chainId, item === null || item === void 0 ? void 0 : item.nftAddress, item === null || item === void 0 ? void 0 : item.buys, onDismiss), handleDelistp2p = ref3.handleDelistp2p, pendingDelistp2p = ref3.pendingDelistp2p;
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onDismiss: onDismiss
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                alignItems: "center",
                mt: "1rem",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTitle, {
                    children: t("X\xe1c nhận huỷ")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: windowSize > 768 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCancel_WrapperItemHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Mệnh gi\xe1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Mệnh gi\xe1 (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Lợi suất"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Ng\xe0y trả LS"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Ng\xe0y trả lợi suất",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    width: "14.2%",
                                    children: "Ng\xe0y c\xf2n lại"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CsFlexHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Gi\xe1 trị"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Gi\xe1 trị (VND)",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {})
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_WrapperCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.profit).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        }), "%")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(totalVested, "/").concat(totalVestingMap)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : "".concat(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.intervestTerm, " th\xe1ng")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000).isNaN() ? "0" : "".concat(convertDate((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: new bignumber/* default */.Z((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000).isNaN() ? "0 ".concat(config/* UNIT_DATE */.L$) : "".concat(getDateBetweenTwoDates((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000), " ").concat(config/* UNIT_DATE */.L$)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "14.2%",
                                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            width: "42px"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: new bignumber/* default */.Z(item === null || item === void 0 ? void 0 : item.price).isNaN() ? "0" : Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTransaction, {
                            titleOrderQuantity: "Số lượng giao dịch",
                            valueOrderQuantity: item === null || item === void 0 ? void 0 : (ref1 = item.amountTrading) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                            valueTransactionMethod: "B\xe1n thỏa thuận",
                            dateTransaction: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000),
                            addressBuy: item === null || item === void 0 ? void 0 : item.addressTrading,
                            totalMoney: Number(item === null || item === void 0 ? void 0 : item.price),
                            textAlert: "Địa chỉ v\xed người mua",
                            utiOrderQuantity: "CCQ"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_WrapItemMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapQuantity, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "23.3%",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Mệnh gi\xe1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                    bold: true,
                                                                    children: Number(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.price).toLocaleString("en", {
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "23.3%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : "".concat(nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.profit, "%")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "23.3%",
                                                justifyContent: "flex-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Kỳ đ\xe3 nhận/Tổng kỳ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: [
                                                                    totalVested,
                                                                    "/",
                                                                    totalVestingMap
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        mt: "8px",
                                        style: {
                                            display: "grid",
                                            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "flex-start",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Kỳ trả lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: "42px"
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                                    style: {
                                                                        gap: "4px"
                                                                    },
                                                                    justifyContent: "center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                            style: {
                                                                                color: "#02111b",
                                                                                fontWeight: "700"
                                                                            },
                                                                            children: nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.intervestTerm
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                            children: "th\xe1ng"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Ng\xe0y c\xf2n lại",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "2px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: new bignumber/* default */.Z((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000).isNaN() ? "0" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                                    color: "#02111b",
                                                                    style: {
                                                                        fontWeight: "700"
                                                                    },
                                                                    children: [
                                                                        getDateBetweenTwoDates((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000),
                                                                        " ",
                                                                        config/* UNIT_DATE */.L$
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsFlexHeaderMb, {
                                                width: "100%",
                                                justifyContent: "flex-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                                                    title: "Ng\xe0y trả lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        style: {
                                                            cursor: "pointer",
                                                            gap: "4px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                ml: "4px",
                                                                children: new bignumber/* default */.Z((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000).isNaN() ? "0" : convertDate((nftInfo === null || nftInfo === void 0 ? void 0 : nftInfo.nextInterestPaymentDate) * 1000)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                height: "auto",
                                flexDirection: "column",
                                style: {
                                    gap: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        style: {
                                            color: "#02111b",
                                            fontWeight: 700,
                                            fontSize: "0.875rem"
                                        },
                                        children: "Th\xf4ng tin chứng chỉ quỹ"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                color: "textSubtle",
                                                children: "Ng\xe0y giao dịch"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                bold: true,
                                                children: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                color: "textSubtle",
                                                children: "Địa chỉ v\xed giao dịch thỏa thuận"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                bold: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CustomLink, {
                                                    style: {
                                                        textAlign: "right"
                                                    },
                                                    onClick: function() {
                                                        return handleOpenLink(item === null || item === void 0 ? void 0 : item.addressTrading);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            style: {
                                                                fontWeight: "600",
                                                                color: "#02111b"
                                                            },
                                                            children: sAccount(item === null || item === void 0 ? void 0 : item.addressTrading)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                color: "textSubtle",
                                                children: "Số lượng"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                bold: true,
                                                children: item === null || item === void 0 ? void 0 : item.amountTrading
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                color: "textSubtle",
                                                children: "Phương thức thanh to\xe1n"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                fontSize: "12px",
                                                bold: true,
                                                children: "B\xe1n thỏa thuận"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: "100%",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mt: "0.5rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CsTextMobile, {
                                                color: "textSubtle",
                                                children: "Tổng tiền thỏa thuận"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexDirection: "column",
                                                alignItems: "flex-end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        flexDirection: "row",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextValue, {
                                                                children: Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                                bold: true,
                                                                color: "text",
                                                                ml: "5px",
                                                                children: "VND"
                                                            })
                                                        ]
                                                    }),
                                                    Number(item === null || item === void 0 ? void 0 : item.price) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel_CsUnit, {
                                                        style: {
                                                            color: "#8C8D8E"
                                                        },
                                                        children: " (Tương đương ".concat(Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0
                                                        }), " điểm VNDC)")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_WrapperButton, {
                children: [
                    !item.isBuyP2P && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        style: {
                            color: "red",
                            fontSize: "14px",
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "10px"
                        },
                        children: "Đ\xe3 hết kỳ nhận lợi suất của CCQ kh\xf4ng thể thực hiện giao dịch, vui l\xf2ng x\xe1c nhận hủy!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        style: {
                            gap: "10px"
                        },
                        width: "100%",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_styles_CsButtonConfirm, {
                            disabled: pendingDelistp2p || (item === null || item === void 0 ? void 0 : item.paused),
                            onClick: handleDelistp2p,
                            endIcon: pendingDelistp2p ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                spin: true,
                                color: "textSubtle"
                            }) : "",
                            children: t("X\xe1c nhận hủy")
                        })
                    })
                ]
            }),
            (item === null || item === void 0 ? void 0 : item.paused) === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                mt: [
                    "1rem",
                    ,
                    ,
                    "1rem"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: [
                        "12px",
                        ,
                        ,
                        "14px"
                    ],
                    color: "red",
                    children: t("CCQ đang tạm kh\xf3a, vui l\xf2ng quay lại sau!")
                })
            })
        ]
    }));
};
var ModalCancel_CsImgCoin = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7cebbd8d-0"
})(ModalCancel_templateObject());
var ModalCancel_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7cebbd8d-1"
})(ModalCancel_templateObject1());
var ModalCancel_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7cebbd8d-2"
})(ModalCancel_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-7cebbd8d-3"
})(ModalCancel_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ModalCancel_CsFlexHeaderMb = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7cebbd8d-4"
})(ModalCancel_templateObject4());
var ModalCancel_CsUnit = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7cebbd8d-5"
})(ModalCancel_templateObject5());
/* harmony default export */ var ModalCancel = (CancelModal);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/components/Row.tsx


function TabsOrder_components_Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 80px !important;\n    height: 100%;\n    padding: 26px;\n    align-items: center;\n    position: relative;\n    flex-direction: row;\n    border-radius: 20px;\n    margin-top: 24px;\n    justify-content: space-between;\n    border: 1px solid ",
        ";\n    ",
        " {\n        text-align: center;\n        font-size: 14px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n    }\n"
    ]);
    TabsOrder_components_Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsOrder_components_Row_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 13.3%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    TabsOrder_components_Row_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_Row_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 10%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    components_Row_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_Row_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n"
    ]);
    components_Row_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function components_Row_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 80%;\n    @media screen and (max-width: 1000px) {\n        width: 100%;\n        margin-top: 12px;\n        justify-content: center;\n    }\n"
    ]);
    components_Row_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function components_Row_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 170px;\n    height: 40px;\n    padding: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 4px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    transition: 0.5s;\n    @media screen and (max-width: 1024px) {\n        font-size: 12px;\n        padding: 6px;\n        width: 130px;\n        height: 36px;\n    }\n    @media screen and (max-width: 768px){\n        width: 100px;\n        height: 36px;\n    }\n"
    ]);
    components_Row_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function components_Row_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 170px;\n    height: 40px;\n    padding: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 4px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    transition: 0.5s;\n    @media screen and (max-width: 1024px) {\n        padding: 6px;\n        font-size: 12px;\n        width: 130px;\n        height: 36px;\n    }\n    @media screen and (max-width: 600px){\n        width: 100px;\n    }\n"
    ]);
    components_Row_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function components_Row_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 16px;\n    border-radius: 4px;\n    padding: 0 12px 12px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    @media screen and (max-width: 767px){\n        margin-top: 0;\n    }\n    ",
        " {\n        margin: 10px 0;\n        font-size: 12px;\n        font-weight: 500;\n        &:last-child {\n            text-align: right;\n        }\n    }\n"
    ]);
    components_Row_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function components_Row_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    @media screen and (min-width: 767px){\n        width: 25%;\n    }\n"
    ]);
    components_Row_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Row_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 100%;\n    align-items: center;\n    justify-content: center;\n"
    ]);
    Row_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}














var components_Row_Row = function(param) {
    var item = param.item, account = param.account, chainId = param.chainId, windowSize = param.windowSize, indexRow = param.indexRow, listAllowance = param.listAllowance, balance = param.balance, tokenAddress = param.tokenAddress;
    var handleOpenLink = function handleOpenLink(address) {
        window.open((0,utils/* getBlockExploreLink */.C)(address, "address", chainId));
    };
    var sAccount = function sAccount(dataAddress) {
        if (dataAddress) {
            return "".concat(dataAddress.substring(0, 4), "...").concat(dataAddress.substring(dataAddress.length - 4));
        }
        return "";
    };
    var ref;
    var t = (0,src/* useTranslation */.$G)().t;
    var itemAllowance = listAllowance.find(function(data) {
        var ref, ref1;
        return (data === null || data === void 0 ? void 0 : (ref = data.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (item === null || item === void 0 ? void 0 : (ref1 = item.nftAddress) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_components_ModalDetail, {
        handleOpenLink: handleOpenLink,
        sAccount: sAccount,
        item: item,
        account: account,
        chainId: chainId
    })), 1), openDetailModal = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmModalPC, {
        handleOpenLink: handleOpenLink,
        sAccount: sAccount,
        title: "X\xe1c nhận giao dịch",
        item: item,
        account: account,
        chainId: chainId,
        itemAllowance: itemAllowance,
        balance: balance,
        tokenAddress: tokenAddress
    }), true, true, "modal_confirm_".concat(indexRow)), 1), onConfirmModal = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancel, {
        handleOpenLink: handleOpenLink,
        sAccount: sAccount,
        title: "Th\xf4ng tin Chứng chỉ Quỹ",
        item: item,
        account: account,
        chainId: chainId
    }), true, true, "modal_cancel_".concat(indexRow)), 1), onCancelModal = ref3[0];
    var totalVested = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.filter(function(itemVest) {
            return (itemVest === null || itemVest === void 0 ? void 0 : itemVest.isVested) === !false;
        })) === null || ref1 === void 0 ? void 0 : ref1.length;
    }, [
        item === null || item === void 0 ? void 0 : item.vestingMap
    ]);
    var totalVestingMap = (0,react.useMemo)(function() {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length;
    }, [
        item === null || item === void 0 ? void 0 : (ref = item.vestingMap) === null || ref === void 0 ? void 0 : ref.length
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_WrapItem, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItemSmall, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsText, {
                        isBuy: item === null || item === void 0 ? void 0 : item.isSelling,
                        children: (item === null || item === void 0 ? void 0 : item.isSelling) ? t("B\xe1n") : t("Mua")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        children: convertDate((item === null || item === void 0 ? void 0 : item.dateTrading) * 1000)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: "text",
                        children: [
                            totalVested,
                            "/",
                            totalVestingMap
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItemSmall, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        children: item === null || item === void 0 ? void 0 : item.amountTrading
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        children: Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "text",
                        children: "Đang chờ x\xe1c nhận"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_CsItem, {
                    onClick: function() {
                        return handleOpenLink(item === null || item === void 0 ? void 0 : item.addressTrading);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                            title: item === null || item === void 0 ? void 0 : item.addressTrading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: sAccount(item === null || item === void 0 ? void 0 : item.addressTrading)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_CsButtonConfirm, {
                        children: [
                            (item === null || item === void 0 ? void 0 : item.isSelling) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButtonCancel, {
                                onClick: onCancelModal,
                                children: t("Huỷ")
                            }),
                            (item === null || item === void 0 ? void 0 : item.isSelling) === false && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonConfirmMobile, {
                                onClick: onConfirmModal,
                                children: t("Tuỳ chọn")
                            })
                        ]
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Row_WrapItemMobile, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-between",
                mt: "0.5rem",
                alignItems: "center",
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "30%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {
                                width: "20px",
                                onClick: openDetailModal,
                                style: {
                                    cursor: "pointer"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsText, {
                                isBuy: item === null || item === void 0 ? void 0 : item.isSelling,
                                children: (item === null || item === void 0 ? void 0 : item.isSelling) ? t("B\xe1n") : t("Mua")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsFlexHeader, {
                        width: "30%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Số lượng",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer",
                                    gap: "2px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "11px",
                                        color: "textSubtle",
                                        children: "SL:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "4px",
                                        children: item === null || item === void 0 ? void 0 : item.amountTrading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsFlexHeader, {
                        width: "30%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip3, {
                            title: "Tổng gi\xe1 trị giao dịch",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    cursor: "pointer",
                                    gap: "2px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "11px",
                                        color: "textSubtle",
                                        children: "GT:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        mr: "4px",
                                        ml: "4px",
                                        children: Number(item === null || item === void 0 ? void 0 : item.price).toLocaleString("en", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq2/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        minWidth: "30%",
                        style: {
                            fontWeight: "600"
                        },
                        children: [
                            " ",
                            renderStatus_renderStatus(item === null || item === void 0 ? void 0 : item.isSelling)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_styles_CustomLink, {
                        style: {
                            textAlign: "right"
                        },
                        width: "25%",
                        onClick: function() {
                            return handleOpenLink(item === null || item === void 0 ? void 0 : item.addressTrading);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                title: item === null || item === void 0 ? void 0 : item.addressTrading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        children: sAccount(item === null || item === void 0 ? void 0 : item.addressTrading)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNewIcon/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapBtn, {
                        children: (item === null || item === void 0 ? void 0 : item.isSelling) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_CsButtonCancel, {
                            onClick: onCancelModal,
                            children: t("Huỷ")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonConfirmMobile, {
                            onClick: onConfirmModal,
                            children: t("T\xf9y chọn")
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TabsOrder_components_Row = (components_Row_Row);
var Row_WrapItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-0"
})(TabsOrder_components_Row_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, Text/* default */.Z);
var Row_CsItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-1"
})(TabsOrder_components_Row_templateObject1());
var Row_CsItemSmall = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-2"
})(components_Row_templateObject2());
var Row_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-895b5174-3"
})(components_Row_templateObject3(), function(param) {
    var theme = param.theme, isBuy = param.isBuy;
    return isBuy ? theme.colors.red : theme.colors.success2;
});
var Row_CsButtonConfirm = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-4"
})(components_Row_templateObject4());
var Row_CsButtonCancel = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-895b5174-5"
})(components_Row_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
}, function(param) {
    var theme = param.theme;
    return theme.colors.red;
});
var CsButtonConfirmMobile = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-895b5174-6"
})(components_Row_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var components_Row_WrapItemMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-895b5174-7"
})(components_Row_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, Text/* default */.Z);
var CsWrapBtn = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-8"
})(components_Row_templateObject8());
var Row_CsFlexHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-895b5174-9"
})(Row_templateObject9());

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/TabsOrder/index.tsx


function TabsOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n"
    ]);
    TabsOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    padding-bottom: 20px;\n    flex-direction: column;\n"
    ]);
    TabsOrder_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    border-radius: 20px;\n    margin: 40px 0 0px 0;\n    padding: 0 26px;\n    justify-content: space-between;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n"
    ]);
    TabsOrder_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n"
    ]);
    TabsOrder_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n    width: 100%;\n    justify-content: center;\n    margin-top:1rem;\n    .pagination {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        align-items: center;\n        @media screen and (max-width: 600px) {\n            width: 100%;\n        }\n        * {\n            list-style-type: none;\n        }\n    }\n    .page-item {\n        margin: 0 0.375rem;\n        &:first-child,\n        &:last-child {\n            a {\n                &:hover {\n                    color: #13486b;\n                    border: none !important;\n                }\n            }\n        }\n        &:first-child,\n        &:last-child {\n            a {\n                border: none;\n                background: none !important;\n            }\n        }\n        &:last-child.disabled,\n        &:first-child.disabled {\n            cursor: not-allowed;\n        }\n    }\n    .page-link {\n        width: 32px;\n        height: 32px;\n        display: flex;\n        background: #fff;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px !important;\n        color: #02111b;\n        border: 1px solid #efefef;\n        @media screen and (max-width: 768px) {\n            padding: 12px;\n        }\n        &:focus {\n            box-shadow: none !important;\n        }\n        &:hover {\n            background: #13486b;\n            color: #fff;\n            border: 1px solid #13486b !important;\n        }\n    }\n    .page-item.disabled .page-link {\n        background: ",
        ";\n        cursor: not-allowed !important;\n        opacity: 0.7;\n        pointer-events: none;\n    }\n    .page-item.active .page-link {\n        background: #13486b;\n        color: #fff;\n        border: none;\n    }\n"
    ]);
    TabsOrder_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 13.3%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    line-height: 21px;\n    color:",
        ";\n    font-weight:bold;\n    font-size: 14px;\n    white-space: nowrap;\n    ",
        "{\n        font-size: 14px;\n        white-space: nowrap;\n    }\n"
    ]);
    TabsOrder_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 10%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    line-height: 21px;\n    color:",
        ";\n    font-weight:bold;\n    font-size: 14px;\n    white-space: nowrap;\n    ",
        "{\n        font-size: 14px;\n        white-space: nowrap;\n    }\n"
    ]);
    TabsOrder_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TabsOrder_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 60px;\n    width: 50%;\n    @media screen and (max-width: 1200px){\n        ",
        "{\n            font-size: 22px;\n        }\n    }\n    @media screen and (max-width: 1000px){\n        margin-top: 30px;\n        margin-bottom: 20px;\n        ",
        "{\n            font-size: 18px;\n        }\n    }\n    @media screen and (max-width: 767px){\n        width: 100%;\n        margin-top: 30px;\n        margin-bottom: 20px;\n        ",
        "{\n            font-size: 14px;\n        }\n    }\n    h6 {\n        font-size: 1.25rem;\n        color: #8c8d8e;\n        font-weight: 500;\n    }\n    p {\n        color: #f9a138;\n        font-size: 1.75rem;\n        font-weight: 500;\n        span {\n            color: #02111b;\n            font-weight: 600;\n        }\n    }\n    ",
        " {\n        justify-content: space-between;\n    }\n"
    ]);
    TabsOrder_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var TabsOrder_pageSize = 7;
var TabsOrder = function(param) {
    var windowSize = param.windowSize;
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var ref1 = (0,react.useState)(0), itemOffset = ref1[0], setItemOffset = ref1[1];
    // order
    var token = renderToken(chainId);
    UseCoreListOrder(token === null || token === void 0 ? void 0 : token.address, account, chainId);
    var ref2 = GetDataListOrder(), listAllowanc = ref2.listAllowanc, listItemOrder = ref2.listItemOrder, isLoading = ref2.isLoading, balance = ref2.balance;
    var listOrder = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(listItemOrder);
    }, [
        listItemOrder
    ]);
    var sortList = (0,_to_consumable_array/* default */.Z)(listOrder).sort(function(a, b) {
        return (b === null || b === void 0 ? void 0 : b.dateTrading) - (a === null || a === void 0 ? void 0 : a.dateTrading);
    });
    var total = sortList.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        alignItems: "flex-end",
        children: [
            windowSize > 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_WrapperTable, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_WrapperTableHeader, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_CsItemSmall, {
                                    children: "Loại lệnh"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_CsItem, {
                                    children: "Ng\xe0y giao dịch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_CsItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Kỳ đ\xe3 nhận"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Kỳ đ\xe3 nhận /Tổng kỳ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_CsItemSmall, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "SL giao dịch"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Số lượng giao dịch",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_CsItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Tổng gi\xe1 trị"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Tổng gi\xe1 trị giao dịch",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_CsItem, {
                                    children: "Trạng th\xe1i"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsOrder_CsItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            mr: "0.2rem",
                                            children: "Địa chỉ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip2, {
                                            title: "Địa chỉ v\xed giao dịch thoả thuận",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                    " "
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_CsItem, {
                                    children: "H\xe0nh động"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_WrapperTableContent, {
                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "center",
                                mt: "3rem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                    spin: true,
                                    color: "textSubtle"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: sortList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: sortList.splice(itemOffset, TabsOrder_pageSize).map(function(item, key) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_components_Row, {
                                            item: item,
                                            account: account,
                                            chainId: chainId,
                                            windowSize: windowSize,
                                            indexRow: key,
                                            listAllowance: listAllowanc,
                                            balance: balance,
                                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                                        });
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        width: "100%",
                                        textAlign: "center",
                                        mt: "2rem",
                                        children: "Kh\xf4ng c\xf3 dữ liệu"
                                    })
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_WrapperTableMobile, {
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    mt: "3rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        spin: true,
                        color: "textSubtle"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: sortList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: sortList.splice(itemOffset, TabsOrder_pageSize).map(function(item, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_components_Row, {
                                item: item,
                                account: account,
                                chainId: chainId,
                                windowSize: windowSize,
                                indexRow: key,
                                listAllowance: listAllowanc,
                                balance: balance,
                                tokenAddress: token === null || token === void 0 ? void 0 : token.address
                            });
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            width: "100%",
                            textAlign: "center",
                            mt: "2rem",
                            children: "Kh\xf4ng c\xf3 dữ liệu"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsOrder_CustomFlex, {
                children: sortList.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPaginate, {
                    total: total,
                    pageSize: TabsOrder_pageSize,
                    setItemOffset: setItemOffset
                })
            })
        ]
    });
};
var TabsOrder_WrapperTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-778d0cd3-0"
})(TabsOrder_templateObject());
var TabsOrder_WrapperTableMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-1"
})(TabsOrder_templateObject1());
var TabsOrder_WrapperTableHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-2"
})(TabsOrder_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var TabsOrder_WrapperTableContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-3"
})(TabsOrder_templateObject3());
var TabsOrder_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-4"
})(TabsOrder_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
});
var TabsOrder_CsItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-5"
})(TabsOrder_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, Text/* default */.Z);
var TabsOrder_CsItemSmall = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-6"
})(TabsOrder_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, Text/* default */.Z);
var TabsOrder_WrapperTotal = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-778d0cd3-7"
})(TabsOrder_templateObject7(), Text/* default */.Z, Text/* default */.Z, Text/* default */.Z, Flex/* default */.Z);
/* harmony default export */ var FooterTabs_TabsOrder = (TabsOrder);

;// CONCATENATED MODULE: ./src/views/MarketPlace/FooterTabs/index.tsx


function FooterTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 3rem;\n    padding: 0 16px 3rem;\n    width: 100%;\n    min-height: 100vh;\n    justify-content: flex-start;\n    @media screen and (max-width: 1000px) {\n        min-height: auto;\n        margin-top: 1rem;\n        padding: 0 16px 3rem;\n    }\n    @media screen and (max-width: 600px) {\n        margin-top: 1rem;\n        padding: 0 10px 3rem;\n    }\n"
    ]);
    FooterTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FooterTabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    flex-flow: column;\n    max-width: 1280px;\n    justify-content: flex-start;\n    align-items: center;\n    min-height: 100vh;\n"
    ]);
    FooterTabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FooterTabs_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1140px;\n    grid-template-columns: repeat(3, 1fr);\n    width: 100% !important;\n    display: grid;\n    height: 84px;\n    padding: 8px;\n    background-color: ",
        ";\n    border-radius: 8px;\n    align-items: center;\n    margin-top: 3.375rem;\n    gap: 10px;\n    @media screen and (max-width: 600px) {\n        height: 64px;\n        gap: 5px;\n        margin-left: 20px;\n        margin-right: 20px;\n        margin-top: 1.563rem;\n    }\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        height: 64px;\n        margin-top: 1.563rem;\n    }\n"
    ]);
    FooterTabs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function FooterTabs_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 64px;\n    border-radius: 8px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: 22px;\n    font-weight: 700;\n    transition: 0.5s;\n    @media screen and (max-width: 600px) {\n        font-size: 14px;\n        height: 48px;\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n    @media screen and (min-width: 601px) and (max-width: 1000px) {\n        font-size: 16px;\n        height: 48px;\n    }\n"
    ]);
    FooterTabs_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var FooterTabs = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), tabActive = ref[0], setTabActive = ref[1];
    var windowSize = (0,getWindowSize/* default */.Z)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var marketplaceAddress = renderMarketplaceAddress(chainId);
    var handleChangeTabs = function(index) {
        return setTabActive(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperFooterContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerSubTab, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_CsButton, {
                        isActive: tabActive === 0 ? !false : false,
                        onClick: function() {
                            return handleChangeTabs(0);
                        },
                        children: "SỔ LỆNH"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_CsButton, {
                        isActive: tabActive === 1 ? !false : false,
                        onClick: function() {
                            return handleChangeTabs(1);
                        },
                        children: "T\xc0I SẢN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_CsButton, {
                        isActive: tabActive === 2 ? !false : false,
                        onClick: function() {
                            return handleChangeTabs(2);
                        },
                        children: "TRA CỨU"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFooterContent, {
                children: [
                    tabActive === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_TabsOrder, {
                        windowSize: windowSize
                    }),
                    tabActive === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_TabsAsset, {
                        windowSize: windowSize
                    }),
                    tabActive === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterTabs_TabsHistory, {
                        windowSize: windowSize
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MarketPlace_FooterTabs = (FooterTabs);
var WrapperFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4b55185-0"
})(FooterTabs_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CsFooterContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4b55185-1"
})(FooterTabs_templateObject1());
var ContainerSubTab = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-4b55185-2"
})(FooterTabs_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var FooterTabs_CsButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-4b55185-3"
})(FooterTabs_templateObject3(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.primary : "transparent";
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.white : theme.colors.primary;
});

;// CONCATENATED MODULE: ./src/components/Select/Select.tsx




function Select_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  padding: 0px 16px;\n  align-items: center;\n  justify-content: space-between;\n  transition: border-radius 0.15s;\n  color: #fdb533;\n\n  @media screen and (max-width: 1024px) {\n    padding: 0 10px;\n    justify-content: center;\n  }\n"
    ]);
    Select_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Select_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 180px;\n  height: 100%;\n  padding: 12px;\n  max-height:250px;\n  position: absolute;\n  overflow-y: hidden;\n  overflow-x:hidden;\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: ",
        ";\n  background: ",
        ";\n  color: ",
        " !important;\n  ",
        " {\n    min-width: 50px;\n    width: 160px;\n  }\n"
    ]);
    Select_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Select_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ",
        " {\n        /* box-shadow: ",
        "; */\n      }\n      ",
        " {\n        opacity: 1;\n        height: auto;\n        transform: scaleY(1);\n        border-top-width: 0;\n        background:  ",
        ";\n        border-radius: 12px;\n        width: 100%;\n        transform: translateY(3.063rem);\n        @media only screen and (max-width: 1024px){\n          border-radius: 4px;\n        }\n      }\n    "
    ]);
    Select_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Select_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  position: relative;\n  cursor: pointer;\n  min-width: 180px;\n  max-width: 220px;\n  height: 48px;\n  display: flex;\n  box-sizing: border-box;\n  @media only screen and (max-width: 1024px) {\n    height: 40px;\n    min-width: 120px;\n    border-radius:4px;\n  }\n  @media only screen and (max-width: 600px) {\n    max-width: 160px;\n  }\n  border: 1px solid ",
        ";\n  border-radius: 12px;\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    fill:  ",
        " !important;\n    @media only screen and (max-width: 1024px) {\n      right: 9px;\n    }\n  }\n\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n    /* margin-top:1rem; */\n  }\n"
    ]);
    Select_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Select_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  background:  ",
        ";\n  z-index: ",
        ";\n"
    ]);
    Select_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Select_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 8px;\n  border-radius:4px;\n  &:hover {\n    background: ",
        ";\n    > div {\n      color: #fff !important;\n    }\n  }\n"
    ]);
    Select_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Select_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 58px;\n    justify-content: space-between;\n    border-top-right-radius: 11px;\n    border-bottom-right-radius: 11px;\n    border-left: 1px solid ",
        ";\n    transition: 0.5s;\n    &:hover{\n      border-left: 1px solid transparent;\n      background: ",
        ";\n      svg{\n        fill: ",
        " !important;\n      }\n    }\n    @media only screen and (max-width: 1024px) {\n      width: 40px;      \n      border-top-right-radius: 3px;\n      border-bottom-right-radius: 3px;\n    }\n"
    ]);
    Select_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Select_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 320px) {\n    padding: 0px\n  }\n  ",
        "{\n    color: ",
        ";\n    font-size: 14px;\n  }\n"
    ]);
    Select_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var Select_DropDownHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e8e7318-0"
})(Select_templateObject());
var Select_DropDownListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e8e7318-1"
})(Select_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "#fdb533" : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Select_DropDownContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1e8e7318-2"
})(Select_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(props) {
    return props.isOpen && (0,styled_components_browser_esm/* css */.iv)(Select_templateObject2(), Select_DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, Select_DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.white;
    });
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Select_DropDownList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-1e8e7318-3"
})(Select_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var Select_ListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-1e8e7318-4"
})(Select_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var CsInconSort = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1e8e7318-5"
})(Select_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, defaultOptionIndex = _param.defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var containerRef = (0,react.useRef)(null);
    var dropdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var theme = (0,useTheme/* default */.ZP)().theme;
    var toggling = function(event) {
        if (options.length > 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select_DropDownContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "primary",
                    fontSize: "14px",
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsInconSort, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSort/* default */.Z, {
                    color: theme.isDark ? "#fff" : "primary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_DropDownListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_DropDownList, {
                    ref: dropdownRef,
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_CustomListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Select_Select = (Select);
var Select_CustomListItem = (0,styled_components_browser_esm/* default */.ZP)(Select_ListItem).withConfig({
    componentId: "sc-1e8e7318-6"
})(Select_templateObject7(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});

;// CONCATENATED MODULE: ./src/views/MarketPlace/components/HeaderSort.tsx

function HeaderSort_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* justify-content: center; */\n"
    ]);
    HeaderSort_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var HeaderSort = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var windowSize = (0,getWindowSize/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    // select mệnh giá
    var handleSelectDenominations = function(option) {
        dispatch((0,actions/* selectDenominations */.pO)({
            denominations: Number(option === null || option === void 0 ? void 0 : option.value)
        }));
    };
    // select Kỳ trả lợi suất
    var handeleSelectPaymentPeriod = function(option) {
        dispatch((0,actions/* selectPaymentPeriod */.f3)({
            paymentPeriod: Number(option === null || option === void 0 ? void 0 : option.value)
        }));
    };
    // Số ngày đến kì trả lợi suất
    var handleSelectNextInterestPaymentDate = function(option) {
        dispatch((0,actions/* selectNextInterestPaymentDate */.W2)({
            nextInterestPaymentDate: Number(option === null || option === void 0 ? void 0 : option.value)
        }));
    };
    // select Lợi suất kì này`
    var handleSelectCurrentYield = function(option) {
        dispatch((0,actions/* selectCurrentYield */.cx)({
            currentYield: Number(option === null || option === void 0 ? void 0 : option.value)
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: windowSize > 1000 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            padding: " 0 16px",
            mt: [
                "0",
                ,
                "1rem"
            ],
            mb: "1rem",
            width: "100%",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: [
                "column",
                ,
                ,
                "row"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSort_CsFlexSort, {
                    justifyContent: "flex-start",
                    padding: [
                        "12px 0",
                        ,
                        ,
                        "0"
                    ],
                    alignItems: "center",
                    width: [
                        "100%",
                        ,
                        ,
                        "24%"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "right",
                            fontSize: [
                                "12px",
                                ,
                                "14px"
                            ],
                            mr: "10px",
                            children: t("Mệnh gi\xe1")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select, {
                            options: [
                                {
                                    label: t("To\xe0n bộ"),
                                    value: 0
                                },
                                {
                                    label: t("100,000"),
                                    value: 100000
                                }
                            ],
                            onOptionChange: handleSelectDenominations,
                            defaultOptionIndex: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSort_CsFlexSort, {
                    justifyContent: "flex-start",
                    padding: [
                        "12px 0",
                        ,
                        ,
                        "0"
                    ],
                    alignItems: "center",
                    width: [
                        "100%",
                        ,
                        ,
                        "24%"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "right",
                            fontSize: [
                                "12px",
                                ,
                                "14px"
                            ],
                            mr: "10px",
                            children: t("Kỳ trả lợi suất")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select, {
                            options: [
                                {
                                    label: t("To\xe0n bộ"),
                                    value: 0
                                },
                                {
                                    label: t("3 th\xe1ng"),
                                    value: 3
                                },
                                {
                                    label: t("6 th\xe1ng"),
                                    value: 6
                                }
                            ],
                            onOptionChange: handeleSelectPaymentPeriod,
                            defaultOptionIndex: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSort_CsFlexSort, {
                    justifyContent: "center",
                    padding: [
                        "12px 0",
                        ,
                        ,
                        "0"
                    ],
                    alignItems: "center",
                    width: [
                        "100%",
                        ,
                        ,
                        "27%"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            textAlign: "right",
                            fontSize: [
                                "12px",
                                ,
                                "14px"
                            ],
                            mr: "10px",
                            children: [
                                "Số ng\xe0y đến ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " kỳ trả lợi suất"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select, {
                            options: [
                                {
                                    label: t("To\xe0n bộ"),
                                    value: 0
                                },
                                {
                                    label: t("Dưới 10 ng\xe0y"),
                                    value: 1
                                },
                                {
                                    label: t("10 - 30 ng\xe0y"),
                                    value: 2
                                },
                                {
                                    label: t("30 - 60 ng\xe0y"),
                                    value: 3
                                },
                                {
                                    label: t("Tr\xean 60 ng\xe0y"),
                                    value: 4
                                }
                            ],
                            onOptionChange: handleSelectNextInterestPaymentDate,
                            defaultOptionIndex: 0
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSort_CsFlexSort, {
                    justifyContent: "flex-end",
                    padding: [
                        "12px 0",
                        ,
                        ,
                        "0"
                    ],
                    alignItems: "center",
                    width: [
                        "100%",
                        ,
                        ,
                        "25%"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "right",
                            fontSize: [
                                "12px",
                                ,
                                "14px"
                            ],
                            mr: "10px",
                            children: t("Lợi suất kỳ n\xe0y")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select, {
                            options: [
                                {
                                    label: t("To\xe0n bộ"),
                                    value: 0
                                },
                                {
                                    label: t("8%"),
                                    value: 8
                                },
                                {
                                    label: t("9.2%"),
                                    value: 9.2
                                }
                            ],
                            onOptionChange: handleSelectCurrentYield,
                            defaultOptionIndex: 0
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_HeaderSort = (HeaderSort);
var HeaderSort_CsFlexSort = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-71fefc80-0"
})(HeaderSort_templateObject());

;// CONCATENATED MODULE: ./src/views/MarketPlace/components/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    img.logo{\n            width: 330px;\n            margin-bottom: 40px;\n            @media screen and (max-width: 1024px) {\n                display: none;\n            }\n        }\n    h4{\n        margin-bottom: 28px;\n        color: #F9A138;\n        font-size: 24px;\n        font-weight: 500;\n        @media screen and (max-width: 1024px) {\n            font-size: 16px;\n            margin-bottom: 14px;\n        }\n    }\n    .description{\n        display: flex;\n        flex-direction: column;\n        gap: 14px;\n        @media screen and (max-width: 1024px) {\n            gap: 8px;\n        }\n        .social{\n            display: flex;\n            gap: 24px;\n        }\n    }\n    p{\n        text-align: justify;\n        color: #ffff;\n        font-size: 16px;\n        line-height: 24px;\n        @media screen and (max-width: 1024px) {\n            font-size: 13px;\n            max-width: 100%;\n        }\n    }\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .verichain{\n        display: none;\n        @media screen and (max-width: 1024px) {\n            width: 230px;\n            display: block;\n            margin-bottom: 20px;\n        }\n    }\n    img.logo-tss{\n        width: 162px;\n        margin-bottom: 40px;\n        @media screen and (max-width: 1024px) {\n            width: 120px;\n            margin-bottom: 24px;\n        }\n    }\n    h4{\n        margin-bottom: 28px;\n        color: #F9A138;\n        font-size: 24px;\n        font-weight: 500;\n        @media screen and (max-width: 1024px) {\n            font-size: 16px;\n            margin-bottom: 14px;\n        }\n    }\n    p{\n        max-width: 560px;\n        text-align: justify;\n        color: #ffff;\n        font-size: 16px;\n        line-height: 24px;\n        @media screen and (max-width: 1024px) {\n            font-size: 13px;\n            max-width: 100%;\n        }\n    }\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background:#13486B;\n    width: 100%;\n    padding: 35px 82px;\n    @media screen and (max-width: 1024px) {\n        padding: 20px;\n    }\n"
    ]);
    Footer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 36px;\n    @media screen and (max-width: 1024px) {\n        grid-template-columns: repeat(1, minmax(0, 1fr));\n    }\n"
    ]);
    Footer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CsWrapperFooter, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsLayoutFooter, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Headquarters, {})
            ]
        })
    });
};
var About = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsAbout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://tss.org.vn/chung-chi-quy",
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/ccqFundgo/logo-tss.png?version=1.1",
                    alt: "logo-tss",
                    className: "logo-tss"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: constants/* LINK_VERICHAINS */.G4,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/ccqFundgo/verichain.png?version=1.2",
                    alt: "verichain",
                    className: "verichain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Giới thiệu"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Trung t\xe2m Quản l\xfd T\xe0i sản số - Digital Asset Management Center, gọi tắt l\xe0 TSS, l\xe0 đơn vị đầu ti\xean tại Việt Nam được Nh\xe0 nước c\xf4ng nhận tư c\xe1ch ph\xe1p nh\xe2n để thực hiện nhiệm vụ th\xfac đẩy, tổ chức c\xe1c hoạt động số h\xf3a, nghi\xean cứu khoa học v\xe0 quản l\xfd t\xe0i sản số theo định hướng kinh tế số của Ch\xednh phủ."
            })
        ]
    });
};
var Headquarters = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsHeadquarters, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: constants/* LINK_VERICHAINS */.G4,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/ccqFundgo/verichain.png?version=1.2",
                    alt: "verichain",
                    className: "logo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Trụ sở ch\xednh"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "description",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "124 Huỳnh Tấn Ph\xe1t, Phường T\xe2n Thuận T\xe2y, Quận 7, Th\xe0nh phố Hồ Ch\xed Minh."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Hotline: 0899 165 169"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Email: support@tss.org.vn"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "social",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.facebook.com/TSS.ORG.VN",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ccqFundgo/fb.png",
                                    alt: "fb"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/TssTai",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ccqFundgo/twitter.png",
                                    alt: "twitter"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://t.me/TTQLTSS",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/ccqFundgo/telegram.png",
                                    alt: "telegram"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var CsHeadquarters = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc63d35-0"
})(Footer_templateObject());
var CsAbout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc63d35-1"
})(Footer_templateObject1());
var CsWrapperFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc63d35-2"
})(Footer_templateObject2());
var CsLayoutFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9cc63d35-3"
})(Footer_templateObject3());

;// CONCATENATED MODULE: ./src/views/MarketPlace/index.tsx




function MarketPlace_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 4rem;\n    padding: 0px 6px 0px 6px;\n"
    ]);
    MarketPlace_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MarketPlace_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    position: relative;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    height: 70px;\n    background: rgba(212, 238, 255, 0.34);\n    &::after {\n        content: "";\n        position: absolute;\n        left: 19%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ';\n    }\n    &::before {\n        content: "";\n        position: absolute;\n        right: 33.5%;\n        width: 1px;\n        height: 100%;\n        background: ',
        ";\n    }\n    ",
        "{\n        text-align:center;\n    }\n"
    ]);
    MarketPlace_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MarketPlace_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    border-radius: 20px;\n    margin: 36px 0 26px 0;\n    ",
        " {\n        text-align: center;\n        font-weight: 700;\n        font-size: 15px;\n        line-height: 19px;\n        letter-spacing: 0.04em;\n        color: ",
        ";\n    }\n    @media screen and (max-width: 600px) {\n        padding: 2rem 25px;\n    }\n    ",
        "{\n        line-height: 21px;\n        color: ",
        ";\n    }\n\n"
    ]);
    MarketPlace_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MarketPlace_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    MarketPlace_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




















var MarketPlace = function() {
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var windowSize = (0,getWindowSize/* default */.Z)();
    var ref2 = (0,useActiveWeb3React/* default */.Z)(), chainId = ref2.chainId, account = ref2.account;
    var marketplaceAddress = renderMarketplaceAddress(chainId);
    var token = renderToken(chainId);
    UseCoreMarketplace(marketplaceAddress, token.address, chainId, account);
    var dataMarketplace = GetDataMarketplace();
    var denominations = dataMarketplace.denominations, paymentPeriod = dataMarketplace.paymentPeriod, listCart = dataMarketplace.listCart, listItem = dataMarketplace.listItem, dataUser = dataMarketplace.dataUser;
    var sortAmount = (ref = (0,_to_consumable_array/* default */.Z)(listItem)) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
        return (a === null || a === void 0 ? void 0 : a.amount) - (b === null || b === void 0 ? void 0 : b.amount);
    });
    var filterDataAddress = sortAmount.reduce(function(acc, pre) {
        var index = acc.findIndex(function(item) {
            var ref, ref1;
            return (item === null || item === void 0 ? void 0 : (ref = item.nftAddress) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (pre === null || pre === void 0 ? void 0 : (ref1 = pre.nftAddress) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase());
        });
        if (index === -1) {
            acc.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pre), {
                buys: [
                    {
                        amount: pre.amount,
                        id: pre.id
                    }, 
                ]
            }));
        } else {
            var item = (0,_to_consumable_array/* default */.Z)(acc[index].buys);
            item.push({
                amount: pre.amount,
                id: pre.id
            });
            // eslint-disable-next-line no-param-reassign
            acc[index] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc[index]), {
                amount: acc[index].amount + pre.amount,
                buys: item
            });
        }
        return acc;
    }, []);
    var sortUnitPrice = (ref1 = (0,_to_consumable_array/* default */.Z)(filterDataAddress)) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
        return (b === null || b === void 0 ? void 0 : b.unitPrice) - (a === null || a === void 0 ? void 0 : a.unitPrice);
    });
    var sortByDenominations = (0,react.useMemo)(function() {
        var data = (0,_to_consumable_array/* default */.Z)(sortUnitPrice);
        switch(denominations){
            case 100000:
                return data.filter(function(item) {
                    return Number(item.price) === 100000;
                });
            default:
                return data;
        }
    }, [
        denominations,
        sortUnitPrice
    ]);
    var sortByPaymentPeriod = (0,react.useMemo)(function() {
        var data = (0,_to_consumable_array/* default */.Z)(sortByDenominations);
        switch(paymentPeriod){
            case 3:
                return data.filter(function(item) {
                    return Number(item === null || item === void 0 ? void 0 : item.interVestTerm) === 3;
                });
            case 6:
                return data.filter(function(item) {
                    return Number(item === null || item === void 0 ? void 0 : item.interVestTerm) === 6;
                });
            default:
                return data;
        }
    }, [
        paymentPeriod,
        sortByDenominations
    ]);
    var sortByNextInterestPaymentDate = (0,react.useMemo)(function() {
        var data = (0,_to_consumable_array/* default */.Z)(sortByPaymentPeriod);
        switch(dataMarketplace === null || dataMarketplace === void 0 ? void 0 : dataMarketplace.nextInterestPaymentDate){
            case 4:
                return data.filter(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.dayDiff) >= 60;
                });
            case 3:
                return data.filter(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.dayDiff) >= 30 && (item === null || item === void 0 ? void 0 : item.dayDiff) <= 60;
                });
            case 2:
                return data.filter(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.dayDiff) >= 10 && (item === null || item === void 0 ? void 0 : item.dayDiff) <= 30;
                });
            case 1:
                return data.filter(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.dayDiff) <= 10;
                });
            default:
                return data;
        }
    }, [
        dataMarketplace === null || dataMarketplace === void 0 ? void 0 : dataMarketplace.nextInterestPaymentDate,
        sortByPaymentPeriod
    ]);
    var sortByCurrentYield = (0,react.useMemo)(function() {
        var data = (0,_to_consumable_array/* default */.Z)(sortByNextInterestPaymentDate);
        switch(dataMarketplace === null || dataMarketplace === void 0 ? void 0 : dataMarketplace.currentYield){
            case 9.2:
                return data.filter(function(item) {
                    return Number(item === null || item === void 0 ? void 0 : item.interVestTermRate) === 9.2;
                });
            case 8:
                return data.filter(function(item) {
                    return Number(item === null || item === void 0 ? void 0 : item.interVestTermRate) === 8;
                });
            default:
                return data;
        }
    }, [
        dataMarketplace === null || dataMarketplace === void 0 ? void 0 : dataMarketplace.currentYield,
        sortByNextInterestPaymentDate
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,actions/* fetchCartItems */.Vw)({
            listCart: []
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsPageFullWidth, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_SubHeader, {
                listItem: sortByCurrentYield,
                dataUser: dataUser,
                account: account
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                maxWidth: "1280px",
                width: "100%",
                flexDirection: "column",
                mt: [
                    "1rem",
                    ,
                    ,
                    "4rem"
                ],
                height: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeaderSort, {}),
                    windowSize > 1000 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarketPlace_WrapperTable, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableMainTitle, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            width: "19%",
                                            bold: true,
                                            fontSize: "20px",
                                            textAlign: "center",
                                            children: t("Th\xf4ng tin CCQ")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            width: "45.5%",
                                            bold: true,
                                            fontSize: "20px",
                                            children: t("Lợi suất")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            width: "33.5%",
                                            bold: true,
                                            fontSize: "20px",
                                            children: t("Th\xf4ng tin giao dịch")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MarketPlace_WrapperItemHeader, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "SL"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Số lượng",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "Mệnh gi\xe1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Mệnh gi\xe1 (VND)",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "Kỳ đ\xe3 nhận"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Kỳ đ\xe3 nhận/tổng kỳ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "Kỳ trả LS"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Kỳ trả lợi suất",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "Ng\xe0y trả LS"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Ng\xe0y trả lợi suất kế tiếp",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItemSmall, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mr: "0.2rem",
                                                children: "Ng\xe0y c\xf2n lại"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "LSNCL"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Lợi suất ng\xe0y c\xf2n lại",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItemSmall, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "Đơn gi\xe1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Đơn gi\xe1 (VND)",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mr: "0.3rem",
                                                    children: "SL mua"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LightTooltip, {
                                                    title: "Số lượng mua",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCcq/* default */.Z, {}),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsItem, {})
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketPlace_Cart, {
                        listItem: filterDataAddress,
                        windowSize: windowSize,
                        listCart: listCart
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketPlace_Ccq, {
                        listItem: sortByCurrentYield,
                        windowSize: windowSize,
                        listCart: listCart
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketPlace_FooterTabs, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};
/* harmony default export */ var views_MarketPlace = (MarketPlace);
var MarketPlace_WrapperTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-52253bd6-0"
})(MarketPlace_templateObject());
var TableMainTitle = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-52253bd6-1"
})(MarketPlace_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.border2;
}, Text/* default */.Z);
var MarketPlace_WrapperItemHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-52253bd6-2"
})(MarketPlace_templateObject2(), Text/* default */.Z, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, CsItem, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CsPageFullWidth = (0,styled_components_browser_esm/* default */.ZP)(PageFullWidth/* default */.Z).withConfig({
    componentId: "sc-52253bd6-3"
})(MarketPlace_templateObject3());


/***/ }),

/***/ 79419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./1945.ts": [
		9002,
		9002
	],
	"./1975.ts": [
		53695,
		3695
	],
	"./56.ts": [
		66657,
		6657
	],
	"./97.ts": [
		77952,
		7952
	],
	"./index.ts": [
		88175
	],
	"./type.ts": [
		78128,
		8128
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 79419;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 89214:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85568:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 69386:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31616:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 29120:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46586:
/***/ (function() {

/* (ignored) */

/***/ })

}]);